var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgContactUs(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 257.04 243.08",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{isolation:isolate;}.cls-2{fill:url(#linear-gradient);}.cls-3{fill:url(#linear-gradient-2);}.cls-159,.cls-164,.cls-170,.cls-180,.cls-203,.cls-204,.cls-214,.cls-239,.cls-253,.cls-255,.cls-256,.cls-257,.cls-4,.cls-45,.cls-49{mix-blend-mode:multiply;}.cls-4{fill:url(#linear-gradient-3);}.cls-5,.cls-8{fill:#2af6ff;}.cls-6{fill:#25054d;}.cls-31,.cls-6,.cls-8{opacity:0;}.cls-7{fill:#6395ff;}.cls-9{fill:url(#linear-gradient-4);}.cls-10{fill:url(#linear-gradient-5);}.cls-11{fill:url(#linear-gradient-6);}.cls-12,.cls-13,.cls-14,.cls-15,.cls-16,.cls-162,.cls-167,.cls-172,.cls-175,.cls-179,.cls-182,.cls-185,.cls-187,.cls-190,.cls-193,.cls-196,.cls-199,.cls-202,.cls-206,.cls-209,.cls-213,.cls-215,.cls-218,.cls-223,.cls-228,.cls-233,.cls-238,.cls-244,.cls-245,.cls-248,.cls-252,.cls-26,.cls-52{mix-blend-mode:color-dodge;}.cls-12{fill:url(#radial-gradient);}.cls-13{fill:url(#radial-gradient-2);}.cls-14{fill:url(#radial-gradient-3);}.cls-15{fill:url(#radial-gradient-4);}.cls-16{fill:url(#radial-gradient-5);}.cls-17{fill:url(#linear-gradient-7);}.cls-18{fill:url(#linear-gradient-8);}.cls-19{fill:url(#linear-gradient-9);}.cls-20{fill:url(#linear-gradient-10);}.cls-21{fill:url(#linear-gradient-11);}.cls-22{fill:url(#linear-gradient-12);}.cls-23{fill:url(#linear-gradient-13);}.cls-24{fill:url(#linear-gradient-14);}.cls-25{fill:#e6e7e8;}.cls-25,.cls-258,.cls-51{mix-blend-mode:screen;}.cls-26{fill:url(#radial-gradient-6);}.cls-27{fill:url(#linear-gradient-15);}.cls-28{fill:url(#radial-gradient-7);}.cls-29{fill:url(#linear-gradient-16);}.cls-179,.cls-270,.cls-30{opacity:0.5;}.cls-255,.cls-256,.cls-257,.cls-31,.cls-32,.cls-33,.cls-34,.cls-35,.cls-36,.cls-37,.cls-38,.cls-39,.cls-40,.cls-41,.cls-42{fill:#afb6e5;}.cls-32{opacity:0.09;}.cls-33{opacity:0.18;}.cls-34{opacity:0.27;}.cls-35{opacity:0.36;}.cls-36{opacity:0.45;}.cls-37{opacity:0.55;}.cls-38{opacity:0.64;}.cls-39{opacity:0.73;}.cls-40{opacity:0.82;}.cls-41{opacity:0.91;}.cls-43{fill:url(#linear-gradient-17);}.cls-44{fill:url(#linear-gradient-18);}.cls-45{opacity:0.82;fill:url(#linear-gradient-19);}.cls-46{fill:#fff;}.cls-47{fill:url(#linear-gradient-20);}.cls-48{fill:url(#linear-gradient-21);}.cls-49{fill:#bcbec0;}.cls-50{fill:url(#linear-gradient-22);}.cls-51{fill:url(#radial-gradient-8);}.cls-53{fill:url(#linear-gradient-23);}.cls-54{fill:url(#linear-gradient-24);}.cls-55{fill:url(#linear-gradient-25);}.cls-56{fill:url(#linear-gradient-26);}.cls-57{fill:url(#linear-gradient-27);}.cls-58{fill:url(#linear-gradient-28);}.cls-59{fill:url(#linear-gradient-29);}.cls-60{fill:url(#linear-gradient-30);}.cls-61{fill:url(#linear-gradient-31);}.cls-62{fill:url(#linear-gradient-32);}.cls-63{fill:url(#linear-gradient-33);}.cls-64{fill:url(#linear-gradient-34);}.cls-65{fill:url(#linear-gradient-35);}.cls-66{fill:url(#linear-gradient-36);}.cls-67{fill:url(#linear-gradient-37);}.cls-68{fill:url(#linear-gradient-38);}.cls-69{fill:url(#linear-gradient-39);}.cls-70{fill:url(#linear-gradient-40);}.cls-71{fill:url(#linear-gradient-41);}.cls-72{fill:url(#linear-gradient-42);}.cls-73{fill:url(#linear-gradient-43);}.cls-74{fill:url(#linear-gradient-44);}.cls-75{fill:url(#linear-gradient-45);}.cls-76{fill:url(#linear-gradient-46);}.cls-77{fill:url(#linear-gradient-47);}.cls-78{fill:url(#linear-gradient-48);}.cls-79{fill:url(#linear-gradient-49);}.cls-80{fill:url(#linear-gradient-50);}.cls-81{fill:url(#linear-gradient-51);}.cls-82{fill:url(#linear-gradient-52);}.cls-83{fill:url(#linear-gradient-53);}.cls-84{fill:url(#linear-gradient-54);}.cls-85{fill:url(#linear-gradient-55);}.cls-86{fill:url(#linear-gradient-56);}.cls-87{fill:url(#linear-gradient-57);}.cls-88{fill:url(#linear-gradient-58);}.cls-89{fill:url(#linear-gradient-59);}.cls-90{fill:url(#linear-gradient-60);}.cls-91{fill:url(#linear-gradient-61);}.cls-92{fill:url(#linear-gradient-62);}.cls-93{fill:url(#linear-gradient-63);}.cls-94{fill:url(#linear-gradient-64);}.cls-95{fill:url(#linear-gradient-65);}.cls-96{fill:url(#linear-gradient-66);}.cls-97{fill:url(#linear-gradient-67);}.cls-98{fill:url(#linear-gradient-68);}.cls-99{fill:url(#linear-gradient-69);}.cls-100{fill:url(#linear-gradient-70);}.cls-101{fill:url(#linear-gradient-71);}.cls-102{fill:url(#linear-gradient-72);}.cls-103{fill:url(#linear-gradient-73);}.cls-104{fill:url(#linear-gradient-74);}.cls-105{fill:url(#linear-gradient-75);}.cls-106{fill:url(#linear-gradient-76);}.cls-107{fill:url(#linear-gradient-77);}.cls-108{fill:url(#linear-gradient-78);}.cls-109{fill:url(#linear-gradient-79);}.cls-110{fill:url(#linear-gradient-80);}.cls-111{fill:url(#linear-gradient-81);}.cls-112{fill:url(#linear-gradient-82);}.cls-113{fill:url(#linear-gradient-83);}.cls-114{fill:url(#linear-gradient-84);}.cls-115{fill:url(#linear-gradient-85);}.cls-116{fill:url(#linear-gradient-86);}.cls-117{fill:url(#linear-gradient-87);}.cls-118{fill:url(#linear-gradient-88);}.cls-119{fill:url(#linear-gradient-89);}.cls-120{fill:url(#linear-gradient-90);}.cls-121{fill:url(#linear-gradient-91);}.cls-122{fill:url(#linear-gradient-92);}.cls-123{fill:url(#linear-gradient-93);}.cls-124{fill:url(#linear-gradient-94);}.cls-125{fill:url(#linear-gradient-95);}.cls-126{fill:url(#linear-gradient-96);}.cls-127{fill:url(#linear-gradient-97);}.cls-128{fill:url(#radial-gradient-9);}.cls-129{fill:url(#radial-gradient-10);}.cls-130{fill:url(#radial-gradient-11);}.cls-131{fill:url(#radial-gradient-12);}.cls-132{fill:url(#radial-gradient-13);}.cls-133{fill:url(#radial-gradient-14);}.cls-134{fill:url(#radial-gradient-15);}.cls-135{fill:url(#radial-gradient-16);}.cls-136{fill:url(#radial-gradient-17);}.cls-137{fill:url(#radial-gradient-18);}.cls-138{fill:url(#radial-gradient-19);}.cls-139{fill:url(#radial-gradient-20);}.cls-140{fill:url(#radial-gradient-21);}.cls-141{fill:url(#radial-gradient-22);}.cls-142{fill:url(#radial-gradient-23);}.cls-143{fill:url(#radial-gradient-24);}.cls-144{fill:url(#radial-gradient-25);}.cls-145{fill:url(#radial-gradient-26);}.cls-146{fill:url(#radial-gradient-27);}.cls-147{fill:url(#radial-gradient-29);}.cls-148{fill:url(#radial-gradient-30);}.cls-149{fill:url(#radial-gradient-31);}.cls-150{fill:url(#radial-gradient-32);}.cls-151{fill:url(#radial-gradient-33);}.cls-152{fill:url(#radial-gradient-34);}.cls-153{fill:url(#radial-gradient-35);}.cls-154{fill:url(#radial-gradient-36);}.cls-155{fill:url(#radial-gradient-37);}.cls-156{fill:url(#radial-gradient-38);}.cls-157{fill:url(#radial-gradient-39);}.cls-158{fill:url(#radial-gradient-40);}.cls-159{fill:url(#radial-gradient-41);}.cls-160{fill:url(#linear-gradient-98);}.cls-161{fill:url(#linear-gradient-99);}.cls-162{fill:url(#radial-gradient-42);}.cls-163{fill:url(#linear-gradient-100);}.cls-164{fill:url(#linear-gradient-101);}.cls-165{fill:url(#linear-gradient-102);}.cls-166{fill:url(#linear-gradient-103);}.cls-167{fill:url(#radial-gradient-43);}.cls-168{fill:url(#linear-gradient-104);}.cls-169{fill:url(#linear-gradient-105);}.cls-170{fill:url(#linear-gradient-106);}.cls-171{fill:url(#linear-gradient-107);}.cls-172{fill:url(#radial-gradient-44);}.cls-173{fill:url(#radial-gradient-45);}.cls-174{fill:url(#linear-gradient-108);}.cls-175{fill:url(#radial-gradient-46);}.cls-176{fill:url(#radial-gradient-47);}.cls-177{fill:url(#radial-gradient-48);}.cls-178{fill:url(#linear-gradient-109);}.cls-179{fill:url(#radial-gradient-49);}.cls-180{opacity:0.1;}.cls-181{fill:url(#linear-gradient-110);}.cls-182{fill:url(#radial-gradient-50);}.cls-183{fill:url(#linear-gradient-111);}.cls-184{fill:url(#linear-gradient-112);}.cls-185{fill:url(#radial-gradient-51);}.cls-186{fill:url(#linear-gradient-113);}.cls-187{fill:url(#radial-gradient-52);}.cls-188{fill:url(#linear-gradient-114);}.cls-189{fill:url(#linear-gradient-115);}.cls-190{fill:url(#radial-gradient-53);}.cls-191{fill:url(#radial-gradient-54);}.cls-192{fill:url(#linear-gradient-116);}.cls-193{fill:url(#radial-gradient-55);}.cls-194{fill:url(#linear-gradient-117);}.cls-195{fill:url(#radial-gradient-56);}.cls-196{fill:url(#radial-gradient-57);}.cls-197{fill:url(#radial-gradient-58);}.cls-198{fill:url(#linear-gradient-118);}.cls-199{fill:url(#radial-gradient-59);}.cls-200{fill:url(#radial-gradient-60);}.cls-201{fill:url(#radial-gradient-61);}.cls-202{fill:url(#radial-gradient-62);}.cls-203{fill:url(#linear-gradient-119);}.cls-204{fill:url(#linear-gradient-120);}.cls-205{fill:url(#linear-gradient-121);}.cls-206{fill:url(#radial-gradient-63);}.cls-207{fill:url(#radial-gradient-64);}.cls-208{fill:url(#linear-gradient-122);}.cls-209{fill:url(#radial-gradient-65);}.cls-210{fill:url(#linear-gradient-123);}.cls-211{fill:url(#radial-gradient-66);}.cls-212{fill:url(#linear-gradient-124);}.cls-213{fill:url(#radial-gradient-67);}.cls-214{fill:url(#linear-gradient-125);}.cls-215{fill:url(#radial-gradient-68);}.cls-216{fill:url(#linear-gradient-126);}.cls-217{fill:url(#linear-gradient-127);}.cls-218{fill:url(#radial-gradient-69);}.cls-219{fill:url(#linear-gradient-128);}.cls-220{fill:url(#linear-gradient-129);}.cls-221{fill:url(#linear-gradient-130);}.cls-222{fill:url(#linear-gradient-131);}.cls-223{fill:url(#radial-gradient-70);}.cls-224{fill:url(#linear-gradient-132);}.cls-225{fill:url(#linear-gradient-133);}.cls-226{fill:url(#linear-gradient-134);}.cls-227{fill:url(#linear-gradient-135);}.cls-228{fill:url(#radial-gradient-71);}.cls-229{fill:url(#linear-gradient-136);}.cls-230{fill:url(#linear-gradient-137);}.cls-231{fill:url(#linear-gradient-138);}.cls-232{fill:url(#linear-gradient-139);}.cls-233{fill:url(#radial-gradient-72);}.cls-234{fill:url(#linear-gradient-140);}.cls-235{fill:url(#linear-gradient-141);}.cls-236{fill:url(#linear-gradient-142);}.cls-237{fill:url(#linear-gradient-143);}.cls-238{fill:url(#radial-gradient-73);}.cls-239{fill:url(#radial-gradient-74);}.cls-240{fill:url(#linear-gradient-144);}.cls-241{fill:url(#linear-gradient-145);}.cls-242{fill:#5a88e8;}.cls-243{fill:url(#linear-gradient-146);}.cls-244{fill:url(#radial-gradient-75);}.cls-245{fill:url(#radial-gradient-76);}.cls-246{fill:url(#linear-gradient-147);}.cls-247{fill:url(#linear-gradient-148);}.cls-248{fill:url(#radial-gradient-77);}.cls-249{fill:url(#linear-gradient-149);}.cls-250{fill:url(#linear-gradient-150);}.cls-251{fill:url(#linear-gradient-151);}.cls-252{fill:url(#radial-gradient-78);}.cls-253{fill:url(#radial-gradient-79);}.cls-254{fill:url(#radial-gradient-80);}.cls-255{opacity:0.4;}.cls-257{opacity:0.7;}.cls-259,.cls-260,.cls-261,.cls-262,.cls-263,.cls-264,.cls-265,.cls-266,.cls-267,.cls-268,.cls-269,.cls-270,.cls-271,.cls-272,.cls-273,.cls-274,.cls-275,.cls-276,.cls-277,.cls-278,.cls-279,.cls-280,.cls-281,.cls-282,.cls-283,.cls-284,.cls-285,.cls-286,.cls-287,.cls-288,.cls-289,.cls-290,.cls-291,.cls-292,.cls-294,.cls-295,.cls-296,.cls-297,.cls-298,.cls-299,.cls-300,.cls-301,.cls-302,.cls-303{fill:#e5e9ff;}.cls-259{opacity:0.02;}.cls-260{opacity:0.06;}.cls-261{opacity:0.11;}.cls-262{opacity:0.15;}.cls-263{opacity:0.19;}.cls-264{opacity:0.24;}.cls-265{opacity:0.28;}.cls-266{opacity:0.33;}.cls-267{opacity:0.37;}.cls-268{opacity:0.41;}.cls-269{opacity:0.46;}.cls-271{opacity:0.05;}.cls-272{opacity:0.09;}.cls-273{opacity:0.13;}.cls-274{opacity:0.17;}.cls-275{opacity:0.22;}.cls-276{opacity:0.26;}.cls-277{opacity:0.3;}.cls-278{opacity:0.34;}.cls-279{opacity:0.38;}.cls-280{opacity:0.42;}.cls-281{opacity:0.46;}.cls-282{opacity:0.05;}.cls-283{opacity:0.09;}.cls-284{opacity:0.13;}.cls-285{opacity:0.17;}.cls-286{opacity:0.21;}.cls-287{opacity:0.25;}.cls-288{opacity:0.3;}.cls-289{opacity:0.34;}.cls-290{opacity:0.38;}.cls-291{opacity:0.42;}.cls-292{opacity:0.46;}.cls-293{fill:url(#radial-gradient-81);}.cls-294{opacity:0.07;}.cls-295{opacity:0.1;}.cls-296{opacity:0.12;}.cls-297{opacity:0.14;}.cls-298{opacity:0.16;}.cls-299{opacity:0.19;}.cls-300{opacity:0.21;}.cls-301{opacity:0.23;}.cls-302{opacity:0.28;}.cls-303{opacity:0.3;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 520.89,
    y1: 157.52,
    x2: 558.56,
    y2: 219.09,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#afb6e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#b1b8e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#b9bfea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#c6ccf0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#d8ddf9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#e5e9ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#e1e5fd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#d3d8f7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#bec4ec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#afb6e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#b3bae7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#e5e9ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#e5e9ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 520.27,
    y1: 180.08,
    x2: 581.85,
    y2: 180.08,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#5a88e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#517ada"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#273b98"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 208.56,
    y1: 55.09,
    x2: 217.06,
    y2: 41.69,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 197.43,
    y1: 44.76,
    x2: 209.45,
    y2: 61.44,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 534.61,
    y1: 149.63,
    x2: 571.99,
    y2: 211.58,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#afb6e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#b5bbe8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#c4caef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#dee3fc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#e5e9ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#e3e7fe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#dce1fb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#d1d6f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#c0c6ed"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#afb6e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#b9bfe8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#d4d8f1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#f5f7ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#e5e9ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#dbdffa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#c3c9ee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#b4bbe7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#afb6e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#b1b8e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#b8bee9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#c3c9ef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#d4d9f7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#e5e9ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#e6e9f7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#c8cded"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#b6bce7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#afb6e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#b2b9e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#bbc1eb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#c9cff2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#dfe3fc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#e5e9ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 516.74,
    y1: 200.56,
    x2: 581.4,
    y2: 167.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#afb6e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#b6bce8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#c8cdf1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#e5e9ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#f5f4fc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f7f6fb"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 533.16,
    cy: 192.7,
    r: 12.98,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-2",
    cx: 547.46,
    cy: 163.24,
    r: 19.07,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-3",
    cx: 518.03,
    cy: 163.09,
    r: 3.67,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-4",
    cx: 1772.7,
    cy: -4235.48,
    r: 14.36,
    gradientTransform: "matrix(0.92, -0.38, 0.17, 0.42, -363.27, 2604.11)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#972a74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#8a266a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#601b4a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#3d112f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#230a1b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#0f040c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#040103"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-5",
    cx: 2262.86,
    cy: -7780.5,
    r: 10.15,
    gradientTransform: "matrix(0.87, -0.49, 0.16, 0.29, -160.4, 3536.7)",
    xlinkHref: "#radial-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: -626.42,
    y1: 209.75,
    x2: -612.45,
    y2: 205.57,
    gradientTransform: "translate(839.22 -113.32)",
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: -651.15,
    y1: 211.64,
    x2: -614.09,
    y2: 203.33,
    gradientTransform: "translate(839.22 -113.32)",
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 202.7,
    y1: 94.08,
    x2: 209.7,
    y2: 94.08,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: -625.93,
    y1: 191.93,
    x2: -631.98,
    y2: 203.46,
    gradientTransform: "translate(839.22 -113.32)",
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: -631.89,
    y1: 209.28,
    x2: -634.69,
    y2: 204.42,
    gradientTransform: "translate(1171.46)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#e5e9ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#eff2ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#f5f7ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#e5e9ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#dbdffa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#c3c9ee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#b4bbe7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#afb6e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#bac0ea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#d7dcf8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e5e9ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: -634.74,
    y1: 208.89,
    x2: -632.26,
    y2: 204.62,
    gradientTransform: "translate(1171.46)",
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: -633.11,
    y1: 209.52,
    x2: -635.51,
    y2: 205.35,
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: -635.75,
    y1: 209.3,
    x2: -633.62,
    y2: 205.64,
    gradientTransform: "translate(1171.46)",
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-6",
    cx: -634.22,
    cy: 207.43,
    r: 1.73,
    gradientTransform: "translate(1171.46)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 390.81,
    y1: 239.45,
    x2: 390.81,
    y2: 190.84,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#ffe4a7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#fac098"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#f49587"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#a142b5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#7c1dc9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#7926cb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#703ed1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#6165db"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#4c9ce9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#32e1fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2af6ff"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-7",
    cx: 458.75,
    cy: 270.14,
    r: 100.37,
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 7068.47,
    y1: 240.06,
    x2: 7068.47,
    y2: 207.84,
    gradientTransform: "matrix(-1, 0, 0, 1, 7579.33, 0)",
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 6255.01,
    y1: 206.69,
    x2: 6297.57,
    y2: 206.69,
    gradientTransform: "matrix(-1, 0, 0, 1, 6646.93, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#afb6e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#b1b8e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#b9bfea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#c6ccf0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#d8ddf9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#e5e9ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#e9edff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#f7f8ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#f9faff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#eaedff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#e5e9ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#dbdffa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#c3c9ee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#b4bbe7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#afb6e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#afb6e5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 6267.12,
    y1: 209.43,
    x2: 6286.41,
    y2: 198.76,
    gradientTransform: "matrix(-1, 0, 0, 1, 6646.93, 0)",
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: 6277.35,
    y1: 204.38,
    x2: 6281.14,
    y2: 198.03,
    gradientTransform: "matrix(-1, 0, 0, 1, 6646.93, 0)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: 434.43,
    y1: 117.75,
    x2: 330.11,
    y2: 208.37,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: 339.29,
    y1: 168.33,
    x2: 408.79,
    y2: 183.33,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: 6322.42,
    y1: 218.88,
    x2: 6271.16,
    y2: 136.97,
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-8",
    cx: 6308.02,
    cy: 168.61,
    r: 8.73,
    gradientTransform: "matrix(-1, 0, 0, 1, 6646.93, 0)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: 7248.61,
    y1: 160.33,
    x2: 7254.69,
    y2: 160.33,
    gradientTransform: "matrix(-1, 0, 0, 1, 7282.93, -113.32)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#99fbff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1bb0d4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: 7247.38,
    y1: 169.96,
    x2: 7253.44,
    y2: 169.96,
    xlinkHref: "#linear-gradient-23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: 7246.77,
    y1: 161.71,
    x2: 7252.02,
    y2: 161.71,
    xlinkHref: "#linear-gradient-23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    x1: 7240.54,
    y1: 162.52,
    x2: 7242.92,
    y2: 162.52,
    xlinkHref: "#linear-gradient-23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-27",
    x1: 7233.1,
    y1: 161.35,
    x2: 7236.96,
    y2: 161.35,
    xlinkHref: "#linear-gradient-23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-28",
    x1: 7248.86,
    y1: 167.98,
    x2: 7254.04,
    y2: 167.98,
    xlinkHref: "#linear-gradient-23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-29",
    x1: 7247.41,
    y1: 164.24,
    x2: 7251.25,
    y2: 164.24,
    xlinkHref: "#linear-gradient-23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-30",
    x1: 7255.93,
    y1: 163.03,
    x2: 7257,
    y2: 163.03,
    xlinkHref: "#linear-gradient-23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-31",
    x1: 7237.48,
    y1: 158.73,
    x2: 7241.47,
    y2: 158.73,
    xlinkHref: "#linear-gradient-23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-32",
    x1: 7253.26,
    y1: 165.55,
    x2: 7259.15,
    y2: 165.55,
    xlinkHref: "#linear-gradient-23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-33",
    x1: 7234.31,
    y1: 159.73,
    x2: 7239.32,
    y2: 159.73,
    xlinkHref: "#linear-gradient-23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-34",
    x1: 7235.51,
    y1: 152.34,
    x2: 7239.44,
    y2: 152.34,
    xlinkHref: "#linear-gradient-23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-35",
    x1: 7240.68,
    y1: 154.74,
    x2: 7242.67,
    y2: 154.74,
    xlinkHref: "#linear-gradient-23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-36",
    x1: 7238.2,
    y1: 163.73,
    x2: 7240.27,
    y2: 163.73,
    xlinkHref: "#linear-gradient-23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-37",
    x1: 7258.05,
    y1: 173.28,
    x2: 7263.4,
    y2: 173.28,
    xlinkHref: "#linear-gradient-23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-38",
    x1: 7229.97,
    y1: 159.02,
    x2: 7231.86,
    y2: 159.02,
    xlinkHref: "#linear-gradient-23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-39",
    x1: 7226.09,
    y1: 148.4,
    x2: 7234.51,
    y2: 148.4,
    xlinkHref: "#linear-gradient-23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-40",
    x1: 7259.29,
    y1: 170.44,
    x2: 7261.27,
    y2: 170.44,
    xlinkHref: "#linear-gradient-23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-41",
    x1: 7260.39,
    y1: 169.74,
    x2: 7266.66,
    y2: 169.74,
    xlinkHref: "#linear-gradient-23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-42",
    x1: 7252.49,
    y1: 167.57,
    x2: 7258.07,
    y2: 167.57,
    xlinkHref: "#linear-gradient-23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-43",
    x1: 7258.24,
    y1: 165.32,
    x2: 7262.68,
    y2: 165.32,
    xlinkHref: "#linear-gradient-23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-44",
    x1: 7226.16,
    y1: 155.77,
    x2: 7233.07,
    y2: 155.77,
    xlinkHref: "#linear-gradient-23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-45",
    x1: 7255.28,
    y1: 170.57,
    x2: 7256.83,
    y2: 170.57,
    xlinkHref: "#linear-gradient-23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-46",
    x1: 7229.97,
    y1: 155.1,
    x2: 7236.24,
    y2: 155.1,
    xlinkHref: "#linear-gradient-23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-47",
    x1: 7228.11,
    y1: 152.96,
    x2: 7239.54,
    y2: 152.96,
    xlinkHref: "#linear-gradient-23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-48",
    x1: 7248.61,
    y1: 173.51,
    x2: 7254.69,
    y2: 173.51,
    xlinkHref: "#linear-gradient-23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-49",
    x1: 7247.38,
    y1: 183.14,
    x2: 7253.44,
    y2: 183.14,
    xlinkHref: "#linear-gradient-23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-50",
    x1: 7246.77,
    y1: 174.89,
    x2: 7252.02,
    y2: 174.89,
    xlinkHref: "#linear-gradient-23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-51",
    x1: 7240.54,
    y1: 175.7,
    x2: 7242.92,
    y2: 175.7,
    xlinkHref: "#linear-gradient-23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-52",
    x1: 7233.1,
    y1: 174.53,
    x2: 7236.96,
    y2: 174.53,
    xlinkHref: "#linear-gradient-23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-53",
    x1: 7248.86,
    y1: 181.16,
    x2: 7254.04,
    y2: 181.16,
    xlinkHref: "#linear-gradient-23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-54",
    x1: 7247.41,
    y1: 177.42,
    x2: 7251.25,
    y2: 177.42,
    xlinkHref: "#linear-gradient-23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-55",
    x1: 7255.93,
    y1: 176.21,
    x2: 7257,
    y2: 176.21,
    xlinkHref: "#linear-gradient-23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-56",
    x1: 7237.48,
    y1: 171.91,
    x2: 7241.47,
    y2: 171.91,
    xlinkHref: "#linear-gradient-23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-57",
    x1: 7253.26,
    y1: 178.73,
    x2: 7259.15,
    y2: 178.73,
    xlinkHref: "#linear-gradient-23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-58",
    x1: 7234.31,
    y1: 172.91,
    x2: 7239.32,
    y2: 172.91,
    xlinkHref: "#linear-gradient-23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-59",
    x1: 7235.51,
    y1: 165.52,
    x2: 7239.44,
    y2: 165.52,
    xlinkHref: "#linear-gradient-23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-60",
    x1: 7240.68,
    y1: 167.92,
    x2: 7242.67,
    y2: 167.92,
    xlinkHref: "#linear-gradient-23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-61",
    x1: 7238.2,
    y1: 176.91,
    x2: 7240.27,
    y2: 176.91,
    xlinkHref: "#linear-gradient-23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-62",
    x1: 7258.05,
    y1: 186.46,
    x2: 7263.4,
    y2: 186.46,
    xlinkHref: "#linear-gradient-23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-63",
    x1: 7229.97,
    y1: 172.2,
    x2: 7231.86,
    y2: 172.2,
    xlinkHref: "#linear-gradient-23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-64",
    x1: 7226.09,
    y1: 161.58,
    x2: 7234.51,
    y2: 161.58,
    xlinkHref: "#linear-gradient-23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-65",
    x1: 7259.29,
    y1: 183.62,
    x2: 7261.27,
    y2: 183.62,
    xlinkHref: "#linear-gradient-23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-66",
    x1: 7260.39,
    y1: 182.92,
    x2: 7266.66,
    y2: 182.92,
    xlinkHref: "#linear-gradient-23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-67",
    x1: 7252.49,
    y1: 180.75,
    x2: 7258.07,
    y2: 180.75,
    xlinkHref: "#linear-gradient-23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-68",
    x1: 7258.24,
    y1: 178.5,
    x2: 7262.68,
    y2: 178.5,
    xlinkHref: "#linear-gradient-23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-69",
    x1: 7226.16,
    y1: 168.95,
    x2: 7233.07,
    y2: 168.95,
    xlinkHref: "#linear-gradient-23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-70",
    x1: 7255.28,
    y1: 183.75,
    x2: 7256.83,
    y2: 183.75,
    xlinkHref: "#linear-gradient-23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-71",
    x1: 7229.97,
    y1: 168.28,
    x2: 7236.24,
    y2: 168.28,
    xlinkHref: "#linear-gradient-23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-72",
    x1: 7228.11,
    y1: 166.14,
    x2: 7239.54,
    y2: 166.14,
    xlinkHref: "#linear-gradient-23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-73",
    x1: 7248.61,
    y1: 186.88,
    x2: 7254.69,
    y2: 186.88,
    xlinkHref: "#linear-gradient-23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-74",
    x1: 7247.38,
    y1: 196.5,
    x2: 7253.44,
    y2: 196.5,
    xlinkHref: "#linear-gradient-23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-75",
    x1: 7246.77,
    y1: 188.26,
    x2: 7252.02,
    y2: 188.26,
    xlinkHref: "#linear-gradient-23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-76",
    x1: 7240.54,
    y1: 189.07,
    x2: 7242.92,
    y2: 189.07,
    xlinkHref: "#linear-gradient-23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-77",
    x1: 7233.1,
    y1: 187.9,
    x2: 7236.96,
    y2: 187.9,
    xlinkHref: "#linear-gradient-23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-78",
    x1: 7248.86,
    y1: 194.53,
    x2: 7254.04,
    y2: 194.53,
    xlinkHref: "#linear-gradient-23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-79",
    x1: 7247.41,
    y1: 190.79,
    x2: 7251.25,
    y2: 190.79,
    xlinkHref: "#linear-gradient-23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-80",
    x1: 7255.93,
    y1: 189.57,
    x2: 7257,
    y2: 189.57,
    xlinkHref: "#linear-gradient-23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-81",
    x1: 7237.48,
    y1: 185.28,
    x2: 7241.47,
    y2: 185.28,
    xlinkHref: "#linear-gradient-23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-82",
    x1: 7253.26,
    y1: 192.09,
    x2: 7259.15,
    y2: 192.09,
    xlinkHref: "#linear-gradient-23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-83",
    x1: 7234.31,
    y1: 186.27,
    x2: 7239.32,
    y2: 186.27,
    xlinkHref: "#linear-gradient-23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-84",
    x1: 7235.51,
    y1: 178.88,
    x2: 7239.44,
    y2: 178.88,
    xlinkHref: "#linear-gradient-23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-85",
    x1: 7240.68,
    y1: 181.29,
    x2: 7242.67,
    y2: 181.29,
    xlinkHref: "#linear-gradient-23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-86",
    x1: 7238.2,
    y1: 190.28,
    x2: 7240.27,
    y2: 190.28,
    xlinkHref: "#linear-gradient-23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-87",
    x1: 7258.05,
    y1: 199.83,
    x2: 7263.4,
    y2: 199.83,
    xlinkHref: "#linear-gradient-23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-88",
    x1: 7229.97,
    y1: 185.56,
    x2: 7231.86,
    y2: 185.56,
    xlinkHref: "#linear-gradient-23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-89",
    x1: 7226.09,
    y1: 174.95,
    x2: 7234.51,
    y2: 174.95,
    xlinkHref: "#linear-gradient-23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-90",
    x1: 7259.29,
    y1: 196.98,
    x2: 7261.27,
    y2: 196.98,
    xlinkHref: "#linear-gradient-23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-91",
    x1: 7260.39,
    y1: 196.28,
    x2: 7266.66,
    y2: 196.28,
    xlinkHref: "#linear-gradient-23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-92",
    x1: 7252.49,
    y1: 194.11,
    x2: 7258.07,
    y2: 194.11,
    xlinkHref: "#linear-gradient-23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-93",
    x1: 7258.24,
    y1: 191.86,
    x2: 7262.68,
    y2: 191.86,
    xlinkHref: "#linear-gradient-23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-94",
    x1: 7226.16,
    y1: 182.32,
    x2: 7233.07,
    y2: 182.32,
    xlinkHref: "#linear-gradient-23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-95",
    x1: 7255.28,
    y1: 197.12,
    x2: 7256.83,
    y2: 197.12,
    xlinkHref: "#linear-gradient-23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-96",
    x1: 7229.97,
    y1: 181.65,
    x2: 7236.24,
    y2: 181.65,
    xlinkHref: "#linear-gradient-23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-97",
    x1: 7228.11,
    y1: 179.51,
    x2: 7239.54,
    y2: 179.51,
    xlinkHref: "#linear-gradient-23"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-9",
    cx: 463.72,
    cy: 258.82,
    r: 106.36,
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-10",
    cx: 463.72,
    cy: 258.82,
    r: 106.36,
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-11",
    cx: 463.72,
    cy: 258.82,
    r: 106.36,
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-12",
    cx: 463.72,
    cy: 258.82,
    r: 106.36,
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-13",
    cx: 463.72,
    cy: 258.82,
    r: 106.36,
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-14",
    cx: 463.72,
    cy: 258.82,
    r: 106.36,
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-15",
    cx: 463.72,
    cy: 258.82,
    r: 106.36,
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-16",
    cx: 463.72,
    cy: 258.82,
    r: 106.36,
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-17",
    cx: 463.72,
    cy: 258.82,
    r: 106.36,
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-18",
    cx: 463.72,
    cy: 258.82,
    r: 106.36,
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-19",
    cx: 463.72,
    cy: 258.82,
    r: 106.36,
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-20",
    cx: 463.72,
    cy: 258.82,
    r: 106.36,
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-21",
    cx: 463.72,
    cy: 258.82,
    r: 106.36,
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-22",
    cx: 463.72,
    cy: 258.82,
    r: 106.36,
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-23",
    cx: 131.48,
    cy: 145.49,
    r: 106.36,
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-24",
    cx: 131.48,
    cy: 145.49,
    r: 106.36,
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-25",
    cx: 131.48,
    cy: 145.49,
    r: 106.36,
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-26",
    cx: 131.48,
    cy: 145.49,
    r: 106.36,
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-27",
    cx: 131.48,
    cy: 145.49,
    r: 106.36,
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-29",
    cx: 131.48,
    cy: 145.49,
    r: 106.36,
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-30",
    cx: 463.72,
    cy: 258.82,
    r: 106.36,
    gradientTransform: "translate(510.41 -293.02) rotate(59.77)",
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-31",
    cx: 131.48,
    cy: 145.49,
    r: 106.36,
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-32",
    cx: 131.48,
    cy: 145.49,
    r: 106.36,
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-33",
    cx: 131.48,
    cy: 145.49,
    r: 106.36,
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-34",
    cx: 131.48,
    cy: 145.49,
    r: 106.36,
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-35",
    cx: 463.72,
    cy: 258.82,
    r: 106.36,
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-36",
    cx: 131.48,
    cy: 145.49,
    r: 106.36,
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-37",
    cx: 131.48,
    cy: 145.49,
    r: 106.36,
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-38",
    cx: 463.72,
    cy: 258.82,
    r: 106.36,
    gradientTransform: "translate(206.51 -168.04) rotate(30.37)",
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-39",
    cx: 131.48,
    cy: 145.49,
    r: 106.36,
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-40",
    cx: 131.48,
    cy: 145.49,
    r: 106.36,
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-41",
    cx: 1249.45,
    cy: -2737.66,
    r: 41.69,
    gradientTransform: "translate(-1345.31 1997.24) scale(1.18 0.67)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#afb6e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-98",
    x1: 413.87,
    y1: 264.09,
    x2: 502.89,
    y2: 264.09,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#afb6e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#b2b9e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#bbc1eb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#c9cff2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#dfe3fc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#e5e9ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#eff2ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#ebedf9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#b9bfe8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#afb6e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#afb6e5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-99",
    x1: 478.38,
    y1: 204.68,
    x2: 447.75,
    y2: 283.73,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#afb6e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#b6bce8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#c8cdf1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#e5e9ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#f5f6ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-42",
    cx: 458.38,
    cy: 269.15,
    r: 32.82,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-100",
    x1: 480.82,
    y1: 260.56,
    x2: 553.54,
    y2: 260.56,
    gradientTransform: "translate(-54.82)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e7888e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#f5bf9d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#ffe4a7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#fac098"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#f49587"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#7c1dc9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#7926cb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#703ed1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#6165db"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#4c9ce9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#32e1fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2af6ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-101",
    x1: 458.17,
    y1: 269.35,
    x2: 458.17,
    y2: 241.54,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#afb6e5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-102",
    x1: 473.68,
    y1: 244.9,
    x2: 551.81,
    y2: 244.9,
    gradientTransform: "translate(-54.82)",
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-103",
    x1: 5197.28,
    y1: 178.08,
    x2: 5260.16,
    y2: 245.5,
    gradientTransform: "matrix(-1, 0, 0, 1, 5369.81, -113.32)",
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-43",
    cx: 445.43,
    cy: 247.98,
    r: 29.27,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-104",
    x1: 5215.9,
    y1: 198.95,
    x2: 5263.06,
    y2: 249.52,
    gradientTransform: "matrix(-1, 0, 0, 1, 5369.81, -113.32)",
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-105",
    x1: 105.66,
    y1: 135.1,
    x2: 181.66,
    y2: 62.1,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-106",
    x1: 428.51,
    y1: 195.55,
    x2: 468.36,
    y2: 238.28,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-107",
    x1: 252.52,
    y1: 604.24,
    x2: 241.85,
    y2: 605.78,
    gradientTransform: "matrix(0.99, 0.12, -0.12, 0.99, 303.07, -447.72)",
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-44",
    cx: 246.89,
    cy: 606.88,
    r: 9.58,
    gradientTransform: "matrix(0.99, 0.12, -0.12, 0.99, 303.07, -447.72)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#972a74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#8c276c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#671d4f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#471437"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#2d0d23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#190713"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#0b0308"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#020102"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-45",
    cx: 247.78,
    cy: 596.62,
    r: 3.24,
    gradientTransform: "matrix(0.99, 0.12, -0.12, 0.99, 303.07, -447.72)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#5d6fbc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#273b98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#12054e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#10054d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-108",
    x1: 251.67,
    y1: 584.79,
    x2: 236.28,
    y2: 588.39,
    gradientTransform: "matrix(0.99, 0.12, -0.12, 0.99, 303.07, -447.72)",
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-46",
    cx: -1823.59,
    cy: 350.72,
    r: 8.77,
    gradientTransform: "matrix(0.41, -0.01, 0.02, 1, 1219.23, -201.24)",
    xlinkHref: "#radial-gradient-44"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-47",
    cx: 491.7,
    cy: 4198.88,
    r: 2.31,
    gradientTransform: "matrix(0.48, 0.88, -0.88, 0.48, 3929.16, -2280.05)",
    xlinkHref: "#radial-gradient-45"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-48",
    cx: 330.68,
    cy: 3707.6,
    r: 3.78,
    gradientTransform: "matrix(0.59, 0.81, -0.81, 0.59, 3276.62, -2307.85)",
    xlinkHref: "#radial-gradient-45"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-109",
    x1: 51.95,
    y1: 3344.51,
    x2: 47.79,
    y2: 3351.24,
    gradientTransform: "matrix(0.66, 0.75, -0.75, 0.66, 2953.61, -2101.47)",
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-49",
    cx: 75.66,
    cy: 4629.35,
    r: 7.33,
    gradientTransform: "matrix(0.54, 0.78, -0.59, 0.41, 3156.07, -1817.31)",
    xlinkHref: "#radial-gradient-44"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-110",
    x1: 473.39,
    y1: 218.16,
    x2: 457.05,
    y2: 233.62,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-50",
    cx: 467.7,
    cy: 223.56,
    r: 6.36,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#radial-gradient-44"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-111",
    x1: 463.31,
    y1: 209.26,
    x2: 458.58,
    y2: 209.55,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#radial-gradient-45"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-112",
    x1: 468.81,
    y1: 209.33,
    x2: 456.21,
    y2: 206.3,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-51",
    cx: -1670.12,
    cy: -2528.14,
    r: 7.88,
    gradientTransform: "matrix(0.61, 0.04, -0.1, 1.54, 1233.15, 4165.81)",
    xlinkHref: "#radial-gradient-44"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-113",
    x1: 460.09,
    y1: 229.53,
    x2: 444.73,
    y2: 235.14,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-52",
    cx: 455.33,
    cy: 231.27,
    r: 6.68,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#radial-gradient-44"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-114",
    x1: 454.09,
    y1: 214.98,
    x2: 449.65,
    y2: 214.91,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#radial-gradient-45"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-115",
    x1: 456.83,
    y1: 214.33,
    x2: 443.93,
    y2: 213.47,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-53",
    cx: -2643.6,
    cy: -3099.13,
    r: 6.08,
    gradientTransform: "matrix(0.51, 0.01, -0.03, 1.31, 1706.5, 4293.79)",
    xlinkHref: "#radial-gradient-44"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-54",
    cx: 466.11,
    cy: 197.54,
    r: 2.89,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#radial-gradient-45"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-116",
    x1: 472.11,
    y1: 177.62,
    x2: 455.13,
    y2: 180.68,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-55",
    cx: -1711,
    cy: -2472.86,
    r: 12.85,
    gradientTransform: "translate(1482.53 3847.58) scale(0.59 1.48)",
    xlinkHref: "#radial-gradient-44"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-117",
    x1: 467.97,
    y1: 162.09,
    x2: 450.03,
    y2: 163.78,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#radial-gradient-45"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-56",
    cx: 470.24,
    cy: 139.25,
    r: 33.55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#eef1ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#e5e9ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#d5daf7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#afb6e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#b3bae7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#bec4ec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#d1d6f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#e5e9ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#e2e6fe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#d9def9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#cbd0f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b5bce8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#afb6e5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-57",
    cx: 464.63,
    cy: 149.83,
    r: 13.3,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#radial-gradient-44"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-58",
    cx: 454.72,
    cy: 203.82,
    r: 2.89,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#radial-gradient-45"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-118",
    x1: 461.05,
    y1: 183.56,
    x2: 443.48,
    y2: 185.07,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-59",
    cx: -384.96,
    cy: -1167.03,
    r: 12.63,
    gradientTransform: "translate(709.44 1583.32) scale(0.66 1.2)",
    xlinkHref: "#radial-gradient-44"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-60",
    cx: 461.32,
    cy: 124.12,
    r: 12.73,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#radial-gradient-45"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-61",
    cx: 467.77,
    cy: 118.5,
    r: 18.45,
    xlinkHref: "#radial-gradient-56"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-62",
    cx: 464.94,
    cy: 121.95,
    r: 6.44,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#radial-gradient-44"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-119",
    x1: 457.37,
    y1: 146.52,
    x2: 456.56,
    y2: 162.18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e5e9ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-120",
    x1: 470.93,
    y1: 152.93,
    x2: 445.67,
    y2: 151.16,
    xlinkHref: "#linear-gradient-101"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-121",
    x1: 320.66,
    y1: 491.81,
    x2: 307.78,
    y2: 496.65,
    gradientTransform: "translate(160.55 -320.79) rotate(3.61)",
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-63",
    cx: 317.59,
    cy: 494.92,
    r: 7.07,
    gradientTransform: "translate(160.55 -320.79) rotate(3.61)",
    xlinkHref: "#radial-gradient-44"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-64",
    cx: 508.38,
    cy: 15.98,
    r: 1.78,
    gradientTransform: "translate(-66.21 210.72) rotate(-4.73)",
    xlinkHref: "#radial-gradient-45"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-122",
    x1: 512.52,
    y1: -101.59,
    x2: 501.86,
    y2: -102.46,
    gradientTransform: "matrix(1, -0.08, 0.08, 0.93, -57.73, 310.14)",
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-65",
    cx: -410.47,
    cy: -2995.78,
    r: 5.63,
    gradientTransform: "matrix(0.77, -0.06, 0.12, 1.44, 1113.62, 4460.42)",
    xlinkHref: "#radial-gradient-44"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-123",
    x1: 799.97,
    y1: -453.01,
    x2: 793.79,
    y2: -455.7,
    gradientTransform: "translate(-245.4 753.75) rotate(-11.6)",
    xlinkHref: "#radial-gradient-45"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-66",
    cx: 158.14,
    cy: 1001.39,
    r: 2.31,
    gradientTransform: "translate(509.11 -850) rotate(12.83)",
    xlinkHref: "#radial-gradient-45"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-124",
    x1: 393.33,
    y1: 222.87,
    x2: 383.47,
    y2: 220.53,
    gradientTransform: "translate(54 -69.12) rotate(0.06)",
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-67",
    cx: -799.16,
    cy: 460.81,
    r: 5.84,
    gradientTransform: "matrix(0.75, 0.05, -0.08, 1.04, 1082.31, -289.05)",
    xlinkHref: "#radial-gradient-44"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-125",
    x1: 462,
    y1: 122.83,
    x2: 452.84,
    y2: 124.45,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b086cc"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-68",
    cx: -2593.19,
    cy: 262.94,
    r: 27.75,
    gradientTransform: "translate(1460.51 -113.32) scale(0.52 1)",
    xlinkHref: "#radial-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-126",
    x1: 578.74,
    y1: 345.14,
    x2: 628.53,
    y2: 345.14,
    gradientTransform: "translate(-54.82)",
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-127",
    x1: 5123.37,
    y1: 302.12,
    x2: 5163.45,
    y2: 345.09,
    gradientTransform: "matrix(-1, 0, 0, 1, 5369.81, -113.32)",
    xlinkHref: "#linear-gradient-99"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-69",
    cx: 540.86,
    cy: 346.67,
    r: 18.66,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-128",
    x1: 525.42,
    y1: 336.22,
    x2: 572.53,
    y2: 336.22,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-129",
    x1: 580.46,
    y1: 335.1,
    x2: 626.83,
    y2: 335.1,
    gradientTransform: "translate(-54.82)",
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-130",
    x1: 578.74,
    y1: 331.29,
    x2: 628.53,
    y2: 331.29,
    gradientTransform: "translate(-54.82)",
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-131",
    x1: 5123.37,
    y1: 288.27,
    x2: 5163.45,
    y2: 331.25,
    gradientTransform: "matrix(-1, 0, 0, 1, 5369.81, -113.32)",
    xlinkHref: "#linear-gradient-99"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-70",
    cx: 540.86,
    cy: 332.82,
    r: 18.66,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-132",
    x1: 525.42,
    y1: 322.37,
    x2: 572.53,
    y2: 322.37,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-133",
    x1: 580.46,
    y1: 321.26,
    x2: 626.83,
    y2: 321.26,
    gradientTransform: "translate(-54.82)",
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-134",
    x1: 578.74,
    y1: 317.83,
    x2: 628.53,
    y2: 317.83,
    gradientTransform: "translate(-54.82)",
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-135",
    x1: 5123.37,
    y1: 274.81,
    x2: 5163.45,
    y2: 317.79,
    gradientTransform: "matrix(-1, 0, 0, 1, 5369.81, -113.32)",
    xlinkHref: "#linear-gradient-99"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-71",
    cx: 540.86,
    cy: 319.36,
    r: 18.66,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-136",
    x1: 525.42,
    y1: 308.91,
    x2: 572.53,
    y2: 308.91,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-137",
    x1: 580.46,
    y1: 307.8,
    x2: 626.83,
    y2: 307.8,
    gradientTransform: "translate(-54.82)",
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-138",
    x1: 578.74,
    y1: 304.22,
    x2: 628.53,
    y2: 304.22,
    gradientTransform: "translate(-54.82)",
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-139",
    x1: 5123.37,
    y1: 261.2,
    x2: 5163.45,
    y2: 304.18,
    gradientTransform: "matrix(-1, 0, 0, 1, 5369.81, -113.32)",
    xlinkHref: "#linear-gradient-99"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-72",
    cx: 540.86,
    cy: 305.76,
    r: 18.66,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-140",
    x1: 525.42,
    y1: 295.31,
    x2: 572.53,
    y2: 295.31,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-141",
    x1: 580.46,
    y1: 294.19,
    x2: 626.83,
    y2: 294.19,
    gradientTransform: "translate(-54.82)",
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-142",
    x1: 578.74,
    y1: 290.62,
    x2: 628.53,
    y2: 290.62,
    gradientTransform: "translate(-54.82)",
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-143",
    x1: 5123.37,
    y1: 247.6,
    x2: 5163.45,
    y2: 290.57,
    gradientTransform: "matrix(-1, 0, 0, 1, 5369.81, -113.32)",
    xlinkHref: "#linear-gradient-99"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-73",
    cx: 540.86,
    cy: 292.15,
    r: 18.66,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-74",
    cx: 1324.28,
    cy: -3161.14,
    r: 10.84,
    gradientTransform: "translate(-1345.31 2068.71) scale(1.18 0.6)",
    xlinkHref: "#radial-gradient-41"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-144",
    x1: 593.77,
    y1: 279.52,
    x2: 613.7,
    y2: 279.52,
    gradientTransform: "translate(-54.82)",
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-145",
    x1: 5141.19,
    y1: 261.86,
    x2: 5157.23,
    y2: 279.06,
    gradientTransform: "matrix(-1, 0, 0, 1, 5369.81, -113.32)",
    xlinkHref: "#linear-gradient-99"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-146",
    x1: 556.38,
    y1: 273.66,
    x2: 540.73,
    y2: 273.66,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-75",
    cx: 545.73,
    cy: 279.69,
    r: 7.47,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-76",
    cx: -5525.47,
    cy: 689.51,
    r: 27.75,
    gradientTransform: "translate(2144.88 -639.92) scale(0.35 1.23)",
    xlinkHref: "#radial-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-147",
    x1: 387.42,
    y1: 335.3,
    x2: 459.57,
    y2: 335.3,
    gradientTransform: "translate(-54.82)",
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-148",
    x1: 5290.1,
    y1: 275.24,
    x2: 5348.18,
    y2: 337.52,
    gradientTransform: "matrix(-1, 0, 0, 1, 5369.81, -113.32)",
    xlinkHref: "#linear-gradient-99"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-77",
    cx: 357.14,
    cy: 339.8,
    r: 27.04,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-149",
    x1: 390.21,
    y1: 325.93,
    x2: 456.82,
    y2: 325.93,
    gradientTransform: "translate(-54.82)",
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-150",
    x1: 5293.41,
    y1: 269.07,
    x2: 5347.03,
    y2: 326.56,
    gradientTransform: "matrix(-1, 0, 0, 1, 5369.81, -113.32)",
    xlinkHref: "#linear-gradient-99"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-151",
    x1: -25.43,
    y1: 221.87,
    x2: 85.94,
    y2: 179.69,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-78",
    cx: 358.04,
    cy: 328.67,
    r: 24.96,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-79",
    cx: 1172.82,
    cy: -3392.96,
    r: 25.79,
    gradientTransform: "translate(-1345.31 2112.04) scale(1.18 0.56)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#5761ad"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-80",
    cx: 367.26,
    cy: 302.17,
    r: 25.54,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#e5e9ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#dde1fb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#c6ccf0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#afb6e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#a5b1df"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#8ba3ce"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#819ec7"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-81",
    cx: 370.73,
    cy: 297.84,
    r: 29.81,
    xlinkHref: "#radial-gradient-80"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M562,192.4a8.78,8.78,0,0,0-3.75-1.25c0-.08,0-.15,0-.23,0-11.35-8-25.17-17.9-30.88-8-4.59-14.68-2.52-17,4.36a18,18,0,0,0-1.86-1.27c-6.52-3.76-11.81-.75-11.81,6.73s5.29,16.6,11.81,20.36L562,213.62c5.11,2.95,9.25.59,9.25-5.27S567.09,195.35,562,192.4Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M572.6,186.24a8.66,8.66,0,0,0-3.75-1.24c0-.08,0-.16,0-.24,0-11.34-8-25.17-17.9-30.88-8-4.59-14.68-2.52-17,4.36a17,17,0,0,0-1.87-1.26c-6.52-3.77-11.8-.76-11.8,6.73s5.28,16.59,11.8,20.36l40.53,23.39c5.11,2.95,9.25.59,9.25-5.27S577.71,189.19,572.6,186.24Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "193.01 45.23 225.35 62.99 225.05 45.08 199.71 41.15 193.01 45.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "212.71 53.27 214.01 54.03 214.01 52.53 212.71 51.78 212.71 53.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "210.26 51.86 211.56 52.61 211.56 51.12 210.26 50.37 210.26 51.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "207.81 50.45 209.12 51.2 209.12 49.7 207.81 48.95 207.81 50.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "205.37 49.03 206.67 49.79 206.67 48.29 205.37 47.54 205.37 49.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "202.92 47.62 204.22 48.37 204.22 46.88 202.92 46.13 202.92 47.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "200.47 46.21 201.77 46.96 201.77 45.47 200.47 44.71 200.47 46.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "198.02 44.8 199.32 45.55 199.32 44.05 198.02 43.3 198.02 44.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "195.57 43.38 196.88 44.13 196.88 42.64 195.57 41.89 195.57 43.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "193.13 41.97 194.43 42.72 194.43 41.23 193.13 40.47 193.13 41.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "190.68 40.55 191.98 41.31 191.98 39.81 190.68 39.06 190.68 40.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "188.23 39.14 189.53 39.89 189.53 38.4 188.23 37.65 188.23 39.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "185.78 37.73 187.08 38.48 187.08 36.98 185.78 36.23 185.78 37.73"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "212.71 55.93 214.01 56.69 214.01 55.19 212.71 54.44 212.71 55.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "210.26 54.52 211.56 55.27 211.56 53.78 210.26 53.02 210.26 54.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "207.81 53.11 209.12 53.86 209.12 52.36 207.81 51.61 207.81 53.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "205.37 51.69 206.67 52.45 206.67 50.95 205.37 50.2 205.37 51.69"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "202.92 50.28 204.22 51.03 204.22 49.54 202.92 48.78 202.92 50.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "200.47 48.87 201.77 49.62 201.77 48.12 200.47 47.37 200.47 48.87"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "198.02 47.45 199.32 48.2 199.32 46.71 198.02 45.96 198.02 47.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "195.57 46.04 196.88 46.79 196.88 45.3 195.57 44.54 195.57 46.04"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "193.13 44.63 194.43 45.38 194.43 43.88 193.13 43.13 193.13 44.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "212.71 58.57 214.01 59.32 214.01 57.83 212.71 57.07 212.71 58.57"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "210.26 57.16 211.56 57.91 211.56 56.41 210.26 55.66 210.26 57.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "207.81 55.74 209.12 56.49 209.12 55 207.81 54.25 207.81 55.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "205.37 54.33 206.67 55.08 206.67 53.59 205.37 52.83 205.37 54.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "202.92 52.92 204.22 53.67 204.22 52.17 202.92 51.42 202.92 52.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "200.47 51.5 201.77 52.26 201.77 50.76 200.47 50.01 200.47 51.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "198.02 50.09 199.32 50.84 199.32 49.35 198.02 48.59 198.02 50.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "195.57 48.68 196.88 49.43 196.88 47.93 195.57 47.18 195.57 48.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "193.13 47.26 194.43 48.02 194.43 46.52 193.13 45.77 193.13 47.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "190.68 45.85 191.98 46.6 191.98 45.11 190.68 44.35 190.68 45.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "185.78 43.02 187.08 43.77 187.08 42.28 185.78 41.53 185.78 43.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "212.71 61.23 214.01 61.98 214.01 60.48 212.71 59.73 212.71 61.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "210.26 59.81 211.56 60.57 211.56 59.07 210.26 58.32 210.26 59.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "207.81 58.4 209.12 59.15 209.12 57.66 207.81 56.91 207.81 58.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "205.37 56.99 206.67 57.74 206.67 56.24 205.37 55.49 205.37 56.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "202.92 55.57 204.22 56.33 204.22 54.83 202.92 54.08 202.92 55.57"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "200.47 54.16 201.77 54.91 201.77 53.42 200.47 52.66 200.47 54.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "198.02 52.75 199.32 53.5 199.32 52 198.02 51.25 198.02 52.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "195.57 51.33 196.88 52.09 196.88 50.59 195.57 49.84 195.57 51.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "193.13 49.92 194.43 50.67 194.43 49.18 193.13 48.42 193.13 49.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "190.68 48.51 191.98 49.26 191.98 47.76 190.68 47.01 190.68 48.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "188.23 47.09 189.53 47.85 189.53 46.35 188.23 45.6 188.23 47.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "185.78 45.68 187.08 46.43 187.08 44.94 185.78 44.19 185.78 45.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "212.71 63.84 214.01 64.6 214.01 63.1 212.71 62.35 212.71 63.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "210.26 62.43 211.56 63.18 211.56 61.69 210.26 60.94 210.26 62.43"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "207.81 61.02 209.12 61.77 209.12 60.28 207.81 59.52 207.81 61.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "205.37 59.6 206.67 60.36 206.67 58.86 205.37 58.11 205.37 59.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "202.92 58.19 204.22 58.94 204.22 57.45 202.92 56.7 202.92 58.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "200.47 56.78 201.77 57.53 201.77 56.04 200.47 55.28 200.47 56.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "198.02 55.37 199.32 56.12 199.32 54.62 198.02 53.87 198.02 55.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "195.57 53.95 196.88 54.7 196.88 53.21 195.57 52.46 195.57 53.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "193.13 52.54 194.43 53.29 194.43 51.8 193.13 51.04 193.13 52.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "190.68 51.13 191.98 51.88 191.98 50.38 190.68 49.63 190.68 51.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "188.23 49.71 189.53 50.46 189.53 48.97 188.23 48.22 188.23 49.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "185.78 48.3 187.08 49.05 187.08 47.56 185.78 46.8 185.78 48.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "212.71 66.5 214.01 67.25 214.01 65.76 212.71 65.01 212.71 66.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "210.26 65.09 211.56 65.84 211.56 64.35 210.26 63.59 210.26 65.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "207.81 63.68 209.12 64.43 209.12 62.93 207.81 62.18 207.81 63.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "205.37 62.26 206.67 63.02 206.67 61.52 205.37 60.77 205.37 62.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "202.92 60.85 204.22 61.6 204.22 60.11 202.92 59.35 202.92 60.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "200.47 59.44 201.77 60.19 201.77 58.69 200.47 57.94 200.47 59.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "198.02 58.02 199.32 58.77 199.32 57.28 198.02 56.53 198.02 58.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "195.57 56.61 196.88 57.36 196.88 55.87 195.57 55.11 195.57 56.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "193.13 55.2 194.43 55.95 194.43 54.45 193.13 53.7 193.13 55.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "190.68 53.78 191.98 54.53 191.98 53.04 190.68 52.29 190.68 53.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "212.71 69.14 214.01 69.89 214.01 68.4 212.71 67.64 212.71 69.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "210.26 67.73 211.56 68.48 211.56 66.98 210.26 66.23 210.26 67.73"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "207.81 66.31 209.12 67.07 209.12 65.57 207.81 64.82 207.81 66.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "205.37 64.9 206.67 65.65 206.67 64.16 205.37 63.41 205.37 64.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "202.92 63.49 204.22 64.24 204.22 62.74 202.92 61.99 202.92 63.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "200.47 62.07 201.77 62.83 201.77 61.33 200.47 60.58 200.47 62.07"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "198.02 60.66 199.32 61.41 199.32 59.92 198.02 59.16 198.02 60.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "195.57 59.25 196.88 60 196.88 58.5 195.57 57.75 195.57 59.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "193.13 57.83 194.43 58.59 194.43 57.09 193.13 56.34 193.13 57.83"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "190.68 56.42 191.98 57.17 191.98 55.68 190.68 54.92 190.68 56.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "185.78 53.59 187.08 54.35 187.08 52.85 185.78 52.1 185.78 53.59"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "212.71 71.8 214.01 72.55 214.01 71.06 212.71 70.3 212.71 71.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "210.26 70.38 211.56 71.14 211.56 69.64 210.26 68.89 210.26 70.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "207.81 68.97 209.12 69.72 209.12 68.23 207.81 67.48 207.81 68.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "205.37 67.56 206.67 68.31 206.67 66.81 205.37 66.06 205.37 67.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "202.92 66.14 204.22 66.9 204.22 65.4 202.92 64.65 202.92 66.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "200.47 64.73 201.77 65.48 201.77 63.99 200.47 63.24 200.47 64.73"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "198.02 63.32 199.32 64.07 199.32 62.58 198.02 61.82 198.02 63.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "195.57 61.9 196.88 62.66 196.88 61.16 195.57 60.41 195.57 61.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "193.13 60.49 194.43 61.24 194.43 59.75 193.13 59 193.13 60.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "190.68 59.08 191.98 59.83 191.98 58.34 190.68 57.58 190.68 59.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "188.23 57.66 189.53 58.42 189.53 56.92 188.23 56.17 188.23 57.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "185.78 56.25 187.08 57 187.08 55.51 185.78 54.76 185.78 56.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "212.71 74.51 214.01 75.26 214.01 73.76 212.71 73.01 212.71 74.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "210.26 73.09 211.56 73.85 211.56 72.35 210.26 71.6 210.26 73.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "207.81 71.68 209.12 72.43 209.12 70.94 207.81 70.19 207.81 71.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "205.37 70.27 206.67 71.02 206.67 69.52 205.37 68.77 205.37 70.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "202.92 68.85 204.22 69.61 204.22 68.11 202.92 67.36 202.92 68.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "200.47 67.44 201.77 68.19 201.77 66.7 200.47 65.94 200.47 67.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "198.02 66.03 199.32 66.78 199.32 65.28 198.02 64.53 198.02 66.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "195.57 64.61 196.88 65.37 196.88 63.87 195.57 63.12 195.57 64.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "193.13 63.2 194.43 63.95 194.43 62.46 193.13 61.7 193.13 63.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "185.78 58.96 187.08 59.71 187.08 58.22 185.78 57.46 185.78 58.96"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "212.71 77.16 214.01 77.92 214.01 76.42 212.71 75.67 212.71 77.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "210.26 75.75 211.56 76.5 211.56 75.01 210.26 74.26 210.26 75.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "207.81 74.34 209.12 75.09 209.12 73.59 207.81 72.84 207.81 74.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "205.37 72.92 206.67 73.68 206.67 72.18 205.37 71.43 205.37 72.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "202.92 71.51 204.22 72.26 204.22 70.77 202.92 70.02 202.92 71.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "200.47 70.1 201.77 70.85 201.77 69.36 200.47 68.6 200.47 70.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "198.02 68.68 199.32 69.44 199.32 67.94 198.02 67.19 198.02 68.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "195.57 67.27 196.88 68.02 196.88 66.53 195.57 65.78 195.57 67.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "190.68 64.44 191.98 65.2 191.98 63.7 190.68 62.95 190.68 64.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "188.23 63.03 189.53 63.78 189.53 62.29 188.23 61.53 188.23 63.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "185.78 61.62 187.08 62.37 187.08 60.87 185.78 60.12 185.78 61.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "242.03 70.26 243.33 71.02 243.33 69.52 242.03 68.77 242.03 70.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "239.58 68.85 240.88 69.6 240.88 68.11 239.58 67.36 239.58 68.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "237.13 67.44 238.44 68.19 238.44 66.69 237.13 65.94 237.13 67.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "234.69 66.02 235.99 66.78 235.99 65.28 234.69 64.53 234.69 66.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "232.24 64.61 233.54 65.36 233.54 63.87 232.24 63.11 232.24 64.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "229.79 63.2 231.09 63.95 231.09 62.45 229.79 61.7 229.79 63.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "227.34 61.78 228.65 62.54 228.65 61.04 227.34 60.29 227.34 61.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "224.89 60.37 226.2 61.12 226.2 59.63 224.89 58.87 224.89 60.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "222.45 58.96 223.75 59.71 223.75 58.21 222.45 57.46 222.45 58.96"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "220 57.54 221.3 58.3 221.3 56.8 220 56.05 220 57.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "217.55 56.13 218.85 56.88 218.85 55.39 217.55 54.63 217.55 56.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "215.1 54.72 216.41 55.47 216.41 53.97 215.1 53.22 215.1 54.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "242.03 72.92 243.33 73.67 243.33 72.18 242.03 71.43 242.03 72.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "239.58 71.51 240.88 72.26 240.88 70.77 239.58 70.01 239.58 71.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "237.13 70.09 238.44 70.85 238.44 69.35 237.13 68.6 237.13 70.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "234.69 68.68 235.99 69.43 235.99 67.94 234.69 67.19 234.69 68.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "232.24 67.27 233.54 68.02 233.54 66.53 232.24 65.77 232.24 67.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "229.79 65.85 231.09 66.61 231.09 65.11 229.79 64.36 229.79 65.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "227.34 64.44 228.65 65.19 228.65 63.7 227.34 62.95 227.34 64.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "224.89 63.03 226.2 63.78 226.2 62.28 224.89 61.53 224.89 63.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "222.45 61.61 223.75 62.37 223.75 60.87 222.45 60.12 222.45 61.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "220 60.2 221.3 60.95 221.3 59.46 220 58.7 220 60.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "217.55 58.79 218.85 59.54 218.85 58.04 217.55 57.29 217.55 58.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "215.1 57.37 216.41 58.13 216.41 56.63 215.1 55.88 215.1 57.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "242.03 75.56 243.33 76.31 243.33 74.81 242.03 74.06 242.03 75.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "239.58 74.14 240.88 74.9 240.88 73.4 239.58 72.65 239.58 74.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "237.13 72.73 238.44 73.48 238.44 71.99 237.13 71.24 237.13 72.73"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "234.69 71.32 235.99 72.07 235.99 70.58 234.69 69.82 234.69 71.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "232.24 69.91 233.54 70.66 233.54 69.16 232.24 68.41 232.24 69.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "229.79 68.49 231.09 69.24 231.09 67.75 229.79 67 229.79 68.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "227.34 67.08 228.65 67.83 228.65 66.33 227.34 65.58 227.34 67.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "224.89 65.67 226.2 66.42 226.2 64.92 224.89 64.17 224.89 65.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "222.45 64.25 223.75 65 223.75 63.51 222.45 62.76 222.45 64.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "220 62.84 221.3 63.59 221.3 62.09 220 61.34 220 62.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "217.55 61.42 218.85 62.18 218.85 60.68 217.55 59.93 217.55 61.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "215.1 60.01 216.41 60.76 216.41 59.27 215.1 58.52 215.1 60.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "242.03 78.22 243.33 78.97 243.33 77.47 242.03 76.72 242.03 78.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "239.58 76.8 240.88 77.56 240.88 76.06 239.58 75.31 239.58 76.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "237.13 75.39 238.44 76.14 238.44 74.65 237.13 73.89 237.13 75.39"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "234.69 73.98 235.99 74.73 235.99 73.23 234.69 72.48 234.69 73.98"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "232.24 72.56 233.54 73.31 233.54 71.82 232.24 71.07 232.24 72.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "229.79 71.15 231.09 71.9 231.09 70.41 229.79 69.65 229.79 71.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "227.34 69.74 228.65 70.49 228.65 68.99 227.34 68.24 227.34 69.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "224.89 68.32 226.2 69.08 226.2 67.58 224.89 66.83 224.89 68.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "222.45 66.91 223.75 67.66 223.75 66.17 222.45 65.41 222.45 66.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "220 65.5 221.3 66.25 221.3 64.75 220 64 220 65.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "217.55 64.08 218.85 64.83 218.85 63.34 217.55 62.59 217.55 64.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "215.1 62.67 216.41 63.42 216.41 61.93 215.1 61.17 215.1 62.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "242.03 80.83 243.33 81.59 243.33 80.09 242.03 79.34 242.03 80.83"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "239.58 79.42 240.88 80.17 240.88 78.68 239.58 77.92 239.58 79.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "237.13 78.01 238.44 78.76 238.44 77.26 237.13 76.51 237.13 78.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "234.69 76.59 235.99 77.35 235.99 75.85 234.69 75.1 234.69 76.59"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "232.24 75.18 233.54 75.93 233.54 74.44 232.24 73.69 232.24 75.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "229.79 73.77 231.09 74.52 231.09 73.02 229.79 72.27 229.79 73.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "227.34 72.35 228.65 73.11 228.65 71.61 227.34 70.86 227.34 72.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "224.89 70.94 226.2 71.69 226.2 70.2 224.89 69.44 224.89 70.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "222.45 69.53 223.75 70.28 223.75 68.78 222.45 68.03 222.45 69.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "220 68.11 221.3 68.87 221.3 67.37 220 66.62 220 68.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "217.55 66.7 218.85 67.45 218.85 65.96 217.55 65.2 217.55 66.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "215.1 65.29 216.41 66.04 216.41 64.54 215.1 63.79 215.1 65.29"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "242.03 83.49 243.33 84.24 243.33 82.75 242.03 82 242.03 83.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "239.58 82.08 240.88 82.83 240.88 81.33 239.58 80.58 239.58 82.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "237.13 80.67 238.44 81.42 238.44 79.92 237.13 79.17 237.13 80.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "234.69 79.25 235.99 80 235.99 78.51 234.69 77.76 234.69 79.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "232.24 77.84 233.54 78.59 233.54 77.09 232.24 76.34 232.24 77.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "229.79 76.42 231.09 77.18 231.09 75.68 229.79 74.93 229.79 76.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "227.34 75.01 228.65 75.76 228.65 74.27 227.34 73.52 227.34 75.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "224.89 73.6 226.2 74.35 226.2 72.86 224.89 72.1 224.89 73.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "222.45 72.19 223.75 72.94 223.75 71.44 222.45 70.69 222.45 72.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "220 70.77 221.3 71.52 221.3 70.03 220 69.28 220 70.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "217.55 69.36 218.85 70.11 218.85 68.61 217.55 67.86 217.55 69.36"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "215.1 67.94 216.41 68.7 216.41 67.2 215.1 66.45 215.1 67.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "242.03 86.13 243.33 86.88 243.33 85.39 242.03 84.63 242.03 86.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "239.58 84.72 240.88 85.47 240.88 83.97 239.58 83.22 239.58 84.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "237.13 83.3 238.44 84.05 238.44 82.56 237.13 81.81 237.13 83.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "234.69 81.89 235.99 82.64 235.99 81.15 234.69 80.39 234.69 81.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "232.24 80.47 233.54 81.23 233.54 79.73 232.24 78.98 232.24 80.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "229.79 79.06 231.09 79.81 231.09 78.32 229.79 77.57 229.79 79.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "227.34 77.65 228.65 78.4 228.65 76.91 227.34 76.15 227.34 77.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "224.89 76.23 226.2 76.99 226.2 75.49 224.89 74.74 224.89 76.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "222.45 74.82 223.75 75.57 223.75 74.08 222.45 73.33 222.45 74.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "220 73.41 221.3 74.16 221.3 72.67 220 71.91 220 73.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "217.55 72 218.85 72.75 218.85 71.25 217.55 70.5 217.55 72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "215.1 70.58 216.41 71.33 216.41 69.84 215.1 69.09 215.1 70.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "242.03 88.79 243.33 89.54 243.33 88.04 242.03 87.29 242.03 88.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "239.58 87.37 240.88 88.13 240.88 86.63 239.58 85.88 239.58 87.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "237.13 85.96 238.44 86.71 238.44 85.22 237.13 84.46 237.13 85.96"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "234.69 84.55 235.99 85.3 235.99 83.8 234.69 83.05 234.69 84.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "232.24 83.13 233.54 83.89 233.54 82.39 232.24 81.64 232.24 83.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "229.79 81.72 231.09 82.47 231.09 80.98 229.79 80.22 229.79 81.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "227.34 80.31 228.65 81.06 228.65 79.56 227.34 78.81 227.34 80.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "224.89 78.89 226.2 79.64 226.2 78.15 224.89 77.4 224.89 78.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "222.45 77.48 223.75 78.23 223.75 76.74 222.45 75.98 222.45 77.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "220 76.07 221.3 76.82 221.3 75.32 220 74.57 220 76.07"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "217.55 74.65 218.85 75.41 218.85 73.91 217.55 73.16 217.55 74.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "215.1 73.24 216.41 73.99 216.41 72.5 215.1 71.74 215.1 73.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "242.03 91.5 243.33 92.25 243.33 90.75 242.03 90 242.03 91.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "239.58 90.08 240.88 90.83 240.88 89.34 239.58 88.59 239.58 90.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "237.13 88.67 238.44 89.42 238.44 87.92 237.13 87.17 237.13 88.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "234.69 87.25 235.99 88.01 235.99 86.51 234.69 85.76 234.69 87.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "232.24 85.84 233.54 86.59 233.54 85.1 232.24 84.35 232.24 85.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "229.79 84.43 231.09 85.18 231.09 83.69 229.79 82.93 229.79 84.43"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "227.34 83.02 228.65 83.77 228.65 82.27 227.34 81.52 227.34 83.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "224.89 81.6 226.2 82.35 226.2 80.86 224.89 80.11 224.89 81.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "222.45 80.19 223.75 80.94 223.75 79.44 222.45 78.69 222.45 80.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "220 78.78 221.3 79.53 221.3 78.03 220 77.28 220 78.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "217.55 77.36 218.85 78.11 218.85 76.62 217.55 75.87 217.55 77.36"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "215.1 75.95 216.41 76.7 216.41 75.2 215.1 74.45 215.1 75.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "242.03 94.15 243.33 94.91 243.33 93.41 242.03 92.66 242.03 94.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "239.58 92.74 240.88 93.49 240.88 92 239.58 91.24 239.58 92.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "237.13 91.33 238.44 92.08 238.44 90.58 237.13 89.83 237.13 91.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "234.69 89.91 235.99 90.67 235.99 89.17 234.69 88.42 234.69 89.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "232.24 88.5 233.54 89.25 233.54 87.76 232.24 87 232.24 88.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "229.79 87.09 231.09 87.84 231.09 86.34 229.79 85.59 229.79 87.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "227.34 85.67 228.65 86.42 228.65 84.93 227.34 84.18 227.34 85.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "224.89 84.26 226.2 85.01 226.2 83.52 224.89 82.76 224.89 84.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "222.45 82.85 223.75 83.6 223.75 82.1 222.45 81.35 222.45 82.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "220 81.43 221.3 82.19 221.3 80.69 220 79.94 220 81.43"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "217.55 80.02 218.85 80.77 218.85 79.28 217.55 78.52 217.55 80.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "215.1 78.61 216.41 79.36 216.41 77.86 215.1 77.11 215.1 78.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "191.89 53.73 208.12 42.93 195.59 46.08 191.89 51.85 191.89 53.73"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M589.28,197.88c0-5.86-4.14-13-9.24-15.95a8.7,8.7,0,0,0-3.75-1.24c0-.08,0-.16,0-.24,0-11.34-8-25.17-17.9-30.88-5.56-3.2-10.39-2.77-13.79-.5l-5.71,3.26c-3.23-1.67-6.11-1.66-8.15-.26l-17.1,10c2.08-.91,4.81-.62,7.81,1.11a18,18,0,0,1,1.86,1.27c2.34-6.88,9.07-9,17-4.36,9.89,5.71,17.9,19.53,17.9,30.88,0,.08,0,.15,0,.23A8.78,8.78,0,0,1,562,192.4c5.11,2.95,9.25,10.09,9.25,15.95,0,2.48-.74,4.33-2,5.42l17-9.78h0C588.12,203.1,589.28,201,589.28,197.88Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M562,192.4a8.78,8.78,0,0,0-3.75-1.25c0-.08,0-.15,0-.23,0-11.35-8-25.17-17.9-30.88-8-4.59-14.68-2.52-17,4.36a18,18,0,0,0-1.86-1.27c-6.52-3.76-11.81-.75-11.81,6.73s5.29,16.6,11.81,20.36L562,213.62c5.11,2.95,9.25.59,9.25-5.27S567.09,195.35,562,192.4Zm6.57,19.76a2.93,2.93,0,0,1-2.42,1.11,7,7,0,0,1-3.34-1.05l-40.52-23.4c-6.06-3.5-11-12-11-19,0-4.21,1.83-6.72,4.89-6.72a9.23,9.23,0,0,1,4.48,1.4,14.61,14.61,0,0,1,1.7,1.15l1.8,1.36.72-2.13c1.25-3.68,3.9-5.71,7.46-5.71a14.81,14.81,0,0,1,7.21,2.24c9.42,5.44,17.09,18.66,17.09,29.47,0,.08,0,.15,0,.22v1.53l1.53.1a7.16,7.16,0,0,1,3,1c4.57,2.64,8.44,9.3,8.44,14.54A6.08,6.08,0,0,1,568.55,212.16Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M566.13,213.27a7,7,0,0,1-3.34-1.05l-40.52-23.4c-6.06-3.5-11-12-11-19,0-3,.94-5.14,2.58-6.12-2,.81-3.12,3.07-3.12,6.39,0,7,4.93,15.46,11,19l40.52,23.4a7,7,0,0,0,3.34,1,3,3,0,0,0,1.72-.48A3.22,3.22,0,0,1,566.13,213.27Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M562,192.4a8.78,8.78,0,0,0-3.75-1.25c0-.08,0-.15,0-.23,0-11.35-8-25.17-17.9-30.88-4.87-2.81-9.28-3.12-12.5-1.36,3.17-1.45,7.36-1,12,1.63,9.89,5.71,17.9,19.53,17.9,30.88,0,.08,0,.15,0,.23a8.78,8.78,0,0,1,3.75,1.25c5.11,3,9.25,10.09,9.25,16,0,2.89-1,4.93-2.65,5.9,2-.82,3.19-3,3.19-6.17C571.23,202.49,567.09,195.35,562,192.4Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M520.91,163.4a17.12,17.12,0,0,1,1.87,1.27c.06-.18.13-.35.2-.52a17.54,17.54,0,0,0-1.52-1c-3.27-1.89-6.23-2.07-8.37-.84C515.17,161.38,517.91,161.67,520.91,163.4Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M560.65,151c1.36,3.32-3.48,8.45-10.81,11.47s-14.38,2.76-15.75-.56,3.48-8.45,10.81-11.47",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M579.74,189.35c1,1.88-2.73,6-8.43,9.12s-4,1.25-5.07-.63-4.4-3,1.3-6.18S578.69,187.47,579.74,189.35Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "211.74 92.49 211.74 102.28 215.98 99.73 215.98 89.94 211.74 92.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "211.75 92.49 211.75 102.28 200.65 96 200.65 86.22 211.75 92.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "202.7 95.5 202.7 88.78 209.7 92.67 209.7 99.38 202.7 95.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "200.65 86.22 211.75 92.49 215.98 89.94 204.86 83.67 200.65 86.22"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M540.08,208.13a1.31,1.31,0,0,1-.52,1.18l-.6.35c-.34.19-.12-.24-.63-.53a4.1,4.1,0,0,1-1.86-3.21c0-.58-.54-.58-.21-.78l.67-.35a1.29,1.29,0,0,1,1.29.14A4.07,4.07,0,0,1,540.08,208.13Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M539.43,208.49c0,1.18-.83,1.66-1.85,1.06a4.07,4.07,0,0,1-1.86-3.2c0-1.18.83-1.65,1.86-1.06A4.1,4.1,0,0,1,539.43,208.49Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M539,208.41a1.09,1.09,0,0,1-.45,1l-.9.54c-.28.16-.1-.2-.54-.46a3.51,3.51,0,0,1-1.59-2.75c0-.5-.46-.5-.18-.67l.95-.54a1.14,1.14,0,0,1,1.12.12A3.51,3.51,0,0,1,539,208.41Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M538,209c0,1-.71,1.42-1.59.91a3.52,3.52,0,0,1-1.6-2.75c0-1,.72-1.42,1.6-.91A3.51,3.51,0,0,1,538,209Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M537.66,205.25a1.31,1.31,0,0,0-1.27-.16,1.44,1.44,0,0,1,1.11.22,4.09,4.09,0,0,1,1.86,3.2,1.25,1.25,0,0,1-.59,1.22c.46-.13.75-.58.75-1.28A4.07,4.07,0,0,0,537.66,205.25Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M536.52,206.17a1.16,1.16,0,0,0-1.1-.14,1.28,1.28,0,0,1,1,.19A3.54,3.54,0,0,1,538,209a1.08,1.08,0,0,1-.5,1c.39-.11.64-.49.64-1.1A3.54,3.54,0,0,0,536.52,206.17Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M537.29,208.69c0,.59-.41.82-.92.53a2,2,0,0,1-.92-1.59c0-.58.41-.82.92-.52A2,2,0,0,1,537.29,208.69Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M429.39,239.45a.48.48,0,0,1-.26-.07L352,191.77a.51.51,0,0,1-.17-.69.49.49,0,0,1,.69-.16l77.17,47.61a.51.51,0,0,1,.16.69A.5.5,0,0,1,429.39,239.45Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M458.38,300.21a16.69,16.69,0,0,1-8.21-1.9l-39.71-22.93c-2.21-1.27-3.43-3.06-3.43-5,0-2.34,1.73-4.68,4.74-6.42l36.73-21.2a21.83,21.83,0,0,1,10.62-2.66,16.67,16.67,0,0,1,8.21,1.9l39.72,22.93c2.2,1.27,3.42,3.06,3.42,5,0,2.34-1.73,4.68-4.74,6.42L469,297.55A21.87,21.87,0,0,1,458.38,300.21Zm.74-59.14A20.88,20.88,0,0,0,449,243.59L412.27,264.8c-2.69,1.55-4.24,3.58-4.24,5.55,0,1.6,1,3.08,2.93,4.17l39.71,22.92a15.72,15.72,0,0,0,7.71,1.77,20.89,20.89,0,0,0,10.13-2.52l36.72-21.21c2.69-1.55,4.24-3.58,4.24-5.55,0-1.6-1-3.08-2.92-4.17l-39.72-22.93A15.84,15.84,0,0,0,459.12,241.07Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M485.57,240.06a.5.5,0,0,1-.26-.92l50.59-31.22a.5.5,0,0,1,.69.16.51.51,0,0,1-.16.69L485.83,240A.48.48,0,0,1,485.57,240.06Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-30"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M393.46,207a3.26,3.26,0,0,0,1.77-2.82,3.78,3.78,0,0,0-2.13-3.2l-18.81-7.24a7.61,7.61,0,0,0-3.74-.95,6.25,6.25,0,0,0-3.09.74L353.06,202a3.26,3.26,0,0,0-1.77,2.82,3.8,3.8,0,0,0,2.13,3.21l11.78,11.24a7.62,7.62,0,0,0,3.75.95,6.24,6.24,0,0,0,3.08-.74",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M393.33,206.86a3.07,3.07,0,0,0,1.68-2.69,3.63,3.63,0,0,0-2.05-3l-18.69-7.19a7.4,7.4,0,0,0-1.31-.57,8,8,0,0,0-2.41-.4,6.05,6.05,0,0,0-3.06.72L353.22,202l-.15.09a3,3,0,0,0-1.56,2.82,4.15,4.15,0,0,0,2.15,3.11l11.56,11a7.45,7.45,0,0,0,3.66.93,6.07,6.07,0,0,0,3-.72l1.95-1.13",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M393.19,206.74a2.94,2.94,0,0,0,1.6-2.56,3.48,3.48,0,0,0-2-2.89l-18.57-7.15a9.43,9.43,0,0,0-1.3-.56,8.22,8.22,0,0,0-2.39-.43,6,6,0,0,0-3.05.69l-14.28,8.37-.15.09a2.72,2.72,0,0,0-1.35,2.82,4.62,4.62,0,0,0,2.16,3L365.25,219a7.2,7.2,0,0,0,3.57.91,6,6,0,0,0,2.94-.7l3.89-2.26",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M393.05,206.62a2.74,2.74,0,0,0,1.52-2.42,3.33,3.33,0,0,0-1.88-2.75l-18.46-7.1a10.79,10.79,0,0,0-1.3-.55,7.73,7.73,0,0,0-2.37-.46,5.79,5.79,0,0,0-3,.67l-14.3,8.37-.15.1a2.29,2.29,0,0,0-1.15,2.81c0,.91,1.2,2.36,2.19,2.93l11.14,10.64a7.23,7.23,0,0,0,3.48.89,5.77,5.77,0,0,0,2.87-.68l5.84-3.39",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M392.91,206.5a2.58,2.58,0,0,0,1.44-2.29,3.17,3.17,0,0,0-1.8-2.59l-18.34-7.06a13.69,13.69,0,0,0-1.3-.55,7.92,7.92,0,0,0-2.34-.48,5.77,5.77,0,0,0-3,.64l-14.31,8.38-.16.1a2.08,2.08,0,0,0-.93,2.81c0,.8,1.34,2.34,2.2,2.84l10.94,10.44a7,7,0,0,0,3.39.87,5.62,5.62,0,0,0,2.79-.66l7.79-4.52",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M392.77,206.39a2.45,2.45,0,0,0,1.36-2.17,3,3,0,0,0-1.72-2.44l-18.22-7a13.64,13.64,0,0,0-1.3-.54,7.76,7.76,0,0,0-2.31-.51,5.49,5.49,0,0,0-3,.62l-14.32,8.39-.17.09a1.92,1.92,0,0,0-.72,2.81c0,.69,1.48,2.33,2.22,2.75l10.72,10.24a6.78,6.78,0,0,0,3.3.85,5.42,5.42,0,0,0,2.72-.64l9.74-5.66",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M392.63,206.27a2.28,2.28,0,0,0,1.28-2,2.9,2.9,0,0,0-1.64-2.29l-18.11-7c-.18-.11-1.08-.45-1.29-.53a7.9,7.9,0,0,0-2.29-.54,5.43,5.43,0,0,0-3,.59l-14.33,8.4-.17.1a1.79,1.79,0,0,0-.51,2.81c0,.57,1.62,2.3,2.23,2.66l10.52,10a6.63,6.63,0,0,0,3.21.83,5.23,5.23,0,0,0,2.64-.62l11.69-6.79",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M392.49,206.15a2.12,2.12,0,0,0,1.2-1.9,2.72,2.72,0,0,0-1.56-2.14l-18-6.92c-.15-.09-1.13-.46-1.29-.53a7.73,7.73,0,0,0-2.26-.56,5.19,5.19,0,0,0-2.95.57l-14.35,8.4-.17.1a1.7,1.7,0,0,0-.3,2.81c0,.45,1.75,2.28,2.25,2.57l10.3,9.84a6.42,6.42,0,0,0,3.12.79,5.09,5.09,0,0,0,2.57-.59l13.64-7.92",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M392.35,206a2,2,0,0,0,1.12-1.77,2.6,2.6,0,0,0-1.48-2l-17.87-6.87c-.11-.07-1.17-.47-1.29-.52a7.55,7.55,0,0,0-2.24-.59,5.12,5.12,0,0,0-2.93.54l-14.36,8.41-.17.11a1.63,1.63,0,0,0-.09,2.8,10.45,10.45,0,0,0,2.26,2.48l10.1,9.64a6.28,6.28,0,0,0,3,.77,5,5,0,0,0,2.49-.56l15.59-9.06",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M392.22,205.91a1.79,1.79,0,0,0,1-1.64,2.46,2.46,0,0,0-1.4-1.83l-17.75-6.83c-.08-.05-1.21-.48-1.29-.51a7.4,7.4,0,0,0-2.21-.62,5.05,5.05,0,0,0-2.91.51l-14.38,8.43-.17.1c-1.1.74-1,1.92.12,2.8a15,15,0,0,0,2.28,2.39l9.88,9.44a6.2,6.2,0,0,0,2.94.75,4.9,4.9,0,0,0,2.43-.54l17.53-10.19",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M392.08,205.79a1.64,1.64,0,0,0,.95-1.51,2.32,2.32,0,0,0-1.31-1.68l-17.64-6.78s-1.25-.49-1.29-.51a7.83,7.83,0,0,0-2.19-.64,4.93,4.93,0,0,0-2.89.49l-14.39,8.43-.17.11c-1.1.74-1,2,.33,2.8a30.92,30.92,0,0,0,2.29,2.29l9.68,9.24a6,6,0,0,0,2.85.73,4.72,4.72,0,0,0,2.35-.52l19.48-11.32",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M370.51,218.12l21.43-12.45c1.29-.74,1.13-2-.36-2.9l-18.81-7.24a5.6,5.6,0,0,0-5-.21l-14.41,8.44c-1.29.75-1.13,2.05.36,2.91l11.78,11.24A5.62,5.62,0,0,0,370.51,218.12Z",
    transform: "translate(-332.25 -113.32)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M391.94,205.64a1.51,1.51,0,0,0,.87-1.24v-1.62c0-.56-.43.42-1.23,0l-18.81-7.24a5.6,5.6,0,0,0-5-.21l-14.41,8.44c-.43.25-.74-.81-.85-.47,0,.11,0,1.59,0,1.71a2.07,2.07,0,0,0,1.23,1.67l11.78,11.24a5.62,5.62,0,0,0,5,.21",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M370.51,216.5l21.43-12.45c1.29-.74,1.13-2-.36-2.9l-18.81-7.24a5.6,5.6,0,0,0-5-.21l-14.41,8.44c-1.29.75-1.13,2.05.36,2.91l11.78,11.24A5.62,5.62,0,0,0,370.51,216.5Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M353.33,202.14l14.41-8.44a5.6,5.6,0,0,1,5,.21l9.48,3.65a2.23,2.23,0,0,1-.3.2l-21.43,12.45a4,4,0,0,1-1,.38l-5.81-5.54C352.2,204.19,352,202.89,353.33,202.14Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M353.69,204.78,365.47,216a5.59,5.59,0,0,0,5,.21l21.43-12.45a1.54,1.54,0,0,0,.86-1.14,1.42,1.42,0,0,1-.86,1.41L370.51,216.5a5.62,5.62,0,0,1-5-.21l-11.78-11.24a2,2,0,0,1-1.22-1.76A2.22,2.22,0,0,0,353.69,204.78Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M342.51,216.57l52.63-30.41c2.69-1.56,4.87-5.72,4.87-9.31V136.6c0-3.59-2.18-5.24-4.87-3.69l-52.63,30.41c-2.69,1.56-4.87,5.73-4.87,9.31v40.26C337.64,216.47,339.82,218.12,342.51,216.57Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "M341.88,213.77l51.89-30a8.29,8.29,0,0,0,3.51-6.94V136.33a.86.86,0,0,0-1.3-.74l-.16.09-51.94,30c-2.58,1.49-3.5,4.13-3.5,6.94V213a.93.93,0,0,0,1.39.81Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M340.38,172.63V213a.93.93,0,0,0,1.39.81l.11-.06,51.89-30a8.29,8.29,0,0,0,3.51-6.94V136.33a.86.86,0,0,0-1.3-.74l-.16.09-51.94,30C341.3,167.18,340.38,169.82,340.38,172.63Zm.54,0c0-2.1.56-4.92,3.23-6.46l52.1-30.11a.32.32,0,0,1,.16,0,.31.31,0,0,1,.32.31v40.52a7.72,7.72,0,0,1-3.23,6.46l-52,30.05a.45.45,0,0,1-.19,0,.39.39,0,0,1-.39-.39Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "M341.13,162.59l52.63-30.41a3.31,3.31,0,0,1,2.85-.42c.1,0,1.46.76,1.56.82h0a3.2,3.2,0,0,0-3,.33l-52.63,30.41c-2.69,1.56-4.87,5.73-4.87,9.31v40.26c0,2.23.85,3.72,2.14,4.14a.81.81,0,0,1-.43-.15l-1.59-.9c-.93-.65-1.5-2-1.5-3.83V171.9C336.26,168.31,338.44,164.14,341.13,162.59Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "M342.28,163.21l52.63-30.41a3.23,3.23,0,0,1,2.93-.38,3.63,3.63,0,0,0-2.35.55l-52.63,30.41c-2.69,1.56-4.87,5.72-4.87,9.31v40.25c0,2.12.76,3.55,1.94,4.06-1.51-.24-2.52-1.78-2.52-4.23V172.52C337.41,168.93,339.59,164.76,342.28,163.21Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-52"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-53",
    points: "34.32 45.95 28.24 49.3 28.24 48.06 34.32 44.71 34.32 45.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-54",
    points: "29.5 57.69 35.55 54.33 35.55 55.57 29.5 58.93 29.5 57.69"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-55",
    points: "30.91 50.45 30.91 49.21 36.16 46.33 36.16 47.57 30.91 50.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-56",
    points: "42.39 47.89 42.39 49.13 40.02 50.5 40.02 49.26 42.39 47.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-57",
    points: "45.97 49.74 45.97 48.5 49.83 46.32 49.83 47.56 45.97 49.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-58",
    points: "28.89 55.46 34.08 52.61 34.08 53.85 28.89 56.7 28.89 55.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-59",
    points: "35.52 49.27 35.52 50.51 31.68 52.57 31.68 51.33 35.52 49.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-60",
    points: "27 48.77 27 50.01 25.93 50.63 25.93 49.39 27 48.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-61",
    points: "41.46 47.17 41.46 45.92 45.46 43.65 45.46 44.89 41.46 47.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-62",
    points: "29.67 49.92 29.67 51.16 23.78 54.53 23.78 53.29 29.67 49.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-63",
    points: "43.61 48.43 43.61 47.19 48.63 44.38 48.63 45.62 43.61 48.43"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-64",
    points: "47.42 37.27 47.42 38.51 43.49 40.76 43.49 39.52 47.42 37.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-65",
    points: "40.26 41.37 42.26 40.23 42.26 41.47 40.26 42.61 40.26 41.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-66",
    points: "42.66 50.37 44.73 49.2 44.73 50.44 42.66 51.62 42.66 50.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-67",
    points: "24.88 59.02 19.53 62.13 19.53 60.89 24.88 57.78 24.88 59.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-68",
    points: "51.07 45.62 52.96 44.53 52.96 45.77 51.07 46.86 51.07 45.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-69",
    points: "56.84 32.06 56.84 33.3 48.42 38.1 48.42 36.86 56.84 32.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-70",
    points: "23.64 57.16 21.66 58.31 21.66 57.07 23.64 55.92 23.64 57.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-71",
    points: "22.54 55.24 16.27 58.83 16.27 57.59 22.54 54 22.54 55.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-72",
    points: "30.44 53.27 24.86 56.45 24.86 55.21 30.44 52.03 30.44 53.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-73",
    points: "24.69 50.1 24.69 51.34 20.25 53.88 20.25 52.64 24.69 50.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-74",
    points: "49.87 43.69 56.77 39.97 56.77 41.21 49.87 44.93 49.87 43.69"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-75",
    points: "26.11 57.08 27.66 56.18 27.66 57.42 26.11 58.32 26.11 57.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-76",
    points: "46.7 42.94 52.96 39.37 52.96 40.61 46.7 44.18 46.7 42.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-77",
    points: "43.39 42.28 54.82 35.76 54.82 37 43.39 43.52 43.39 42.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-78",
    points: "34.32 59.13 28.24 62.48 28.24 61.24 34.32 57.89 34.32 59.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-79",
    points: "29.5 70.87 35.55 67.51 35.55 68.75 29.5 72.11 29.5 70.87"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-80",
    points: "30.91 63.63 30.91 62.39 36.16 59.51 36.16 60.74 30.91 63.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-81",
    points: "42.39 61.07 42.39 62.31 40.02 63.68 40.02 62.44 42.39 61.07"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-82",
    points: "45.97 62.92 45.97 61.68 49.83 59.5 49.83 60.74 45.97 62.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-83",
    points: "28.89 68.64 34.08 65.79 34.08 67.03 28.89 69.88 28.89 68.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-84",
    points: "35.52 62.45 35.52 63.69 31.68 65.75 31.68 64.51 35.52 62.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-85",
    points: "27 61.95 27 63.19 25.93 63.81 25.93 62.57 27 61.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-86",
    points: "41.46 60.35 41.46 59.1 45.46 56.83 45.46 58.07 41.46 60.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "29.67 63.1 29.67 64.34 23.78 67.71 23.78 66.47 29.67 63.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-88",
    points: "43.61 61.61 43.61 60.37 48.63 57.56 48.63 58.8 43.61 61.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-89",
    points: "47.42 50.45 47.42 51.69 43.49 53.94 43.49 52.7 47.42 50.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-90",
    points: "40.26 54.55 42.26 53.41 42.26 54.65 40.26 55.79 40.26 54.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-91",
    points: "42.66 63.55 44.73 62.38 44.73 63.62 42.66 64.79 42.66 63.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-92",
    points: "24.88 72.2 19.53 75.31 19.53 74.07 24.88 70.96 24.88 72.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "51.07 58.8 52.96 57.71 52.96 58.95 51.07 60.04 51.07 58.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-94",
    points: "56.84 45.24 56.84 46.48 48.42 51.28 48.42 50.04 56.84 45.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-95",
    points: "23.64 70.34 21.66 71.49 21.66 70.25 23.64 69.1 23.64 70.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-96",
    points: "22.54 68.42 16.27 72 16.27 70.77 22.54 67.18 22.54 68.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-97",
    points: "30.44 66.45 24.86 69.63 24.86 68.39 30.44 65.21 30.44 66.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-98",
    points: "24.69 63.28 24.69 64.52 20.25 67.06 20.25 65.82 24.69 63.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-99",
    points: "49.87 56.87 56.77 53.15 56.77 54.39 49.87 58.11 49.87 56.87"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-100",
    points: "26.11 70.25 27.66 69.36 27.66 70.6 26.11 71.5 26.11 70.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-101",
    points: "46.7 56.12 52.96 52.55 52.96 53.79 46.7 57.36 46.7 56.12"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-102",
    points: "43.39 55.46 54.82 48.94 54.82 50.18 43.39 56.7 43.39 55.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-103",
    points: "34.32 72.5 28.24 75.85 28.24 74.61 34.32 71.26 34.32 72.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-104",
    points: "29.5 84.23 35.55 80.88 35.55 82.12 29.5 85.47 29.5 84.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-105",
    points: "30.91 76.99 30.91 75.75 36.16 72.87 36.16 74.11 30.91 76.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-106",
    points: "42.39 74.44 42.39 75.68 40.02 77.05 40.02 75.81 42.39 74.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-107",
    points: "45.97 76.29 45.97 75.05 49.83 72.86 49.83 74.1 45.97 76.29"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-108",
    points: "28.89 82.01 34.08 79.16 34.08 80.4 28.89 83.25 28.89 82.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-109",
    points: "35.52 75.81 35.52 77.05 31.68 79.11 31.68 77.87 35.52 75.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-110",
    points: "27 75.32 27 76.56 25.93 77.18 25.93 75.94 27 75.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-111",
    points: "41.46 73.71 41.46 72.47 45.46 70.19 45.46 71.44 41.46 73.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-112",
    points: "29.67 76.46 29.67 77.7 23.78 81.07 23.78 79.83 29.67 76.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-113",
    points: "43.61 74.97 43.61 73.73 48.63 70.92 48.63 72.17 43.61 74.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-114",
    points: "47.42 63.81 47.42 65.06 43.49 67.3 43.49 66.06 47.42 63.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-115",
    points: "40.26 67.92 42.26 66.77 42.26 68.01 40.26 69.16 40.26 67.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-116",
    points: "42.66 76.92 44.73 75.75 44.73 76.99 42.66 78.16 42.66 76.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-117",
    points: "24.88 85.57 19.53 88.68 19.53 87.44 24.88 84.33 24.88 85.57"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-118",
    points: "51.07 72.16 52.96 71.07 52.96 72.31 51.07 73.4 51.07 72.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-119",
    points: "56.84 58.6 56.84 59.84 48.42 64.64 48.42 63.4 56.84 58.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-120",
    points: "23.64 83.7 21.66 84.86 21.66 83.61 23.64 82.46 23.64 83.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-121",
    points: "22.54 81.78 16.27 85.37 16.27 84.13 22.54 80.54 22.54 81.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-122",
    points: "30.44 79.82 24.86 83 24.86 81.76 30.44 78.58 30.44 79.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-123",
    points: "24.69 76.65 24.69 77.89 20.25 80.43 20.25 79.19 24.69 76.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-124",
    points: "49.87 70.23 56.77 66.52 56.77 67.76 49.87 71.47 49.87 70.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-125",
    points: "26.11 83.62 27.66 82.72 27.66 83.96 26.11 84.86 26.11 83.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-126",
    points: "46.7 69.49 52.96 65.92 52.96 67.16 46.7 70.73 46.7 69.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-127",
    points: "43.39 68.82 54.82 62.31 54.82 63.55 43.39 70.06 43.39 68.82"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-128",
    d: "M403.58,193.07a4.07,4.07,0,0,1,2,.49,1.72,1.72,0,0,1,1,1.43,1.7,1.7,0,0,1-1,1.43,4.43,4.43,0,0,1-3.95,0,1.54,1.54,0,0,1,0-2.86A4,4,0,0,1,403.58,193.07Zm0,2.83a3,3,0,0,0,1.47-.35c.29-.17.46-.37.46-.56s-.17-.39-.47-.56a3.45,3.45,0,0,0-3,0c-.29.17-.46.37-.46.56s.18.39.48.57A3.05,3.05,0,0,0,403.61,195.9Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-129",
    d: "M489,187.75a4,4,0,0,1,2,.48,1.71,1.71,0,0,1,1,1.44,1.69,1.69,0,0,1-1,1.42,4.43,4.43,0,0,1-4,0,1.71,1.71,0,0,1-1-1.44,1.66,1.66,0,0,1,1-1.42A4,4,0,0,1,489,187.75Zm0,2.82a3.09,3.09,0,0,0,1.46-.34c.3-.17.46-.38.46-.56s-.17-.4-.47-.57a3.46,3.46,0,0,0-3,0c-.29.17-.46.37-.46.56s.17.4.47.57A3.12,3.12,0,0,0,489,190.57Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-130",
    d: "M427.49,186.72a4,4,0,0,1,2,.48,1.54,1.54,0,0,1,0,2.86,4.43,4.43,0,0,1-4,0,1.54,1.54,0,0,1,0-2.86A4.07,4.07,0,0,1,427.49,186.72Zm0,2.82a3,3,0,0,0,1.46-.35c.3-.17.46-.37.46-.56s-.17-.39-.47-.56a3.43,3.43,0,0,0-3,0c-.29.17-.46.37-.46.56s.17.39.47.57A3.12,3.12,0,0,0,427.52,189.54Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-131",
    d: "M509.18,190.05h0a4,4,0,0,1,2,.48,1.53,1.53,0,0,1,0,2.85,4.4,4.4,0,0,1-3.95,0,1.66,1.66,0,0,1-1-1.42,1.71,1.71,0,0,1,1-1.44A4,4,0,0,1,509.18,190.05Zm0,2.82a3.05,3.05,0,0,0,1.48-.35c.3-.17.47-.38.47-.57s-.16-.39-.46-.56a3.46,3.46,0,0,0-2.95,0c-.3.17-.47.38-.47.57s.17.39.46.56A3.13,3.13,0,0,0,509.15,192.87Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-132",
    d: "M530.18,217.38h0a4,4,0,0,1,2,.48,1.69,1.69,0,0,1,1,1.42,1.71,1.71,0,0,1-1,1.44,4.46,4.46,0,0,1-4,0,1.54,1.54,0,0,1,0-2.86A3.94,3.94,0,0,1,530.18,217.38Zm0,2.82a3.05,3.05,0,0,0,1.48-.35c.3-.17.47-.38.47-.57s-.16-.39-.46-.55a3.46,3.46,0,0,0-2.95,0c-.3.17-.47.38-.47.57s.17.39.46.56A3,3,0,0,0,530.15,220.2Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-133",
    d: "M566.34,225.88h0a4,4,0,0,1,2,.48,1.69,1.69,0,0,1,1,1.42,1.71,1.71,0,0,1-1,1.44,4.46,4.46,0,0,1-3.95,0,1.54,1.54,0,0,1,0-2.86A3.93,3.93,0,0,1,566.34,225.88Zm0,2.82a3.12,3.12,0,0,0,1.49-.35c.3-.17.47-.38.47-.57s-.17-.39-.46-.55a3.46,3.46,0,0,0-2.95,0c-.3.17-.47.38-.47.57s.16.39.46.56A3,3,0,0,0,566.31,228.7Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-134",
    d: "M554.51,251.05h0a4,4,0,0,1,2,.48,1.53,1.53,0,0,1,0,2.85,4.42,4.42,0,0,1-4,0,1.66,1.66,0,0,1-1-1.42,1.73,1.73,0,0,1,1-1.44A4.07,4.07,0,0,1,554.51,251.05Zm0,2.82a3.12,3.12,0,0,0,1.49-.35c.3-.17.47-.38.47-.57s-.17-.39-.46-.56a3.48,3.48,0,0,0-3,0c-.3.17-.47.38-.47.57s.17.39.46.56A3.13,3.13,0,0,0,554.48,253.87Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-135",
    d: "M518,285.72h0a4.1,4.1,0,0,1,2,.47,1.7,1.7,0,0,1,1,1.43,1.72,1.72,0,0,1-1,1.43,4.45,4.45,0,0,1-4,0,1.68,1.68,0,0,1-1-1.43,1.73,1.73,0,0,1,1-1.43A4.07,4.07,0,0,1,518,285.72Zm0,2.82a3.12,3.12,0,0,0,1.49-.35c.3-.18.47-.38.47-.57s-.17-.39-.46-.56a3.48,3.48,0,0,0-3,0c-.3.18-.47.38-.47.57s.17.39.46.56A3,3,0,0,0,518,288.54Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-136",
    d: "M513.35,328.56h0a4,4,0,0,1,2,.48,1.7,1.7,0,0,1,1,1.43,1.73,1.73,0,0,1-1,1.43,4.48,4.48,0,0,1-4,0,1.69,1.69,0,0,1-1-1.43,1.72,1.72,0,0,1,1-1.43A4.07,4.07,0,0,1,513.35,328.56Zm0,2.82a3,3,0,0,0,1.49-.35c.3-.17.47-.38.47-.56s-.17-.39-.46-.56a3.48,3.48,0,0,0-3,0c-.29.18-.47.38-.47.57s.17.39.46.56A3,3,0,0,0,513.32,331.38Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-137",
    d: "M488.85,327.73h0a4,4,0,0,1,2,.48,1.69,1.69,0,0,1,1,1.42,1.73,1.73,0,0,1-1,1.44,4.45,4.45,0,0,1-4,0,1.66,1.66,0,0,1-1-1.42,1.73,1.73,0,0,1,1-1.44A4.07,4.07,0,0,1,488.85,327.73Zm0,2.82a3.12,3.12,0,0,0,1.49-.35c.3-.17.47-.38.47-.57s-.17-.39-.46-.56a3.48,3.48,0,0,0-3,0c-.29.17-.47.38-.47.57s.17.39.46.56A3,3,0,0,0,488.82,330.55Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-138",
    d: "M437.68,318.73h0a4,4,0,0,1,2,.48,1.69,1.69,0,0,1,1,1.42,1.71,1.71,0,0,1-1,1.44,4.43,4.43,0,0,1-3.95,0,1.66,1.66,0,0,1-1-1.42,1.71,1.71,0,0,1,1-1.44A4,4,0,0,1,437.68,318.73Zm0,2.82a3.1,3.1,0,0,0,1.49-.35c.3-.17.47-.38.47-.57s-.17-.39-.46-.56a3.46,3.46,0,0,0-2.95,0c-.3.17-.47.38-.47.57s.17.39.46.56A3,3,0,0,0,437.65,321.55Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-139",
    d: "M417.52,319.06h0a4,4,0,0,1,2,.48,1.54,1.54,0,0,1,0,2.86,4.46,4.46,0,0,1-4,0,1.54,1.54,0,0,1,0-2.86A4.07,4.07,0,0,1,417.52,319.06Zm0,2.82a3,3,0,0,0,1.48-.35c.3-.17.47-.38.47-.56s-.16-.39-.46-.56a3.46,3.46,0,0,0-3,0c-.3.18-.47.38-.47.57s.17.39.46.56A3,3,0,0,0,417.49,321.88Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-140",
    d: "M377.35,251.73h0a4,4,0,0,1,2,.48,1.69,1.69,0,0,1,1,1.42,1.73,1.73,0,0,1-1,1.44,4.45,4.45,0,0,1-4,0,1.66,1.66,0,0,1-1-1.42,1.73,1.73,0,0,1,1-1.44A4.07,4.07,0,0,1,377.35,251.73Zm0,2.82a3.12,3.12,0,0,0,1.49-.35c.3-.17.47-.38.47-.57s-.17-.39-.46-.56a3.48,3.48,0,0,0-3,0c-.29.17-.47.38-.47.57s.17.39.46.56A3,3,0,0,0,377.32,254.55Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-141",
    d: "M372.38,227.83h0a4,4,0,0,1,2,.48,1.69,1.69,0,0,1,1,1.42,1.73,1.73,0,0,1-1,1.44,4.45,4.45,0,0,1-4,0,1.66,1.66,0,0,1-1-1.42,1.73,1.73,0,0,1,1-1.44A4.07,4.07,0,0,1,372.38,227.83Zm0,2.82a3.12,3.12,0,0,0,1.49-.35c.3-.17.47-.38.47-.57s-.17-.39-.46-.56a3.52,3.52,0,0,0-3,0c-.3.17-.47.38-.47.57s.17.39.46.56A3,3,0,0,0,372.35,230.65Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-142",
    points: "203.4 150.64 186.91 141.98 172.31 150.51 171.81 149.64 186.88 140.84 203.39 149.51 220.49 139.97 220.97 140.84 203.4 150.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-143",
    points: "163.17 138.83 162.62 137.99 181.25 125.95 171.71 120.76 195.97 106.48 196.48 107.34 173.74 120.72 183.21 125.87 163.17 138.83"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-144",
    points: "166.65 147.17 166.14 146.31 201.89 125.16 208.39 128.83 231.97 114.81 232.48 115.67 208.4 129.99 201.9 126.32 166.65 147.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-145",
    points: "106.98 110.34 83.39 96.74 90.06 92.91 72.98 83.18 73.48 82.31 92.07 92.91 85.4 96.74 107.48 109.47 106.98 110.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-146",
    points: "122.3 104 104.42 92.89 114.89 86.91 97.31 76.84 97.81 75.97 116.9 86.91 106.37 92.93 122.83 103.15 122.3 104"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-145",
    d: "M477.81,225.23v-.5l-.09-.49c1-.29,15.7-8.77,25.76-14.67l-12.83-7.51,16.57-9.59.5.86-15.08,8.74,12.82,7.49-.73.44C495,215.69,478.65,225.23,477.81,225.23Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-147",
    points: "133.81 104.34 133.31 103.48 150.61 93.39 139.61 86.22 155.31 76.98 155.81 77.84 141.51 86.26 152.51 93.43 133.81 104.34"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-148",
    x: 509.64,
    y: 273.07,
    width: 1,
    height: 49,
    transform: "translate(-336.04 475.2) rotate(-59.77)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-149",
    points: "184.81 173.84 179.06 170.49 173.39 173.65 164.14 168.17 164.65 167.31 173.4 172.5 179.07 169.33 185.31 172.98 184.81 173.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-150",
    points: "179.64 216.84 160.92 205.57 177.56 195.75 146.81 178.34 147.31 177.47 179.56 195.73 162.87 205.58 180.15 215.98 179.64 216.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-151",
    points: "154.31 215.67 134.75 204.25 151.41 194.09 134.98 184.84 135.47 183.97 153.38 194.06 136.7 204.23 154.81 214.81 154.31 215.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-152",
    points: "107.65 206.84 107.14 205.98 118.07 199.58 102.58 190.59 115.3 182.81 115.82 183.67 104.54 190.56 120.05 199.57 107.65 206.84"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-153",
    d: "M388.05,276.75h0a4,4,0,0,1,2,.48,1.53,1.53,0,0,1,0,2.85,4.4,4.4,0,0,1-3.95,0,1.67,1.67,0,0,1-1-1.42,1.71,1.71,0,0,1,1-1.44A4,4,0,0,1,388.05,276.75Zm0,2.82a3.05,3.05,0,0,0,1.48-.35c.3-.17.47-.38.47-.57s-.16-.39-.46-.56a3.46,3.46,0,0,0-2.95,0c-.3.17-.47.38-.47.57s.17.39.46.56A3.13,3.13,0,0,0,388,279.57Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-154",
    points: "79.53 169.35 65.1 160.66 58.01 164.86 57.5 164 65.11 159.49 79.54 168.19 84.98 165.02 85.48 165.88 79.53 169.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-155",
    points: "86.31 207.17 85.81 206.31 95.57 200.58 81.58 192.41 106.14 177.65 106.65 178.5 83.54 192.4 97.55 200.57 86.31 207.17"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-156",
    x: 392.71,
    y: 295.9,
    width: 40.19,
    height: 1,
    transform: "translate(-425.45 136.06) rotate(-30.37)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-157",
    points: "98.81 137.01 76.07 123.82 64.4 130.99 41.31 117.51 41.81 116.64 64.39 129.83 76.05 122.66 99.31 136.14 98.81 137.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-158",
    points: "79.3 151.33 66.72 143.49 58.07 148.66 45.65 141.51 46.14 140.64 58.06 147.5 66.73 142.32 79.83 150.49 79.3 151.33"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-159",
    cx: 130.29,
    cy: 154.52,
    rx: 49.23,
    ry: 28.06
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-160",
    d: "M502.89,256.17H502a6.48,6.48,0,0,0-1.87-1.57l-34.51-19.92c-4.08-2.36-11.21-2.06-15.93.66l-31.92,18.43a9.42,9.42,0,0,0-2.85,2.4h-1.05v13.75h0a4.9,4.9,0,0,0,2.73,3.65l34.51,19.92c4.09,2.36,11.22,2.07,15.94-.66L499,274.41c2.24-1.3,3.52-2.9,3.82-4.49h.08Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-161",
    d: "M451.14,280.4l-34.51-19.93c-4.08-2.35-3.57-6.47,1.14-9.19l31.92-18.43c4.72-2.72,11.85-3,15.93-.66l34.51,19.92c4.09,2.36,3.58,6.48-1.14,9.2l-31.91,18.43C462.36,282.46,455.23,282.76,451.14,280.4Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-162",
    d: "M499,260.6,467.08,279c-4.72,2.72-11.85,3-15.94.66l-34.51-19.93a4.94,4.94,0,0,1-2.71-3.48c-.25,1.69.63,3.35,2.71,4.55l34.51,19.93c4.09,2.35,11.22,2.06,15.94-.66L499,261.67c2.82-1.63,4.13-3.76,3.85-5.71C502.6,257.59,501.3,259.26,499,260.6Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-42",
    cx: 125.93,
    cy: 142.44,
    rx: 33.25,
    ry: 19.36
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-163",
    d: "M490.65,247.24h-65V255c0,10.45,14.54,18.92,32.48,18.92s32.48-8.47,32.48-18.92Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-164",
    d: "M490.65,245.81h-65v5.77c0,7.8,14.54,14.12,32.48,14.12s32.48-6.32,32.48-14.12Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-165",
    d: "M497.86,227.9H418.48v10.88c0,12.77,17.77,23.12,39.69,23.12s39.69-10.35,39.69-23.12Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-166",
    cx: 125.93,
    cy: 114.73,
    rx: 39.69,
    ry: 23.11
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-167",
    d: "M458.17,251.08c-21.68,0-39.29-10.13-39.67-22.7,0,.13,0,.27,0,.41,0,12.76,17.77,23.11,39.69,23.11s39.69-10.35,39.69-23.11c0-.14,0-.28,0-.41C497.47,241,479.86,251.08,458.17,251.08Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-168",
    cx: 125.93,
    cy: 115.63,
    rx: 26.83,
    ry: 15.63
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-169",
    cx: 125.93,
    cy: 115.63,
    rx: 26.83,
    ry: 15.63
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-170",
    d: "M458.17,215c14.33,0,26,6.55,26.76,14.78A8.33,8.33,0,0,0,485,229c0-8.63-12-15.62-26.84-15.62s-26.83,7-26.83,15.62c0,.29.05.57.07.86C432.18,221.58,443.85,215,458.17,215Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-171",
    d: "M473.92,175c-.49.1-1.44.18-1.36,2.09s-.36,3.24-.26,3.91a9.45,9.45,0,0,1,.07,2.58c-.13.86-.73,1.55-.48,2s1,.17,1.19-.3a11,11,0,0,0,.43-1.32,8,8,0,0,1-.32,2.57c-.33.52-1,1.1-.6,1.62s1.31-.43,1.57-1a7,7,0,0,0,.37-1.37,9.22,9.22,0,0,1-.35,2.46c-.29.57-1,1.64-.71,1.94s1,0,1.42-.81a4.48,4.48,0,0,0,.33-.78,8.6,8.6,0,0,0-.17,2.1c.15.26.91.47,1.11-.43a43.59,43.59,0,0,0,.71-5.1c.06-1,0-2.77.1-5.1a14.21,14.21,0,0,0-.35-3.94A2.71,2.71,0,0,0,473.92,175Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-172",
    d: "M476.44,180.17c-.07-1.24.41-3.48.18-4a2.71,2.71,0,0,0-2.7-1.12c-.49.1-1.44.18-1.36,2.09a33,33,0,0,1-.27,3.71c.44.23,1.14.26,1.37.86a27.09,27.09,0,0,1,.82,3.62c.12.67,1,.86,1.19.41a13.14,13.14,0,0,0,.16-2.75,18.53,18.53,0,0,1,.62-2.67C476.45,180.26,476.44,180.21,476.44,180.17Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-173",
    d: "M476.75,175.36a1.87,1.87,0,1,1-1.63-2.08A1.86,1.86,0,0,1,476.75,175.36Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-174",
    d: "M470.36,158.15c.18,2,1.35,7.91,1.76,10.08a41.15,41.15,0,0,1,.87,5.64c0,1.23.71,2.22,2.5,1.77s1.41-2.16,1.44-3.64c.05-3.43-1.21-15.59-2.45-18.52C473.79,151.83,469.9,152.91,470.36,158.15Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-175",
    d: "M472.52,158.76c.21,2,1.1,7.67,1.42,9.77s.64,4.08.75,5.47c.1,1.22.44,2.11,1.14,1.43a5.34,5.34,0,0,0,1.08-3.75c-.22-3.42-1.59-15.3-2.3-18.05C474.22,152.09,472,153.63,472.52,158.76Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-176",
    d: "M473.38,155.43a2.32,2.32,0,1,1,.93-3.14A2.32,2.32,0,0,1,473.38,155.43Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-177",
    d: "M470.71,140.45c-1.36,1-3.92-2.16-4.91-3.52a3,3,0,0,1,4.93-3.58C471.72,134.72,472.07,139.46,470.71,140.45Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-178",
    d: "M472.14,135.66c-1-.72-5.36,2.18-5.78,3.05s1.29,7,2.24,10.3c1.07,3.69,1.27,4.77,2.76,5s2.72-.61,2.93-1.32C474.89,150.64,473.35,136.54,472.14,135.66Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-179",
    d: "M472.22,136.91c-.8-.81-4.25.78-4.57,1.43s1.17,6.26,2,9.26c.93,3.37,1.11,4.34,2.31,4.79s2.16,0,2.31-.53C474.7,150.27,473.2,137.91,472.22,136.91Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-180",
    d: "M448,237.27c9.95,4.15,14.86.85,22.33-3.47s8.32-8.57,2.58-11.26c-10.84-5.08-17,.05-24.49,4.36S442.19,234.82,448,237.27Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-181",
    d: "M460.53,220.22a3.45,3.45,0,0,0-2.3,2.84c-.26,1.59-.1,3.6,2.39,3.76s4,.54,5.42,1.63,6,1.75,7,.51-.48-2.07-1.79-2.87a19.3,19.3,0,0,1-4.84-3.86,4.74,4.74,0,0,0-2.81-1.95A5.69,5.69,0,0,0,460.53,220.22Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-182",
    d: "M462.44,221.23a2.6,2.6,0,0,0-1.7,2.11c-.19,1.19-.07,2.68,1.77,2.8a6.75,6.75,0,0,1,4,1.21c1.07.8,4.43,1.3,5.24.38s-.36-1.54-1.33-2.14a14.26,14.26,0,0,1-3.6-2.86,3.42,3.42,0,0,0-2.08-1.45A4.3,4.3,0,0,0,462.44,221.23Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-183",
    d: "M463.14,197c-.65,1.09-.89,3.64-1.53,6.7s-2.07,7.24-1.85,11.16-.67,6.18-.1,6.79a2.26,2.26,0,0,0,2.72.22c.95-.57,1.59-1,1.33-1.56s-1.49-2.71-.44-7.4,2.55-11,3.09-11.54,1.18-.41,1.85-1.4S464.29,195,463.14,197Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-184",
    d: "M459.1,219.07c.73.88,3.74.25,4.33-.39s2-7.9,3.2-12c1.06-3.67,2.36-6.71,1.82-7.55s-2.9-4-5.22-2.86-2.9,6.9-3.49,10.74S458.36,218.18,459.1,219.07Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-185",
    d: "M460.85,219c.35.8,2,.35,2.35-.19s1.53-6.84,2.4-10.39c.78-3.18,1.66-5.79,1.42-6.54s-1.34-3.59-2.65-2.68-1.95,5.93-2.49,9.27S460.51,218.16,460.85,219Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-186",
    d: "M449.59,226.07a4.67,4.67,0,0,0-1.09,4.56,16.48,16.48,0,0,0,3.16,5.39c1.25,1.18,2.81,3,5.52,2s.22-4.94-.58-6a10.92,10.92,0,0,1-2-4.12c-.22-1.37-.83-1.66-1.56-1.72S450.32,225.24,449.59,226.07Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-187",
    d: "M450.35,227.33a3.4,3.4,0,0,0-1,3.59,12.74,12.74,0,0,0,2.75,4.25c1.09.93,2.45,2.34,4.82,1.56s.19-3.9-.5-4.7a8.14,8.14,0,0,1-1.79-3.24c-.19-1.08-.72-1.31-1.36-1.36S451,226.67,450.35,227.33Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-188",
    d: "M451.22,203.35a32.1,32.1,0,0,0-1.28,8.77c-.16,3.73.06,9.27.1,10.9a18.5,18.5,0,0,1-.29,3,1.72,1.72,0,0,0,2.2,1.59c1.47-.44,2.29-1.34,2-2.16a21.76,21.76,0,0,1-.74-9.12c.58-4.72,1.44-8.23,1.76-8.71s1.08-1.05,1.34-1.69S452.59,199.81,451.22,203.35Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-189",
    d: "M449.34,224.3c1,.84,3.89.59,4.53-.19s1.55-8.18,2.12-11.53c.49-2.91,1.82-6,.49-6.84s-3.07-3.27-5.26-2.39c-1.31.52-2.12,11-2.12,13.37C449.1,220.56,449.34,224.3,449.34,224.3Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-190",
    d: "M451.19,223.6a1.61,1.61,0,0,0,2.31-.1c.34-.63.5-7.42,1-9.66s1.3-4.31.64-5-1.51-2.66-2.64-2c-.67.4-1.28,8.78-1.33,10.7C451.13,220.6,451.19,223.6,451.19,223.6Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-191",
    d: "M469,197.54a2.89,2.89,0,1,1-2.88-2.88A2.88,2.88,0,0,1,469,197.54Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-192",
    d: "M463.42,195.3a3.58,3.58,0,0,0,3.4,3.4c2,0,3.14-2,3.23-3.4s-1.53-28.48-2.55-31.29-3.91-5.87-7.74-4.17-3.91,6.3-2.21,10.29a81.06,81.06,0,0,1,4.25,14.37C462.31,187.73,463.42,193.52,463.42,195.3Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-193",
    d: "M465.66,194.45c0,1.26.71,3,1.76,3s1.63-1.78,1.68-3-.8-24.88-1.32-27.33-2-5.12-4-3.64-2,5.5-1.15,9a109.19,109.19,0,0,1,2.2,12.55C465.09,187.84,465.66,192.89,465.66,194.45Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-194",
    d: "M459.68,173.28a8.62,8.62,0,0,0,5.95-6.89c.37-2.19,1.36-14.45,1.36-14.45s-14.37.68-15.22,1.61.4,6-1.58,11.25C448.52,169.24,455.82,174.56,459.68,173.28Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-195",
    d: "M464,130c1.45-.05,4.72.17,5.66,2.33s-.94,5.66-.94,5.66,1.62,3.78,1,6.46-.64,3.06-.6,3.32,1.41,4.46.26,4.72a8.2,8.2,0,0,0-2.47.38c-.89.42-1.35,1.59-2.93,2.64-1.84,1.23-8.87,4.38-10.76,4.29-4.38-.21-5.61-5.7-6.71-9-.93-2.79-1.75-6.68-1.75-6.68s-2.76-.42-2.68-2.34,2.41-3.49,4.62-5.36a50.25,50.25,0,0,1,5.76-4.25C453.72,131.36,461.38,130,464,130Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-196",
    d: "M463.53,130.55c1.31-.05,4.28.15,5.13,2.11s-.85,5.13-.85,5.13a13.15,13.15,0,0,1,1.7,5.23,9.24,9.24,0,0,1-.59,3.54c0,.23-4.71,2.67-6.36,3.18-4.28,1.33-8.82-.1-9.82-3.1-.84-2.53-6.65-3.31-6.65-3.31s-2.51-.38-2.43-2.12,2.18-3.16,4.18-4.85a43.72,43.72,0,0,1,5.22-3.85C454.21,131.82,461.15,130.62,463.53,130.55Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-197",
    d: "M457.61,203.82a2.89,2.89,0,1,1-2.89-2.88A2.89,2.89,0,0,1,457.61,203.82Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-198",
    d: "M451.56,204c1,.68,5-.26,6.16-.39a1.75,1.75,0,0,0,1.4-1.87,145,145,0,0,1-.63-15c.17-6.71,1.57-12,0-16.07-1.67-4.2-5.33-7-8.72-6s-4.2,4.75-3.86,8.91c.4,4.84,5.64,18.8,5.73,23S450.49,203.29,451.56,204Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-199",
    d: "M453.73,203.23c.64.65,3.19-.25,3.92-.37s.92-1.35.9-1.8-.52-8-.41-14.44,1-11.57,0-15.43c-1.06-4-3.39-6.77-5.55-5.79S449.9,170,450.12,174c.25,4.65,3.59,18.05,3.64,22.05S453.06,202.53,453.73,203.23Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-200",
    d: "M455.93,114.57c-1.9,1-3.48,3.44-2.16,6.76s1.63,6,1.26,7.36a44.83,44.83,0,0,1-1.7,4.36s2.69,2.14,5.41,1.8,3.44-1.58,3.44-1.58S463.42,110.61,455.93,114.57Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-201",
    d: "M455.34,124.6a4.88,4.88,0,0,0,2.29,4c1.71,1.14,4.72,3.35,6.68,2.29s2.59-6.79,2.64-8.84c0-2.29-.51-6.08-3.11-7.57a7.32,7.32,0,0,0-5.27-1,8.24,8.24,0,0,0-3.32,2.17c-.72.72.05,2.89.39,4.42S455.34,123.83,455.34,124.6Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-202",
    d: "M458.09,124.18a4.73,4.73,0,0,0,1.65,3.59c1.23,1,3.4,3,4.81,2.07s1.87-6.1,1.9-8c0-2.06-.36-5.46-2.23-6.79a4.38,4.38,0,0,0-3.8-.92,5.94,5.94,0,0,0-2.39,1.95c-.53.65,0,2.59.27,4A19.27,19.27,0,0,1,458.09,124.18Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-203",
    d: "M453.21,159.76c1.89.09,8.92-3.06,10.76-4.29,1.58-1.05,2-2.22,2.93-2.64a8.2,8.2,0,0,1,2.47-.38c1.15-.26-.21-4.47-.26-4.72a.22.22,0,0,0,0-.08h0v-.11h0a3,3,0,0,1,0-.35l-1.24.68a28.38,28.38,0,0,1-7.62,3.13c-3.47.81-5.87.19-8-3.84-1.49-2.85-5.62-2.48-7.52-3h0c.13.64.88,4,1.72,6.57C447.6,154.06,448.83,159.55,453.21,159.76Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-204",
    d: "M464.26,151.58c1.74-.9,4.35-2,5.16-2.69-.15-.62-.29-1.08-.31-1.16a2.2,2.2,0,0,1,0-.55l-1.24.68a28.38,28.38,0,0,1-7.62,3.13c-3.47.81-5.87.19-8-3.84-1.49-2.85-5.62-2.48-7.52-3,.13.64.88,4,1.72,6.57.78,2.34,1.63,5.75,3.6,7.64a6.6,6.6,0,0,0,.28-2.35c-.2-4.29,1.11-6.3,1.11-6.3S453.92,157,464.26,151.58Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-205",
    d: "M441.14,184.47c-.82.2-1.19.46-1.11,1.27s0,3.76-.07,5a15,15,0,0,0,1,4.13,4.22,4.22,0,0,0,.56,1.74c.46.61.79.41.93.27s.11-.68,0-1a13.28,13.28,0,0,1-.16-1.82s.53,2,.71,2.79.7,1.51,1.19,1.55a.58.58,0,0,0,.63-.63,8.34,8.34,0,0,1-.47-1.6c0-.51-.05-1.35-.05-1.35a11.67,11.67,0,0,0,.66,2.77c.22.49.7,2.27,1.57,1.83.65-.33-.15-1.92-.28-2.39a16.29,16.29,0,0,1-.26-5.25c.17-1.1.56-1.54,1.59-.6s2,1.54,2.21,1-.73-1.72-1.35-2.46a13.26,13.26,0,0,0-2.45-2.12c-1.52-.93-1.55-2.67-2.54-3.18A3.13,3.13,0,0,0,441.14,184.47Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-206",
    d: "M441.14,184.47c-.82.2-1.19.46-1.11,1.27s0,3.76-.07,5a15,15,0,0,0,1,4.13,4.22,4.22,0,0,0,.56,1.74c.46.61.79.41.93.27s.11-.68,0-1a13.28,13.28,0,0,1-.16-1.82s.53,2,.71,2.79.7,1.51,1.19,1.55a.58.58,0,0,0,.63-.63,8.34,8.34,0,0,1-.47-1.6c0-.51-.05-1.35-.05-1.35a11.67,11.67,0,0,0,.66,2.77c.22.49.7,2.27,1.57,1.83.65-.33-.15-1.92-.28-2.39a16.29,16.29,0,0,1-.26-5.25c.17-1.1.56-1.54,1.59-.6s2,1.54,2.21,1-.73-1.72-1.35-2.46a13.26,13.26,0,0,0-2.45-2.12c-1.52-.93-1.55-2.67-2.54-3.18A3.13,3.13,0,0,0,441.14,184.47Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-207",
    d: "M443.52,184.61a1.78,1.78,0,1,1-1.91-1.63A1.77,1.77,0,0,1,443.52,184.61Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-208",
    d: "M439.66,160.7a3.16,3.16,0,0,0-1.82,2.1c-.55,1.68.92,17.59,1.18,19.17s.65,3.64,2.47,3.44,2.38-1.24,2.32-2.35c-.07-1.49-.18-9.07.16-13.63.31-4.23.22-5.81-.26-6.75C443.31,161.93,441.23,160.09,439.66,160.7Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-209",
    d: "M440.56,163.13a2.33,2.33,0,0,0-1.18,1.73c-.34,1.41.87,14.79,1.06,16.12s.49,3.07,1.69,2.93a1.63,1.63,0,0,0,1.51-1.94c-.07-1.25-.25-7.62-.1-11.45.15-3.54.07-4.87-.27-5.67C443,164.21,441.59,162.64,440.56,163.13Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-210",
    d: "M442.78,143.28a7.38,7.38,0,0,0,3.21,1c1,0,2.33.41,2.44,1.35s-1.46,1.33-1.9,5.54-2.08,2.4-3.25-.53C442,147.55,442.22,144.13,442.78,143.28Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-211",
    d: "M443.26,162.07a2.31,2.31,0,1,1-1.74-2.77A2.33,2.33,0,0,1,443.26,162.07Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-212",
    d: "M439,159.73c0,.77,1.42,1.31,2.77,1.86s2.26.37,2.33-.34,1.67-6.52,2.37-8.59c.78-2.3,2.16-4,1-5.13s-4.33-3.77-5.82-3S439,158.72,439,159.73Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-213",
    d: "M440.79,159.06c-.05.67.8,1.2,1.62,1.73s1.4.41,1.49-.21,1.51-5.63,2.1-7.42c.65-2,1.64-3.45,1-4.45s-2.47-3.45-3.46-2.84S440.85,158.18,440.79,159.06Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-214",
    d: "M460.46,126.15c-.38-3.09.19-8.71-2.16-10.21a3.76,3.76,0,0,0-3.1-.24c-.62.77.11,2.86.44,4.35s-.3,3.78-.3,4.55a4.88,4.88,0,0,0,2.29,4c1.23.83,3.15,2.21,4.86,2.51C462.09,130.17,460.77,128.76,460.46,126.15Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-215",
    cx: 105.56,
    cy: 149.61,
    rx: 14.5,
    ry: 27.75
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-216",
    d: "M574.27,333.87H523.68v7.8c0,8.14,11.33,14.73,25.3,14.73s25.29-6.59,25.29-14.73a1.34,1.34,0,0,0,0-.2h0Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-217",
    cx: 216.73,
    cy: 220.64,
    rx: 25.3,
    ry: 14.73
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-218",
    d: "M549,348.64c-13.82,0-25.05-6.45-25.29-14.47,0,.09,0,.18,0,.27,0,8.13,11.33,14.73,25.3,14.73s25.29-6.6,25.29-14.73c0-.09,0-.18,0-.27C574,342.19,562.8,348.64,549,348.64Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-219",
    d: "M572.53,326.05H525.42v6.43h0c0,.07,0,.13,0,.19,0,7.58,10.55,13.72,23.56,13.72s23.55-6.14,23.55-13.72v-.19h0Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-220",
    d: "M572.53,324.93H525.42v6.44h0c0,.06,0,.12,0,.19,0,7.57,10.55,13.71,23.56,13.71s23.55-6.14,23.55-13.71v-.19h0Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-221",
    d: "M574.27,320H523.68v7.81c0,8.13,11.33,14.73,25.3,14.73s25.29-6.6,25.29-14.73a1.48,1.48,0,0,0,0-.21h0Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-222",
    cx: 216.73,
    cy: 206.8,
    rx: 25.3,
    ry: 14.73
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-223",
    d: "M549,334.8c-13.82,0-25.05-6.46-25.29-14.47,0,.09,0,.17,0,.26,0,8.14,11.33,14.73,25.3,14.73s25.29-6.59,25.29-14.73c0-.09,0-.17,0-.26C574,328.34,562.8,334.8,549,334.8Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-224",
    d: "M572.53,312.2H525.42v6.44h0c0,.06,0,.12,0,.19,0,7.57,10.55,13.72,23.56,13.72s23.55-6.15,23.55-13.72v-.19h0Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-225",
    d: "M572.53,311.09H525.42v6.43h0c0,.07,0,.13,0,.19,0,7.58,10.55,13.72,23.56,13.72s23.55-6.14,23.55-13.72v-.19h0Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-226",
    d: "M574.27,306.56H523.68v7.81c0,8.13,11.33,14.73,25.3,14.73s25.29-6.6,25.29-14.73a1.27,1.27,0,0,0,0-.2h0Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-227",
    cx: 216.73,
    cy: 193.34,
    rx: 25.3,
    ry: 14.73
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-228",
    d: "M549,321.34c-13.82,0-25.05-6.46-25.29-14.47,0,.09,0,.18,0,.26,0,8.14,11.33,14.73,25.3,14.73s25.29-6.59,25.29-14.73c0-.08,0-.17,0-.26C574,314.88,562.8,321.34,549,321.34Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-229",
    d: "M572.53,298.74H525.42v6.44h0c0,.06,0,.13,0,.19,0,7.58,10.55,13.72,23.56,13.72s23.55-6.14,23.55-13.72v-.19h0Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-230",
    d: "M572.53,297.63H525.42v6.43h0c0,.07,0,.13,0,.19C525.42,311.83,536,318,549,318s23.55-6.14,23.55-13.72v-.19h0Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-231",
    d: "M574.27,293H523.68v7.8c0,8.14,11.33,14.73,25.3,14.73s25.29-6.59,25.29-14.73a1.27,1.27,0,0,0,0-.2h0Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-232",
    cx: 216.73,
    cy: 179.73,
    rx: 25.3,
    ry: 14.73
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-233",
    d: "M549,307.73c-13.82,0-25.05-6.45-25.29-14.47,0,.09,0,.18,0,.27,0,8.13,11.33,14.73,25.3,14.73s25.29-6.6,25.29-14.73c0-.09,0-.18,0-.27C574,301.28,562.8,307.73,549,307.73Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-234",
    d: "M572.53,285.13H525.42v6.44h0c0,.06,0,.13,0,.19,0,7.58,10.55,13.72,23.56,13.72s23.55-6.14,23.55-13.72v-.19h0Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-235",
    d: "M572.53,284H525.42v6.44h0c0,.06,0,.12,0,.19,0,7.57,10.55,13.71,23.56,13.71s23.55-6.14,23.55-13.71v-.19h0Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-236",
    d: "M574.27,279.35H523.68v7.8c0,8.14,11.33,14.73,25.3,14.73s25.29-6.59,25.29-14.73a1.34,1.34,0,0,0,0-.2h0Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-237",
    cx: 216.73,
    cy: 166.12,
    rx: 25.3,
    ry: 14.73
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-238",
    d: "M549,294.12c-13.82,0-25.05-6.45-25.29-14.47,0,.09,0,.18,0,.27,0,8.13,11.33,14.73,25.3,14.73s25.29-6.6,25.29-14.73c0-.09,0-.18,0-.27C574,287.67,562.8,294.12,549,294.12Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-239",
    cx: 218.66,
    cy: 165.07,
    rx: 12.8,
    ry: 6.53
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-240",
    d: "M559.1,274.57H538.85v4c0,3.26,4.54,5.9,10.13,5.9s10.12-2.64,10.12-5.9v-.08h0Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-241",
    cx: 216.73,
    cy: 161.28,
    rx: 10.12,
    ry: 5.89
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-242",
    d: "M542.61,274.63c0,2.05,2.85,3.71,6.37,3.71s6.37-1.66,6.37-3.71-2.86-3.7-6.37-3.7S542.61,272.59,542.61,274.63Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-243",
    d: "M549,274.44a7.86,7.86,0,0,1,5.61,1.95,2.6,2.6,0,0,0,.76-1.76c0-2-2.86-3.7-6.37-3.7s-6.37,1.66-6.37,3.7a2.55,2.55,0,0,0,.76,1.76A7.82,7.82,0,0,1,549,274.44Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-244",
    d: "M549,280.48c-5.53,0-10-2.58-10.12-5.79,0,0,0,.07,0,.11,0,3.25,4.54,5.89,10.13,5.89s10.12-2.64,10.12-5.89a.41.41,0,0,0,0-.11C559,277.9,554.51,280.48,549,280.48Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-245",
    cx: 203.23,
    cy: 205.9,
    rx: 9.75,
    ry: 34.04
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-246",
    d: "M405.57,321.25H332.25v6.46h0c0,.1,0,.19,0,.29,0,11.79,16.41,21.35,36.66,21.35s36.66-9.56,36.66-21.35c0-.1,0-.19,0-.29h0Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-247",
    cx: 36.66,
    cy: 208.08,
    rx: 36.66,
    ry: 21.35
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-248",
    d: "M368.91,342.66c-20,0-36.3-9.35-36.65-21,0,.12,0,.25,0,.38,0,11.79,16.41,21.35,36.66,21.35s36.66-9.56,36.66-21.35c0-.13,0-.26,0-.38C405.2,333.31,388.93,342.66,368.91,342.66Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-249",
    d: "M402.75,311.54H335.06v8.8h0c0,.09,0,.18,0,.27,0,10.88,15.15,19.71,33.85,19.71s33.84-8.83,33.84-19.71c0-.09,0-.18,0-.27h0Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-250",
    cx: 36.66,
    cy: 198.36,
    rx: 33.84,
    ry: 19.71
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-251",
    cx: 36.66,
    cy: 198.36,
    rx: 30,
    ry: 17.47
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-252",
    d: "M368.91,331.31c-18.49,0-33.51-8.64-33.83-19.36,0,.12,0,.24,0,.36,0,10.88,15.15,19.7,33.85,19.7s33.84-8.82,33.84-19.7c0-.12,0-.24,0-.36C402.41,322.67,387.39,331.31,368.91,331.31Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-253",
    cx: 39.78,
    cy: 200.11,
    rx: 30.46,
    ry: 14.53
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-254",
    d: "M350.9,317.19c-1.47.67-2.3.76-3.5.08s-3.74-1.28-3.66-4.26-1.07-4.39-1.11-7.5c0-3.31,2.05-5.37,2.73-6.39s2-6,4.18-7.33,5.53-2.64,6.13-3.58,6.65-4.09,9.89-4.94,14.57-1.19,16.7.94,4.18.42,4.77,3.15,2.14,11.57-12.56,19.08A255.78,255.78,0,0,1,350.9,317.19Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-255",
    d: "M348.64,317.14c-1.49-1.05-2-4.21-1.15-5.49a25.53,25.53,0,0,0,1.92-3.84s-1.79.39-1.92-.51a12.58,12.58,0,0,1,.51-3.2s.51,2,1.28,1.41,1.92,1.92,2,.77,1-4.48,1.92-5.37a17.14,17.14,0,0,0,2.05-3.07,3.17,3.17,0,0,1,2.17-.77c1.41,0,3.45-1.27,3.58-2.68s.77-3.32,1.53-3.71,2.43-2.17,2.05-3.07a5.08,5.08,0,0,1-.38-1.78s2.17.89,1.66,2a13.34,13.34,0,0,0-.77,2.56s.38.51,2.17-.13a8.92,8.92,0,0,0,3.33-2.69,25.36,25.36,0,0,0,3.07-.38c1.15-.25,1.4-2,3.7-1.79s3.07.07,5.37.19,5.5.9,5.24,5.5-8.95,15.28-20.45,20.64S350.81,318.68,348.64,317.14Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-256",
    d: "M350.05,317.61c-3.47-1.28-2.05-5.88-1.2-6.9s2.13-2.47,2.13-2.47a5.15,5.15,0,0,1-.85-.94,3.27,3.27,0,0,0-1.11-.85l2,1.11s.69.34,1-.52,1.13-7.17,4.49-8.62c2-.87,5.39-2.28,5.73-2.79a12.4,12.4,0,0,0,.77-2.82,18.59,18.59,0,0,1,1.53-3l-.59,3a13.75,13.75,0,0,0,4.94-2.21,18.36,18.36,0,0,1,5.62-3,53.31,53.31,0,0,1,6.61-1.53c3.24-.45,18.88,4.35,0,16.11S355.59,319.66,350.05,317.61Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-255",
    d: "M357.72,294.43s-2.48-1.19-2.13-2.38a12.75,12.75,0,0,0,.42-2.22s2.64-1.45,3.24-.85,2-1.28,2-1.28h-2.64a16.25,16.25,0,0,0-2.89.5h0a5.45,5.45,0,0,1-1.8,1.29c.41.53,1.48,2,.44,3.31S357.72,294.43,357.72,294.43Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-256",
    d: "M355.69,293.63a2.33,2.33,0,0,1-1-.42l.05-.07a2.51,2.51,0,0,0,.37-.59A2.13,2.13,0,0,0,355.69,293.63Zm-.44-2.32a3.94,3.94,0,0,0-.63-1.65,5.07,5.07,0,0,0,1.36-1,14.55,14.55,0,0,1,2.59-.44h1.51a1.62,1.62,0,0,1-.51.37,1.13,1.13,0,0,0-.78-.26,8.5,8.5,0,0,0-3,1.06l-.24.13,0,.28A13.12,13.12,0,0,1,355.25,291.31Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-255",
    d: "M347.92,297.84a3.12,3.12,0,0,1-1.72-.65,14.17,14.17,0,0,1-.84,1.93c-.14.21-.35.48-.58.78l3.48-.52a8.77,8.77,0,0,1,.25,1.53c.09.94,2,1.7,2,1.7a5.92,5.92,0,0,1-.59-1.87,17.08,17.08,0,0,0,0-3.58c-.26-.94-.66-3-.66-3S348.68,297.76,347.92,297.84Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-256",
    d: "M349.48,301.45a1.06,1.06,0,0,1-.46-.59,10,10,0,0,0-.27-1.63l-.13-.43s-2.65.6-2.41-.58a3.71,3.71,0,0,0,1.59.14H348c.4,0,.42-.32.93-1,0,0,.24-.72.25-.7a15.35,15.35,0,0,1,.26,3.21c0,.34-.05.63-.05.84A2.78,2.78,0,0,0,349.48,301.45Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-255",
    d: "M369.14,284.12c-.37.1-.52,2.22-.52,2.22a2.4,2.4,0,0,1,2.05-1.62,6.6,6.6,0,0,0,3.07-1.54A39.91,39.91,0,0,0,369.14,284.12Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-257",
    d: "M369,285.24c.08-.44.74-.76.82-.86,1.25-.35,2.05-.63,2.95-.79a5.43,5.43,0,0,1-2.14.87A2.9,2.9,0,0,0,369,285.24Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-255",
    d: "M353.92,315.31s-6.39.38-7.37-.6-.64-5.92-.64-5.92a1.08,1.08,0,0,1-1.53.68,3.11,3.11,0,0,1-1.54-1.89c.33,1.85,1,3.2.9,5.43-.08,3,2.47,3.58,3.66,4.26s2,.59,3.5-.08c.52-.24,1.44-.6,2.8-1.15Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-258"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-259",
    d: "M346.21,301.1c-1-.23-2.68.9-3.24,2.77s0,4.05,1,4.09,1.88.13,2.39,1,.94-1,.38-2.64-1.87-2.17-1-2.77S347.79,301.44,346.21,301.1Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-260",
    d: "M346.15,301.24c.9.21.79.88.37,1.47a4,4,0,0,1-.9.9l-.17.14c-.39.47.35.95.87,2a3.82,3.82,0,0,1,.24.54,4.76,4.76,0,0,1,.27,1.57c0,.89-.26,1.49-.57,1a2.51,2.51,0,0,0-2.31-1c-.87-.05-1.45-2.12-.91-3.92a3.55,3.55,0,0,1,2.78-2.69.33.33,0,0,1,.14,0Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-261",
    d: "M346.08,301.39c.81.2.68.83.27,1.39a4.62,4.62,0,0,1-.85.86,1.06,1.06,0,0,0-.15.15c-.37.46.32.92.82,1.86a5.06,5.06,0,0,1,.23.52,4.66,4.66,0,0,1,.28,1.48c0,.83-.22,1.4-.5,1a2.52,2.52,0,0,0-2.24-.91c-.8-.06-1.35-2-.84-3.76a3.43,3.43,0,0,1,2.67-2.58h.13Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-262",
    d: "M346,301.53c.72.2.58.8.17,1.32a5.21,5.21,0,0,1-.8.82.64.64,0,0,0-.14.15c-.33.45.3.9.77,1.77a4.48,4.48,0,0,1,.23.49,4.43,4.43,0,0,1,.29,1.4c0,.77-.18,1.31-.42.95a2.49,2.49,0,0,0-2.17-.85c-.74-.07-1.27-1.93-.78-3.6a3.31,3.31,0,0,1,2.55-2.48h.13Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-263",
    d: "M346,301.67c.61.2.46.77.06,1.26a8,8,0,0,1-.75.78.57.57,0,0,0-.13.14c-.3.45.29.89.73,1.69a4.71,4.71,0,0,1,.22.45,4.21,4.21,0,0,1,.3,1.31c.05.72-.14,1.22-.35.94a2.51,2.51,0,0,0-2.1-.79c-.67-.08-1.18-1.84-.71-3.43a3.15,3.15,0,0,1,2.44-2.38h.12Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-264",
    d: "M345.88,301.82c.52.19.36.73,0,1.18l-.71.74a.75.75,0,0,0-.12.14c-.26.45.27.87.69,1.6q.1.19.21.42a4.28,4.28,0,0,1,.31,1.23c.06.66-.1,1.13-.28.93a2.5,2.5,0,0,0-2-.74c-.6-.09-1.09-1.74-.63-3.26a3,3,0,0,1,2.32-2.28h.11A.65.65,0,0,1,345.88,301.82Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-265",
    d: "M345.82,302c.42.19.24.7-.14,1.11l-.66.7a.53.53,0,0,0-.1.14c-.24.44.24.85.63,1.51a3.55,3.55,0,0,1,.2.39,3.68,3.68,0,0,1,.33,1.15c.07.59-.06,1-.21.91a2.54,2.54,0,0,0-1.95-.68c-.54-.09-1-1.64-.57-3.1a2.87,2.87,0,0,1,2.2-2.17h.11Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-266",
    d: "M345.75,302.11c.33.18.14.66-.24,1a7.13,7.13,0,0,0-.61.67.42.42,0,0,0-.09.14c-.2.43.23.82.59,1.42l.19.35a3.71,3.71,0,0,1,.34,1.07c.08.53,0,.95-.13.9a2.59,2.59,0,0,0-1.89-.63c-.47-.1-.91-1.54-.5-2.93a2.72,2.72,0,0,1,2.09-2.06h.1Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-267",
    d: "M345.69,302.25c.23.18,0,.63-.35,1a4.59,4.59,0,0,0-.57.62l-.07.14c-.17.43.21.8.54,1.33a2.59,2.59,0,0,1,.19.33,3.27,3.27,0,0,1,.35,1c.08.47,0,.86-.06.88a2.69,2.69,0,0,0-1.81-.57c-.41-.11-.83-1.45-.44-2.76a2.6,2.6,0,0,1,2-2h.11A.49.49,0,0,1,345.69,302.25Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-268",
    d: "M345.62,302.39c.14.17-.08.59-.45.9a2.35,2.35,0,0,0-.52.59l-.06.13c-.14.42.2.78.5,1.24l.18.3a3.26,3.26,0,0,1,.36.9,1.75,1.75,0,0,1,0,.87,2.66,2.66,0,0,0-1.74-.51c-.34-.13-.73-1.36-.37-2.61a2.46,2.46,0,0,1,1.86-1.85h.1Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-269",
    d: "M345.56,302.54c0,.16-.2.55-.56.82a1.61,1.61,0,0,0-.47.55s0,.09,0,.13c-.1.42.18.76.46,1.16l.17.26a2.93,2.93,0,0,1,.37.82,2.64,2.64,0,0,1,.09.85,2.9,2.9,0,0,0-1.68-.45,2.65,2.65,0,0,1-.29-2.44,2.33,2.33,0,0,1,1.74-1.75h.09A.33.33,0,0,1,345.56,302.54Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-270",
    d: "M345.49,307a3,3,0,0,0-1.6-.4,2.64,2.64,0,0,1-.23-2.27,2.18,2.18,0,0,1,1.62-1.65h.09l.12,0a1.76,1.76,0,0,1-.66.75,1,1,0,0,0-.45.64,1.39,1.39,0,0,0,.4,1.07,3.43,3.43,0,0,1,.55,1A3,3,0,0,1,345.49,307Z",
    transform: "translate(-332.25 -113.32)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-258"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-271",
    d: "M351,302.48c.73.45,2.23-4.73,3.95-4.89s3.43-1.09,3.64-1.58c.11-.24-1.08-.43-2.33-.72s-2.54-.66-2.65-1.28c-.21-1.24.29-3.67-.89-3.46s-3,3.92-2.56,5.69S349.55,301.62,351,302.48Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-272",
    d: "M352.58,291c1.09-.18.65,2.05.87,3.19.1.51,1.08.85,2.11,1.11l.35.08c1.14.26,2.24.44,2.15.67a4.27,4.27,0,0,1-2.13,1.2,7.36,7.36,0,0,1-1.24.25,1.61,1.61,0,0,0-.95.59c-1.18,1.3-2.17,4.23-2.72,3.93s-.74-1.62-.7-2.87a12.94,12.94,0,0,0-.06-2.9C349.87,294.6,351.51,291.21,352.58,291Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-273",
    d: "M352.5,291.42c1-.14.62,1.88.84,2.93.1.47,1,.78,1.94,1l.32.07c1,.25,2,.42,2,.62a4,4,0,0,1-2,1.09,6,6,0,0,1-1.13.24,1.49,1.49,0,0,0-.87.54c-1.1,1.19-2,3.85-2.52,3.6-.62-.41-.66-1.49-.63-2.63a12.07,12.07,0,0,0,0-2.66C350.06,294.73,351.53,291.65,352.5,291.42Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-274",
    d: "M352.41,291.85c.91-.1.59,1.72.82,2.67.1.42.92.71,1.77.93l.29.07c.94.22,1.84.38,1.8.57a3.85,3.85,0,0,1-1.79,1,5.89,5.89,0,0,1-1,.22,1.38,1.38,0,0,0-.8.5c-1,1.07-1.83,3.46-2.31,3.27-.55-.39-.58-1.37-.55-2.4a11.88,11.88,0,0,0,0-2.42C350.25,294.86,351.56,292.08,352.41,291.85Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-275",
    d: "M352.33,292.28c.81,0,.56,1.56.79,2.41.11.38.83.64,1.6.84l.26.06c.84.21,1.65.35,1.63.52A3.67,3.67,0,0,1,355,297a7,7,0,0,1-.93.21,1.28,1.28,0,0,0-.72.44c-.9,1-1.66,3.08-2.1,2.94-.48-.36-.51-1.24-.48-2.16a10.33,10.33,0,0,0,0-2.18C350.44,295,351.59,292.52,352.33,292.28Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-276",
    d: "M352.25,292.71c.71,0,.52,1.4.76,2.15.11.34.75.57,1.43.75l.23.06c.74.18,1.45.31,1.45.46a3.41,3.41,0,0,1-1.45.77,4.78,4.78,0,0,1-.83.2,1.13,1.13,0,0,0-.64.4c-.81.84-1.49,2.69-1.89,2.61-.41-.34-.44-1.11-.41-1.93a9.42,9.42,0,0,0,0-1.94C350.64,295.12,351.61,293,352.25,292.71Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-277",
    d: "M352.16,293.14c.62,0,.5,1.24.74,1.89.11.29.67.5,1.26.66l.2.06c.64.16,1.25.27,1.28.41a3.45,3.45,0,0,1-1.29.66,4.46,4.46,0,0,1-.72.18,1.1,1.1,0,0,0-.57.35c-.71.74-1.31,2.31-1.68,2.28-.34-.31-.36-1-.34-1.69a8.59,8.59,0,0,0,0-1.7A4.1,4.1,0,0,1,352.16,293.14Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-278",
    d: "M352.08,293.57c.52.07.47,1.08.71,1.63.11.25.59.43,1.09.57l.17.05c.53.14,1.05.24,1.11.36a3.66,3.66,0,0,1-1.12.56c-.21.06-.42.12-.63.16a1,1,0,0,0-.48.31c-.63.62-1.15,1.92-1.48,2a2.17,2.17,0,0,1-.26-1.46,8.79,8.79,0,0,0,0-1.47A3.77,3.77,0,0,1,352.08,293.57Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-279",
    d: "M352,294c.44.1.44.9.69,1.36.11.21.51.36.92.48l.14,0a2.88,2.88,0,0,1,.93.31,4.26,4.26,0,0,1-.95.45l-.52.15a.86.86,0,0,0-.41.25c-.53.51-1,1.54-1.27,1.63a2.07,2.07,0,0,1-.19-1.23,6.23,6.23,0,0,0,0-1.23A3.48,3.48,0,0,1,352,294Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-280",
    d: "M351.91,294.44c.34.14.41.74.66,1.1a1.58,1.58,0,0,0,.75.39l.11,0a3.72,3.72,0,0,1,.76.26,5.2,5.2,0,0,1-.78.34l-.42.14a.83.83,0,0,0-.34.21c-.43.39-.8,1.15-1.06,1.29a2,2,0,0,1-.11-1,8.15,8.15,0,0,0,0-1A3.38,3.38,0,0,1,351.91,294.44Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-281",
    d: "M351.82,294.87c.25.19.39.58.64.84a1.57,1.57,0,0,0,.58.3l.08,0c.23.08.46.14.58.2-.15.06-.38.16-.61.24l-.32.12a.88.88,0,0,0-.25.16c-.34.28-.63.77-.86,1a3,3,0,0,1,0-.76,6.36,6.36,0,0,0,0-.75A4.68,4.68,0,0,1,351.82,294.87Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-270",
    d: "M351.74,297.26l0-.52c0-.18,0-.35,0-.51a9.11,9.11,0,0,0,0-.93,2,2,0,0,0,.61.58,3.14,3.14,0,0,0,.41.22l.46.18a2.13,2.13,0,0,0-.45.13,2.42,2.42,0,0,0-.39.21A2.78,2.78,0,0,0,351.74,297.26Z",
    transform: "translate(-332.25 -113.32)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-258"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-282",
    d: "M359.89,293.81c-.79.17-2-2.81-1.41-3.36s2.22-.3,2.82-1.19,1.19-3.33,2-2.86-.77,2.34-1.41,4.22S361.34,293.52,359.89,293.81Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-283",
    d: "M359.9,293.68c-.73.12-1.85-2.62-1.31-3.15s2-.28,2.58-1.09,1.11-3,1.91-2.61-.7,2.14-1.29,3.85S361.23,293.39,359.9,293.68Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-284",
    d: "M359.92,293.54c-.68.08-1.7-2.42-1.22-2.93s1.84-.25,2.34-1,1-2.73,1.77-2.35-.63,1.93-1.16,3.47S361.12,293.27,359.92,293.54Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-285",
    d: "M359.93,293.41c-.62,0-1.54-2.23-1.13-2.72s1.65-.23,2.12-.88,1-2.44,1.62-2.11-.56,1.73-1,3.1S361,293.14,359.93,293.41Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-286",
    d: "M359.94,293.27c-.56,0-1.38-2-1-2.5s1.46-.21,1.88-.78.88-2.14,1.49-1.86-.5,1.52-.91,2.73C360.9,292.26,360.9,293,359.94,293.27Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-287",
    d: "M360,293.13c-.51,0-1.24-1.84-.95-2.28s1.28-.19,1.65-.67.81-1.85,1.35-1.61-.43,1.31-.78,2.35C360.8,292.2,360.79,292.89,360,293.13Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-288",
    d: "M360,293c-.45-.09-1.08-1.65-.85-2.07.32-.26,1.09-.16,1.42-.57s.72-1.55,1.21-1.36-.37,1.11-.66,2C360.7,292.14,360.68,292.77,360,293Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-289",
    d: "M360,292.86a2.29,2.29,0,0,1-.75-1.85c.27-.21.9-.14,1.18-.47s.65-1.25,1.07-1.1-.29.9-.53,1.61C360.61,292.08,360.57,292.65,360,292.86Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-290",
    d: "M360,292.72a2.24,2.24,0,0,1-.67-1.63c.23-.16.72-.12.95-.36s.57-1,.94-.86c.22.16-.23.69-.41,1.24C360.51,292,360.46,292.52,360,292.72Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-291",
    d: "M360,292.59a2.3,2.3,0,0,1-.57-1.42c.18-.11.53-.09.72-.26s.49-.66.79-.61-.16.49-.28.87C360.41,292,360.35,292.4,360,292.59Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-292",
    d: "M360,292.45a2.61,2.61,0,0,1-.47-1.2,4.42,4.42,0,0,0,.48-.15c.19-.13.42-.37.66-.36.06.08-.1.28-.16.49C360.31,291.91,360.24,292.27,360,292.45Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-270",
    d: "M360,292.31a4.55,4.55,0,0,1-.39-1l.25-.05.52-.11,0,.12A6.6,6.6,0,0,1,360,292.31Z",
    transform: "translate(-332.25 -113.32)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-258"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-282",
    d: "M370.67,287c.41.37,1.31-.1,2.31-.66a7.56,7.56,0,0,1,2.89-1.22c1.57,0,5.75.22,4.39-.89s-4.14-1.71-5.8-.64c-.83.53-2.16,1-3.09,1.58S369.9,286.32,370.67,287Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-283",
    d: "M374.66,283.64c1.54-1,4.08-.42,5.35.59.67.53,0,.74-1.06.81-.57,0-1.22,0-1.81,0l-1.16,0a3,3,0,0,0-1.14.3c-.48.2-1,.47-1.46.73l-.14.08c-.94.51-1.79.94-2.19.61a.84.84,0,0,1-.32-.56c0-.41.39-.78,1-1.13.28-.15.59-.31.91-.46A21.46,21.46,0,0,0,374.66,283.64Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-284",
    d: "M374.85,283.67a4.91,4.91,0,0,1,4.91.54c.63.49,0,.68-.87.76-.53,0-1.14,0-1.71,0h-1.09a3,3,0,0,0-1.08.27c-.45.18-.93.42-1.39.66l-.12.07c-.89.45-1.68.85-2.08.57a.8.8,0,0,1-.27-.51c0-.38.38-.72.93-1,.26-.14.55-.29.85-.42C373.6,284.27,374.33,284,374.85,283.67Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-285",
    d: "M375.05,283.7a4.58,4.58,0,0,1,4.46.49c.6.44.09.61-.67.7-.5,0-1.07,0-1.61,0h-1a3.05,3.05,0,0,0-1,.24c-.43.16-.88.38-1.31.58l-.12.06c-.82.41-1.57.78-1.95.54a.67.67,0,0,1-.23-.47c0-.34.36-.65.87-.94a7.44,7.44,0,0,1,.8-.39C373.87,284.23,374.55,284,375.05,283.7Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-286",
    d: "M375.25,283.73a4.26,4.26,0,0,1,4,.44c.56.4.16.55-.48.64-.46,0-1,0-1.5,0h-1a3,3,0,0,0-.95.21c-.41.14-.84.33-1.24.51l-.11,0c-.76.35-1.45.69-1.84.49a.6.6,0,0,1-.18-.41c0-.31.34-.59.8-.85a6.7,6.7,0,0,1,.76-.36C374.13,284.2,374.77,284,375.25,283.73Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-287",
    d: "M375.44,283.76a4,4,0,0,1,3.57.39c.52.35.22.49-.28.58s-.93,0-1.4,0h-.91a3.13,3.13,0,0,0-.89.18,11.54,11.54,0,0,0-1.16.44l-.11,0c-.69.3-1.34.6-1.71.45a.5.5,0,0,1-.14-.37c0-.27.33-.52.74-.75a7.65,7.65,0,0,1,.7-.33C374.39,284.17,375,284,375.44,283.76Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-288",
    d: "M375.64,283.79a3.67,3.67,0,0,1,3.12.34c.48.3.28.43-.09.52s-.85,0-1.3,0h-.83a2.86,2.86,0,0,0-.83.15c-.37.1-.75.23-1.09.36l-.1,0a3.26,3.26,0,0,1-1.6.41.41.41,0,0,1-.08-.33c0-.24.3-.45.67-.65.2-.11.42-.2.65-.3C374.66,284.14,375.21,284,375.64,283.79Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-289",
    d: "M375.83,283.82a3.38,3.38,0,0,1,2.68.29c.44.26.35.37.11.46s-.78,0-1.2,0h-.77a3,3,0,0,0-.77.12,9.23,9.23,0,0,0-1,.29l-.09,0a4.06,4.06,0,0,1-1.48.37.4.4,0,0,1,0-.28c.05-.21.29-.4.6-.56s.39-.18.6-.27C374.92,284.11,375.42,284,375.83,283.82Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-290",
    d: "M376,283.85a3.12,3.12,0,0,1,2.23.24c.41.21.41.31.3.4-.33,0-.71,0-1.09,0h-.71a3.54,3.54,0,0,0-.71.09c-.32.06-.64.14-.93.21l-.09,0a5,5,0,0,1-1.36.33.36.36,0,0,1,0-.23,1.06,1.06,0,0,1,.54-.46,4.53,4.53,0,0,1,.55-.23C375.18,284.08,375.64,284,376,283.85Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-291",
    d: "M376.22,283.88a3,3,0,0,1,1.79.19c.37.16.47.25.5.34l-1,0h-.65a4.62,4.62,0,0,0-.64.06c-.31,0-.6.09-.86.14h-.08a11.87,11.87,0,0,1-1.24.29.45.45,0,0,1,.05-.19,1.21,1.21,0,0,1,.48-.37,4.77,4.77,0,0,1,.5-.19C375.44,284.05,375.85,284,376.22,283.88Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-292",
    d: "M376.42,283.92a2.9,2.9,0,0,1,1.34.13,3.38,3.38,0,0,1,.69.28l-.89,0H377a5.63,5.63,0,0,0-.58,0l-.78.06h-.07a10.93,10.93,0,0,0-1.12.25.42.42,0,0,1,.09-.14,1.47,1.47,0,0,1,.41-.28,4.72,4.72,0,0,1,.45-.16A7.07,7.07,0,0,1,376.42,283.92Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-270",
    d: "M374.94,284.36a2.31,2.31,0,0,1,.35-.18l.4-.13a3.84,3.84,0,0,1,.93-.1,4.53,4.53,0,0,1,.89.08,6.29,6.29,0,0,1,.88.22h-2.52a3.53,3.53,0,0,0-1.07.2Z",
    transform: "translate(-332.25 -113.32)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-258"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-282",
    d: "M364.36,284.72c-.11-.91,1.88-.73,2.6-.68s1,2.68,1.71,2.64,1.45,1.66-.3,2.34c-.87.34-1.28-.13-1.55-.78a9.28,9.28,0,0,0-.71-1.9C365.47,285.53,364.49,285.74,364.36,284.72Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-283",
    d: "M364.48,284.73c0-.3.19-.47.52-.56a6.7,6.7,0,0,1,1.93-.05c.31,0,.54.57.75,1.13s.49,1.43.87,1.42a.66.66,0,0,1,.49.28,1.18,1.18,0,0,1-.35,1.79l-.3.17a1.54,1.54,0,0,1-.66.13l-.19,0a1.45,1.45,0,0,1-.66-.86,9.35,9.35,0,0,0-.7-1.84,1.29,1.29,0,0,0-.19-.21C365.39,285.53,364.61,285.59,364.48,284.73Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-284",
    d: "M364.59,284.75c0-.27.2-.42.51-.51a7,7,0,0,1,1.81-.05c.28.06.5.57.7,1.1s.47,1.35.82,1.38a.66.66,0,0,1,.46.28,1.11,1.11,0,0,1-.21,1.67,1.48,1.48,0,0,1-.28.17,1.29,1.29,0,0,1-.64.16.5.5,0,0,1-.19,0,1.56,1.56,0,0,1-.64-.87,9.11,9.11,0,0,0-.67-1.79,1.8,1.8,0,0,0-.19-.2C365.49,285.51,364.75,285.53,364.59,284.75Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-285",
    d: "M364.71,284.77c0-.25.19-.38.48-.45a6.53,6.53,0,0,1,1.69-.05c.27.07.47.57.65,1.06s.45,1.28.78,1.33a.72.72,0,0,1,.43.28,1.09,1.09,0,0,1-.08,1.57l-.24.17a1.32,1.32,0,0,1-.63.19l-.19,0a1.61,1.61,0,0,1-.61-.9,8.58,8.58,0,0,0-.66-1.73l-.17-.19C365.59,285.49,364.88,285.48,364.71,284.77Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-286",
    d: "M364.82,284.78c0-.21.2-.33.47-.39a5.93,5.93,0,0,1,1.56,0c.25.09.44.57.61,1s.42,1.19.73,1.27a.82.82,0,0,1,.4.29c.32.42.49,1.09.05,1.45l-.2.17a1.22,1.22,0,0,1-.62.22.37.37,0,0,1-.19,0,1.77,1.77,0,0,1-.59-.91,7.56,7.56,0,0,0-.64-1.68l-.16-.18C365.7,285.46,365,285.43,364.82,284.78Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-287",
    d: "M364.94,284.8c0-.18.19-.29.44-.34a5.88,5.88,0,0,1,1.44,0c.23.1.41.56.57,1s.39,1.12.68,1.23a.87.87,0,0,1,.37.28c.31.41.49,1,.19,1.34a1,1,0,0,1-.18.18,1.26,1.26,0,0,1-.6.25.37.37,0,0,1-.19,0,1.88,1.88,0,0,1-.56-.92,7,7,0,0,0-.63-1.62.9.9,0,0,0-.15-.18C365.8,285.44,365.15,285.38,364.94,284.8Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-288",
    d: "M365.05,284.81c0-.15.2-.24.42-.28a5.9,5.9,0,0,1,1.32,0c.21.12.38.56.53.95s.36,1.05.63,1.18a1,1,0,0,1,.34.29c.3.4.5.95.32,1.22a.73.73,0,0,1-.14.18,1.13,1.13,0,0,1-.58.28.48.48,0,0,1-.2,0,2,2,0,0,1-.54-.95,6.59,6.59,0,0,0-.6-1.56l-.15-.17C365.9,285.41,365.29,285.32,365.05,284.81Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-289",
    d: "M365.17,284.83c0-.12.19-.19.4-.23a6,6,0,0,1,1.2,0,2.37,2.37,0,0,1,.48.92,2.75,2.75,0,0,0,.58,1.13,1.18,1.18,0,0,1,.31.29,1.87,1.87,0,0,1,.45,1.11.62.62,0,0,1-.11.18,1.07,1.07,0,0,1-.56.31.48.48,0,0,1-.2,0,2.12,2.12,0,0,1-.51-1,6.34,6.34,0,0,0-.59-1.51,1.07,1.07,0,0,0-.14-.16C366,285.39,365.42,285.27,365.17,284.83Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-290",
    d: "M365.28,284.85a.53.53,0,0,1,.38-.18,6.48,6.48,0,0,1,1.08,0,2.76,2.76,0,0,1,.44.88,3,3,0,0,0,.54,1.08c.08.08.18.18.27.29a6.18,6.18,0,0,1,.59,1,.71.71,0,0,1-.08.19.94.94,0,0,1-.55.33.66.66,0,0,1-.2,0,2.35,2.35,0,0,1-.49-1,5.93,5.93,0,0,0-.57-1.45l-.12-.16C366.11,285.36,365.56,285.22,365.28,284.85Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-291",
    d: "M365.39,284.86a.73.73,0,0,1,.37-.12,7.4,7.4,0,0,1,.95,0,3.66,3.66,0,0,1,.4.84,3.19,3.19,0,0,0,.49,1c.07.09.16.19.23.3a4.66,4.66,0,0,0,.73.88.5.5,0,0,1,0,.19.92.92,0,0,1-.54.37.45.45,0,0,1-.2,0,2.74,2.74,0,0,1-.47-1,5.31,5.31,0,0,0-.55-1.4l-.11-.15C366.22,285.34,365.69,285.17,365.39,284.86Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-292",
    d: "M365.51,284.88a1,1,0,0,1,.34-.07c.29,0,.6,0,.83,0a5.46,5.46,0,0,1,.36.8,4.54,4.54,0,0,0,.44,1l.2.29a1.77,1.77,0,0,0,.86.77.35.35,0,0,1,0,.2.8.8,0,0,1-.52.39.66.66,0,0,1-.2.05,3.21,3.21,0,0,1-.44-1,5.68,5.68,0,0,0-.53-1.34,1.71,1.71,0,0,1-.11-.14A5.12,5.12,0,0,0,365.51,284.88Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-270",
    d: "M367.84,288.24a3.55,3.55,0,0,1-.42-1,4.13,4.13,0,0,0-.61-1.42,3.1,3.1,0,0,0-1.19-.88h.32l.72,0c.1.2.22.54.31.77a6.25,6.25,0,0,0,.56,1.23,1.32,1.32,0,0,0,1,.66.3.3,0,0,1,0,.19c0,.16-.22.31-.51.43A.73.73,0,0,1,367.84,288.24Z",
    transform: "translate(-332.25 -113.32)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-255",
    d: "M352.37,290.27c-1,.48-2,1-2.83,1.52-2,1.21-3.2,5.23-3.93,6.84.68,0,1.64,0,2.07,0a3.59,3.59,0,0,0,1.28-.19s.19-.64.64-1.73S350.05,293,351,292A15.1,15.1,0,0,0,352.37,290.27Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-255",
    d: "M367.75,282.9c.71.49,1.22.93,1.22,1.58a6.33,6.33,0,0,1-.35,1.86,18,18,0,0,1,3.41-2c.94-.29,2.36-1.26,3.92-1.67A51.46,51.46,0,0,0,367.75,282.9Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-293",
    d: "M350.9,309.6c-2.89,2.89-1.19,5.8-1.19,7.84a6.71,6.71,0,0,0,5.62,6.14c3.75.51,5.28-1,8-.17S368.8,322,368.8,322s3.92,1,5.62.69,1.36-1,2.73-1a14.14,14.14,0,0,0,8.35-3.92,25.52,25.52,0,0,0,4.43-6,7.9,7.9,0,0,0,4.6-1.71c2.05-1.7,2.69-7,2.69-9.58s-1.5-4.22-1.5-5.76-1.19-4.94-3.75-5.11-1.7-2.22-5.79-2.56-8.86-1.19-9.54.34-3.75.86-5.63,2.22-5.62,3.07-6.82,5.11-3.58,2.05-5.45,2.9-6.14,4.6-5.8,6.82S352.26,308.24,350.9,309.6Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-255",
    d: "M372.36,322.72a13.4,13.4,0,0,1,.87-3.4c.85-1.88,3.06-1.88,6.81-4.43,2.47-1.69,3.48-5.16,3.88-7.34a.37.37,0,0,0-.68-.25c-.93,1.64-2.34,4.09-3.2,5.37-1.36,2-4.6,1.87-4.6,1.87s-1,2.39-3.24,2.39a6.26,6.26,0,0,1-3.92-1.7s1.54,3.4,1.54,4.6a3.64,3.64,0,0,1-1,2.21A28.55,28.55,0,0,0,372.36,322.72Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-256",
    d: "M371.18,322.56c-.84-.12-1.64-.34-2.21-.47.31-.48,2.17-1.85,2.17-2.6s-1.27-1.71-1.69-2.8a5.77,5.77,0,0,0,2.75.75,4.25,4.25,0,0,0,3.56-2.38c.93,0,3.47-.25,4.71-2.11.72-1.08,1.83-3,2.77-4.6-.47,2-1.45,4.73-3.48,6.11a26.86,26.86,0,0,1-3.86,2.16c-1.49.71-2.57,1.23-3.14,2.49A18.71,18.71,0,0,0,371.18,322.56Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-255",
    d: "M377.15,321.7s-1.15-.72.25-1.87,3.45-1,4.48-2.43a12.22,12.22,0,0,0,1.53-3.84s0,4-1.66,5.12S377.15,321.7,377.15,321.7Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-257",
    d: "M377.17,321.39c-.09-.09.68-.95,1.09-1.29a6.42,6.42,0,0,1,2-1,3.26,3.26,0,0,0,1.8-1.57,6.71,6.71,0,0,0,.76-1.37,3.85,3.85,0,0,1-1.24,2.29C380.18,319.45,377.8,321,377.17,321.39Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-255",
    d: "M390.34,311.79a8.39,8.39,0,0,0,1.36-.25,8.63,8.63,0,0,0,1.3-2.45c-.13-.38-.26-1,1-3.58s-1.15-5.37-1.15-5.37.13,2.43.26,3.33-.77,2.3-2.43,4.21a4.2,4.2,0,0,0-.77,4.14l.38-.05Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-255",
    d: "M387.5,312.93s-.38-5,.51-6A10.56,10.56,0,0,1,390.7,305s-1.92-.9-1.92-1.79,1.92-3.2,1.66-5-.38-3.19,1.66-2a7.46,7.46,0,0,1,2.82,2.56s-.77-3.46-2.82-4-1.91-3-1.91-3a6.37,6.37,0,0,0-1,3.9c.26,2-.64,4.34-1.79,4.09s-2.55-2.17-2.55-2.17.76,2.94,2.17,3.06.89,1.73.64,3.26-1.09.51-1.15,3A35.62,35.62,0,0,0,387.5,312.93Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-255",
    d: "M395.89,295.75a3.42,3.42,0,0,1-.17-1v-.15a7.12,7.12,0,0,1-1.12-.81,17.89,17.89,0,0,1-1.73-1.59s.83,2.49,1.79,3A8,8,0,0,0,395.89,295.75Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-255",
    d: "M363.34,323.41s-3.32-1.92-3.32-3.2,2.55-2.81,2.55-2.81-3.32-1.28-4.47.64-1.92,2.68-2.94,2.3a53.06,53.06,0,0,1-5.24-3.45s1.6,3.83,3,4.34a43.48,43.48,0,0,0,4.73,1.15Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-255",
    d: "M354.14,314.59s-.13-5.24,2.3-6.65,2.55-4.86,4.73-5.75a42,42,0,0,0,4.86-2.56s-2,3.58-3.84,4.22-2.17,3.32-2.17,3.32l2.43-.38s-2.18,2.68-3.84,2.68S354.14,314.59,354.14,314.59Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-255",
    d: "M359.38,313.18s3.32-.32,3.71-1.21,2.42-3.39,4.85-3.39,6.52-.26,7.29-1.92-4.86-2.3-5.37-3.83,5-4.35,5-4.35-3.33,2.68-3.2,3.58,3.58,1.41,4.86,2.68a3.13,3.13,0,0,0,2.81.9,19.51,19.51,0,0,0-3.45,2.43c-.77.89-.26,1.53,0,2.81a3.45,3.45,0,0,1-.13,2.05s0-3.07-2.56-3.2-5.88-.38-6.77.77a29.42,29.42,0,0,1-3.2,3.06s.39.13.77,1.67a3.6,3.6,0,0,1,0,2.3s-.89-2.69-1.53-3.2A13.76,13.76,0,0,0,359.38,313.18Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-255",
    d: "M383.15,302.57c-2.55-1.15-2.81-4.47-2.68-5.37s1.28-4.09-1-5.75a7.38,7.38,0,0,1-2.81-4l-2.82,1.2a13.31,13.31,0,0,1,3.33,2.94c.89,1.4,1.79,1.91-.13,2a27.58,27.58,0,0,1-3.58,0s2.56,2.05,3.71,1.41,2.43-.9,2,.13-.77,3.45.64,5A12,12,0,0,0,383.15,302.57Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-255",
    d: "M363.09,296.05c.25,1,2.68,0,4.47.77a11.93,11.93,0,0,0,3.45.89,2.74,2.74,0,0,0-2.3-2.68C366.41,294.65,363.09,296.05,363.09,296.05Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-255",
    d: "M384.05,287c.64.76,1.92,2.55.89,4s-1.4,3.32.13,4.09l1.54.77s-1.79-1.67-1-3.07a19.34,19.34,0,0,0,1.28-2.94C387.12,289.15,384.05,287,384.05,287Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-257",
    d: "M390.53,311.69a3.82,3.82,0,0,1,.34-2.34c.59-1.28,2-3.2,2.34-4a3.12,3.12,0,0,0,.47-2,5.11,5.11,0,0,1-.26-1.11s1.24.77.22,2.81-2,3.07-1.75,3.58a1.86,1.86,0,0,0,.43.64s-.52-.25-.64.56a11.09,11.09,0,0,1-.43,1.66Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-256",
    d: "M387.2,307a2.19,2.19,0,0,1,1.2-1.44c.89-.3,1-.56,1-.56s-1.2-.89-1.07-1.62.94-2.77,1.19-3.58.13-3.45.43-4.21.64-.77,1.75-.22a5.52,5.52,0,0,1,1.7,1.32,2,2,0,0,0-1.49-1.57,3.35,3.35,0,0,1-1.92-1.54,8.55,8.55,0,0,0-.47,3.07c0,2,.09,3.58-.89,3.58a5.47,5.47,0,0,1-2.22-.6c.13,0,2.18.3,2.05,1.2s-.9,3.23-.47,3.58.6.34.08.63S387.2,307,387.2,307Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-257",
    d: "M393.81,293.62a3.08,3.08,0,0,0,.85,1.24,5.11,5.11,0,0,0,1,.51l.08-.6a2.26,2.26,0,0,1-.93-.21A4.93,4.93,0,0,1,393.81,293.62Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-256",
    d: "M385.11,294.52s-.89-1.45-.34-2.3,1.2-1.92,1.11-2.39a8.79,8.79,0,0,0-.3-1.11,1.29,1.29,0,0,1,.47,1.79,8.09,8.09,0,0,0-1.15,2.39A15.36,15.36,0,0,1,385.11,294.52Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-256",
    d: "M376.08,288.17a11.52,11.52,0,0,0,1.45,2.64c.81,1,2.13.68,2.3,2.39s0,3.28,0,4.39a8.74,8.74,0,0,0,.9,2.77s-1.79-1.71-1.5-2.56a7.18,7.18,0,0,0,.13-3.54c-.3-.55-.68-.08-1.36.09a12.78,12.78,0,0,1-2.6,0,21.57,21.57,0,0,0,2.47-.39c.47-.17,1.49-.42,1.11-1s-1.66-1.79-2.39-2.6a19.48,19.48,0,0,1-1.4-1.83Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-256",
    d: "M364.28,296s2.68-.17,3.79.51a8.46,8.46,0,0,0,2.47.94,3.56,3.56,0,0,0-2-1.62A19.33,19.33,0,0,0,364.28,296Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-256",
    d: "M354.86,312.54s1.28-3.36,2.77-3.49A8.48,8.48,0,0,0,361,307.6l-1.7.08s0-3,1.49-3.75a23.68,23.68,0,0,0,3.79-2.89s-2.77,1.53-4,2.13-1.4,3.41-2.47,4.09-2.56,1.74-2.86,3.32S354.86,312.54,354.86,312.54Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-256",
    d: "M351.32,318.55a7.06,7.06,0,0,0,2.69,2.26c1.36.42,3.62.3,4.47.72s3,1.28,3,1.28-2.77-1.83-2.34-2.68,1.32-2.22,1.32-2.22a3.52,3.52,0,0,0-1.88,1.28,5.72,5.72,0,0,0-.64,1.53,12.2,12.2,0,0,1-3.58-.34A8.48,8.48,0,0,1,351.32,318.55Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-256",
    d: "M361.55,313.39s1.88-.64,2.3-1.49S366,309,368.11,309s6.39-.51,7.08-1.53.93-1.92-.9-2.6-4-1.41-3.83-2.3a4.19,4.19,0,0,1,1.32-1.92s-1.07,1.88-.39,2.17,4.09,1.79,4.69,2.48a2,2,0,0,0,1.49.63,11.53,11.53,0,0,0-2.26,2c-.55.81.05,2.6.05,2.6s-.09-1.53-2.09-1.57-5.71.3-7.29,1.4a19.19,19.19,0,0,0-3.19,3.16l.68,1.74s-.6-1.49-1.07-1.53A2.28,2.28,0,0,1,361.55,313.39Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-255",
    d: "M389.93,311.82c-.38-.47-2.3,1.74-3.77,2.32s-.58-3.77-.77-6-1.47-2.36-2.15.22a13.47,13.47,0,0,1-5.39,6.81c-1.79.9-4.67,2.18-5.37,3.07a45.36,45.36,0,0,0-2.46,4.1,14.24,14.24,0,0,0,4.4.4c1.7-.35,1.36-1,2.73-1a14.14,14.14,0,0,0,8.35-3.92A25.52,25.52,0,0,0,389.93,311.82Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-255",
    d: "M391.34,309a8.67,8.67,0,0,0-.63,2.79,7.77,7.77,0,0,0,3.82-1.64c2.05-1.7,2.69-7,2.69-9.58,0-2-.94-3.49-1.33-4.78h0c-.55.34.18,1.52.3,3.11a6.08,6.08,0,0,1-.57,3.33c-.45,1.21-2.75-2.05-2.75-2.05s1.21,2.56,1,3.84S391.78,307.88,391.34,309Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-255",
    d: "M362,323.16a8.5,8.5,0,0,1-2.78-1.93c-.58-.7-2.62-.08-4.61-.51-1.58-.34-3.69-2.7-5-4.42a6.87,6.87,0,0,1,.13,1.14,6.71,6.71,0,0,0,5.62,6.14C358.41,324,360,323,362,323.16Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-258"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-282",
    d: "M363,297.14a7.65,7.65,0,0,0-3.4.62,12.47,12.47,0,0,0-3.76,2.38c-2.37,2.18-2.25,6-2.75,7.1-1,2.3-.18,2.38,1.07,1.45a11,11,0,0,0,3.47-4.59c.57-1.72,2.43-3.08,4.18-4.05s3.39-1.54,3.55-1.7C365.64,298,363.66,297.2,363,297.14Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-283",
    d: "M359.51,297.88a7.44,7.44,0,0,1,3.23-.61,4.62,4.62,0,0,1,1.15.32,4.88,4.88,0,0,1,.51.22c.42.21.72.44.61.57s-1.77.72-3.43,1.64a14,14,0,0,0-1.27.78,6.79,6.79,0,0,0-2.78,3.12,8,8,0,0,1-.53,1.17,10.74,10.74,0,0,1-2.81,3.25,1.7,1.7,0,0,1-1.09.44c-.37-.07-.41-.63.15-1.91a10.49,10.49,0,0,0,.38-1.69,10.89,10.89,0,0,1,1.23-3.73,5.7,5.7,0,0,1,1.06-1.31A12,12,0,0,1,359.51,297.88Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-284",
    d: "M359.45,298a7.49,7.49,0,0,1,3.07-.59,4.66,4.66,0,0,1,1.1.28l.49.2c.39.19.67.4.58.53-.24.17-1.73.71-3.3,1.58a14.32,14.32,0,0,0-1.23.74,6.72,6.72,0,0,0-2.69,3,10,10,0,0,1-.51,1.12,10.13,10.13,0,0,1-2.7,3.14,1.42,1.42,0,0,1-1,.33c-.33-.1-.35-.63.15-1.83a9.17,9.17,0,0,0,.37-1.6,10.3,10.3,0,0,1,1.21-3.53,5.66,5.66,0,0,1,1-1.23A11.55,11.55,0,0,1,359.45,298Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-285",
    d: "M359.4,298.11a7.14,7.14,0,0,1,2.9-.58,5,5,0,0,1,1.51.43c.36.16.62.35.57.47-.29.19-1.7.7-3.18,1.52-.4.22-.8.46-1.18.72a6.69,6.69,0,0,0-2.61,2.88c-.14.36-.31.72-.49,1.09a9.1,9.1,0,0,1-2.59,3c-.35.21-.66.31-.85.22s-.29-.63.16-1.74a10.33,10.33,0,0,0,.35-1.52,9.73,9.73,0,0,1,1.19-3.32,5.64,5.64,0,0,1,1-1.16A11.26,11.26,0,0,1,359.4,298.11Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-286",
    d: "M359.35,298.23a7,7,0,0,1,2.74-.57,3.85,3.85,0,0,1,1,.21,3.72,3.72,0,0,1,.44.16c.33.14.58.32.55.43-.32.19-1.66.68-3.06,1.46-.37.21-.76.44-1.13.69a6.69,6.69,0,0,0-2.52,2.76c-.14.34-.3.69-.48,1a8.26,8.26,0,0,1-2.47,2.89c-.3.16-.57.22-.73.11s-.23-.63.17-1.65a10.37,10.37,0,0,0,.33-1.43,8.92,8.92,0,0,1,1.17-3.12,6,6,0,0,1,.94-1.08A10.82,10.82,0,0,1,359.35,298.23Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-287",
    d: "M359.3,298.34a7.26,7.26,0,0,1,2.57-.55,3.54,3.54,0,0,1,.93.17l.41.14c.3.12.54.28.54.39-.37.2-1.63.67-2.94,1.4-.36.2-.73.42-1.08.66a6.47,6.47,0,0,0-2.44,2.64c-.14.32-.29.65-.46,1a7.42,7.42,0,0,1-2.36,2.77.56.56,0,0,1-.61,0c-.19-.18-.18-.64.17-1.56a12.43,12.43,0,0,0,.33-1.36,8,8,0,0,1,1.15-2.91,5.29,5.29,0,0,1,.9-1A10.33,10.33,0,0,1,359.3,298.34Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-288",
    d: "M359.24,298.46a6.88,6.88,0,0,1,2.41-.54,3.33,3.33,0,0,1,.88.14l.39.11a1.08,1.08,0,0,1,.51.34c-.41.22-1.58.66-2.81,1.34-.34.2-.69.41-1,.64a6.41,6.41,0,0,0-2.36,2.51l-.44,1a6.7,6.7,0,0,1-2.25,2.65.41.41,0,0,1-.48-.11c-.16-.2-.13-.65.17-1.47.12-.32.19-.77.31-1.27a7.2,7.2,0,0,1,1.13-2.71,5.34,5.34,0,0,1,.86-.92A10,10,0,0,1,359.24,298.46Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-289",
    d: "M359.19,298.57a6.75,6.75,0,0,1,2.24-.52,3.06,3.06,0,0,1,.82.1,3.29,3.29,0,0,1,.37.1,1.16,1.16,0,0,1,.5.29c-.45.22-1.55.65-2.69,1.28-.33.19-.66.39-1,.61a6.31,6.31,0,0,0-2.27,2.39c-.14.29-.28.6-.42.91a6,6,0,0,1-2.14,2.53.34.34,0,0,1-.36-.22c-.11-.22-.08-.65.18-1.38.1-.31.18-.73.29-1.18a6.75,6.75,0,0,1,1.11-2.51,6,6,0,0,1,.82-.85A9.86,9.86,0,0,1,359.19,298.57Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-290",
    d: "M359.14,298.69a6.76,6.76,0,0,1,2.08-.51,4.08,4.08,0,0,1,.76.06l.34.08a1.32,1.32,0,0,1,.48.25c-.49.23-1.51.63-2.56,1.22-.31.17-.63.37-.94.58a6.32,6.32,0,0,0-2.19,2.27c-.14.27-.28.56-.4.86a5.35,5.35,0,0,1-2,2.41.42.42,0,0,1-.24-.32,2.46,2.46,0,0,1,.18-1.3c.1-.3.17-.69.28-1.1A5.89,5.89,0,0,1,356,300.9a5.23,5.23,0,0,1,.78-.78A9.47,9.47,0,0,1,359.14,298.69Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-291",
    d: "M359.09,298.81a6.53,6.53,0,0,1,1.91-.5,3.38,3.38,0,0,1,.71,0l.31.05a1.56,1.56,0,0,1,.47.21,25.77,25.77,0,0,0-2.44,1.15c-.3.17-.6.36-.9.56a6.4,6.4,0,0,0-2.1,2.14,8.67,8.67,0,0,0-.38.82,4.73,4.73,0,0,1-1.92,2.29,1,1,0,0,1-.12-.43,3.14,3.14,0,0,1,.19-1.21c.09-.29.16-.64.26-1a5.27,5.27,0,0,1,1.07-2.09,6.08,6.08,0,0,1,.74-.7A8.75,8.75,0,0,1,359.09,298.81Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-292",
    d: "M359,298.92a6.81,6.81,0,0,1,1.75-.48,4.87,4.87,0,0,1,.66,0l.29,0a2.14,2.14,0,0,1,.44.16,24.6,24.6,0,0,0-2.31,1.1c-.29.16-.57.34-.85.52a6.41,6.41,0,0,0-2,2,5.51,5.51,0,0,0-.36.78,4.29,4.29,0,0,1-1.81,2.17,4.71,4.71,0,0,1,.2-1.66c.07-.29.15-.61.25-.94a4.45,4.45,0,0,1,1.05-1.88,6.77,6.77,0,0,1,.69-.63A9.27,9.27,0,0,1,359,298.92Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-270",
    d: "M354.89,304.87c0-.2.08-.42.12-.65a12.69,12.69,0,0,1,.44-1.88,3.91,3.91,0,0,1,1-1.68A8.79,8.79,0,0,1,359,299a5.79,5.79,0,0,1,2.18-.51h.27a2.25,2.25,0,0,1,.43.11,16.34,16.34,0,0,0-3,1.53,5.51,5.51,0,0,0-2.28,2.64A3.71,3.71,0,0,1,354.89,304.87Z",
    transform: "translate(-332.25 -113.32)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-258"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-282",
    d: "M377.49,286.68c-.82.26,0,2.55,1.4,4s2.6,2,2.47,4.3,1.84,2.13,1.92.64c.05-.74,0-1.84-.07-2.94a12.65,12.65,0,0,1,.12-3c.34-1.53.08-2.77-.56-2.9a23,23,0,0,0-2.39-.25A9.16,9.16,0,0,0,377.49,286.68Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-283",
    d: "M377.5,286.7a5.24,5.24,0,0,1,1.14-.18,16.13,16.13,0,0,1,1.7,0,20.66,20.66,0,0,1,2.26.22c.44.1.69.78.65,1.75a7.23,7.23,0,0,1-.13,1.07,12.66,12.66,0,0,0-.09,2.89l0,.44c0,.83.09,1.63.08,2.23a1.09,1.09,0,0,0,0,.18,1.07,1.07,0,0,1-.39.78c-.55.4-1.46,0-1.4-1.54a3.79,3.79,0,0,0-1.66-3.35c-.24-.22-.5-.46-.77-.73l-.22-.24C377.51,288.89,376.81,287,377.5,286.7Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-284",
    d: "M377.52,286.73a4.84,4.84,0,0,1,1.11-.18,15.44,15.44,0,0,1,1.67,0,19.9,19.9,0,0,1,2.12.2c.41.1.65.76.61,1.71,0,.32-.06.67-.12,1a12.6,12.6,0,0,0-.05,2.79l0,.43c.05.8.1,1.57.09,2.15a.91.91,0,0,1,0,.17.83.83,0,0,1-.36.66c-.5.28-1.33-.08-1.3-1.54a3.64,3.64,0,0,0-1.64-3.15c-.23-.22-.48-.44-.74-.7l-.22-.23C377.58,288.82,376.91,287,377.52,286.73Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-285",
    d: "M377.53,286.76a4.55,4.55,0,0,1,1.09-.18,14.69,14.69,0,0,1,1.63,0,19.74,19.74,0,0,1,2,.18c.37.11.6.75.56,1.67a9.83,9.83,0,0,1-.11,1,12.6,12.6,0,0,0,0,2.69l0,.42c0,.77.11,1.52.11,2.07,0,.07,0,.13,0,.18a.59.59,0,0,1-.34.52c-.45.18-1.2-.19-1.2-1.52a3.56,3.56,0,0,0-1.62-3c-.23-.2-.47-.41-.71-.65l-.21-.22C377.65,288.74,377,287,377.53,286.76Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-286",
    d: "M377.54,286.78a5.46,5.46,0,0,1,1.07-.18,14.15,14.15,0,0,1,1.6,0,17,17,0,0,1,1.86.15c.34.11.56.73.51,1.63a9.21,9.21,0,0,1-.09,1,13.27,13.27,0,0,0,0,2.59c0,.14,0,.27,0,.4.06.75.12,1.47.12,2a1,1,0,0,1,0,.18.39.39,0,0,1-.31.38c-.4.08-1.06-.29-1.1-1.51a3.45,3.45,0,0,0-1.6-2.78c-.22-.19-.45-.39-.68-.61l-.2-.2C377.72,288.66,377.1,287.08,377.54,286.78Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-287",
    d: "M377.56,286.81a5,5,0,0,1,1-.18,13.48,13.48,0,0,1,1.56-.05,16.45,16.45,0,0,1,1.74.13c.3.12.51.71.46,1.59,0,.28,0,.6-.08.93a13.43,13.43,0,0,0,.06,2.5l0,.38c.07.73.14,1.42.15,1.93,0,.07,0,.12,0,.17s-.16.27-.29.26c-.35,0-.93-.41-1-1.5a3.4,3.4,0,0,0-1.58-2.6c-.21-.18-.43-.36-.65-.57l-.19-.19C377.8,288.58,377.19,287.11,377.56,286.81Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-288",
    d: "M377.57,286.83a6.45,6.45,0,0,1,1-.18c.49,0,1-.06,1.53-.06.71,0,1.36.08,1.61.11s.46.69.41,1.54c0,.28,0,.58-.07.91a13.52,13.52,0,0,0,.1,2.4l0,.36c.08.7.15,1.37.16,1.86a.86.86,0,0,1,0,.17.17.17,0,0,1-.26.12,1.7,1.7,0,0,1-.9-1.49,3.35,3.35,0,0,0-1.57-2.41c-.19-.16-.4-.33-.61-.53a1.54,1.54,0,0,1-.19-.17C377.87,288.5,377.29,287.15,377.57,286.83Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-289",
    d: "M377.59,286.86a5.55,5.55,0,0,1,1-.18,12.22,12.22,0,0,1,1.48-.07c.66,0,1.24.05,1.48.08s.42.67.37,1.5q0,.4-.06.87a13.71,13.71,0,0,0,.14,2.31l0,.34c.08.68.16,1.32.18,1.79,0,.07,0,.12,0,.16s-.14.1-.24,0a2.33,2.33,0,0,1-.79-1.49,3.33,3.33,0,0,0-1.56-2.21l-.58-.5-.18-.16C377.94,288.43,377.38,287.19,377.59,286.86Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-290",
    d: "M377.6,286.89a4.94,4.94,0,0,1,1-.19,14.09,14.09,0,0,1,1.45-.08c.59,0,1.12,0,1.35.05a1.87,1.87,0,0,1,.31,1.47c0,.26,0,.54,0,.83a15.25,15.25,0,0,0,.17,2.22c0,.11,0,.22,0,.32.09.65.17,1.27.19,1.72a.76.76,0,0,1,0,.16c0,.05-.12,0-.21-.14a4,4,0,0,1-.69-1.47,3.33,3.33,0,0,0-1.54-2l-.56-.45-.16-.15C378,288.35,377.48,287.23,377.6,286.89Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-291",
    d: "M377.61,286.91a5.7,5.7,0,0,1,1-.18,13.55,13.55,0,0,1,1.41-.1c.54,0,1,0,1.22,0a2,2,0,0,1,.27,1.43c0,.25,0,.51,0,.8a15.63,15.63,0,0,0,.21,2.12c0,.1,0,.2,0,.3.1.63.18,1.22.21,1.65,0,.06,0,.12,0,.16s-.13-.08-.19-.27a14.84,14.84,0,0,1-.59-1.47,3.48,3.48,0,0,0-1.52-1.84c-.17-.13-.35-.26-.53-.41l-.16-.14A3.69,3.69,0,0,1,377.61,286.91Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-292",
    d: "M377.63,286.94a5.79,5.79,0,0,1,.93-.19c.45-.05.94-.09,1.38-.1s.89,0,1.09,0a2.21,2.21,0,0,1,.22,1.39,6.3,6.3,0,0,0,0,.76,14.28,14.28,0,0,0,.24,2c0,.09,0,.19,0,.29a15.57,15.57,0,0,1,.22,1.56.39.39,0,0,1,0,.16.69.69,0,0,1-.16-.4,8.54,8.54,0,0,0-.49-1.45,3.68,3.68,0,0,0-1.5-1.66l-.5-.37-.15-.12A3.94,3.94,0,0,1,377.63,286.94Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-270",
    d: "M381.57,292.57a1.28,1.28,0,0,1-.13-.54,3.49,3.49,0,0,0-1.88-2.91c-.19-.13-.4-.28-.6-.44a4.19,4.19,0,0,1-1.32-1.72,6.76,6.76,0,0,1,.91-.18c.44-.06.93-.1,1.34-.12s.77,0,1,0A2.64,2.64,0,0,1,381,288a12.5,12.5,0,0,0,.32,2.93c.11.57.21,1.11.24,1.49A.37.37,0,0,1,381.57,292.57Z",
    transform: "translate(-332.25 -113.32)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-258"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-282",
    d: "M363.34,310.16c1.21,0,4.26-2.77,7.41-2.65s3.24-1.1.94-2.51-1-4.35-3.36-4.69-1.54,3.33-3.11,4.77S359,310.07,363.34,310.16Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-283",
    d: "M368.31,300.57a.51.51,0,0,1,.17,0,1.55,1.55,0,0,1,1.21,1.08c.42,1,.41,2.51,1.84,3.39a6.41,6.41,0,0,1,.94.68,1.67,1.67,0,0,1,.46.65.53.53,0,0,1,0,.39.51.51,0,0,1-.15.21,3.54,3.54,0,0,1-2.25.4,9.39,9.39,0,0,0-4.47,1.38c-.7.37-1.33.74-1.81,1a2.13,2.13,0,0,1-.77.2c-3.89-.12.37-3.41,1.84-4.75a2.56,2.56,0,0,0,.54-.73c.52-1,.61-2.34,1.05-3.17A1.22,1.22,0,0,1,368.31,300.57Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-284",
    d: "M368.29,300.82l.16,0a1.46,1.46,0,0,1,1.15,1c.38,1,.4,2.4,1.77,3.24a6.42,6.42,0,0,1,.9.65,1.39,1.39,0,0,1,.37.58.55.55,0,0,1,0,.36.53.53,0,0,1-.15.19,3.72,3.72,0,0,1-2.14.37,9.21,9.21,0,0,0-4.24,1.34c-.66.35-1.27.71-1.72.9a2.25,2.25,0,0,1-.73.17c-3.48-.15.45-3.19,1.81-4.43a2.72,2.72,0,0,0,.52-.69c.52-.94.63-2.22,1-3A1.14,1.14,0,0,1,368.29,300.82Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-285",
    d: "M368.27,301.08l.15,0a1.36,1.36,0,0,1,1.08,1c.36.94.4,2.29,1.72,3.09a5.39,5.39,0,0,1,.84.62.9.9,0,0,1,.28.52.46.46,0,0,1,0,.31.59.59,0,0,1-.15.17,3.88,3.88,0,0,1-2,.35,8.92,8.92,0,0,0-4,1.29c-.63.34-1.22.68-1.64.85a1.91,1.91,0,0,1-.69.15c-3.07-.18.53-3,1.77-4.11a2.44,2.44,0,0,0,.51-.65,29.51,29.51,0,0,0,1-2.88C367.35,301.26,367.67,301,368.27,301.08Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-286",
    d: "M368.25,301.33l.15,0c.56.12.79.42,1,1,.33.9.4,2.17,1.66,2.94a6.21,6.21,0,0,1,.8.58.69.69,0,0,1,.18.46.55.55,0,0,1-.06.28.67.67,0,0,1-.15.14,4.1,4.1,0,0,1-1.92.33,8.6,8.6,0,0,0-3.77,1.25c-.59.31-1.16.64-1.55.8a2.1,2.1,0,0,1-.65.12c-2.66-.21.6-2.75,1.74-3.79a2.58,2.58,0,0,0,.49-.61,19.91,19.91,0,0,0,1-2.74C367.42,301.51,367.71,301.26,368.25,301.33Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-287",
    d: "M368.23,301.58l.14,0c.52.11.73.38.94,1,.3.85.39,2.06,1.59,2.79a4.88,4.88,0,0,1,.75.55.42.42,0,0,1,.09.4.3.3,0,0,1-.08.23.64.64,0,0,1-.15.13,4.71,4.71,0,0,1-1.81.3,8.38,8.38,0,0,0-3.54,1.21c-.55.29-1.1.61-1.45.74a1.82,1.82,0,0,1-.62.1c-2.25-.24.68-2.53,1.7-3.46a2.84,2.84,0,0,0,.48-.58,13.56,13.56,0,0,0,1-2.6C367.49,301.76,367.75,301.53,368.23,301.58Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-288",
    d: "M368.21,301.84l.13,0c.49.09.67.33.87.92.28.81.39,2,1.53,2.64a6.72,6.72,0,0,1,.71.51.32.32,0,0,1,0,.34.37.37,0,0,1-.11.2,1,1,0,0,1-.15.1,5.18,5.18,0,0,1-1.7.28,8.43,8.43,0,0,0-3.31,1.16,13.91,13.91,0,0,1-1.36.7,1.72,1.72,0,0,1-.59.07c-1.82-.27.76-2.31,1.68-3.14a2.87,2.87,0,0,0,.46-.54,11.16,11.16,0,0,0,.94-2.46C367.56,302,367.78,301.79,368.21,301.84Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-289",
    d: "M368.19,302.09l.12,0c.45.08.61.3.81.89a3.72,3.72,0,0,0,1.46,2.49,5,5,0,0,1,.66.48.25.25,0,0,1-.09.28.44.44,0,0,1-.13.15.71.71,0,0,1-.15.08,6.94,6.94,0,0,1-1.59.26,8.06,8.06,0,0,0-3.07,1.12,12.51,12.51,0,0,1-1.28.64,2.09,2.09,0,0,1-.55.06c-1.41-.3.84-2.1,1.65-2.83a3.36,3.36,0,0,0,.44-.5,8.5,8.5,0,0,0,.92-2.32C367.63,302.25,367.82,302.06,368.19,302.09Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-290",
    d: "M368.17,302.35h.12c.41.07.54.26.73.87a3.51,3.51,0,0,0,1.4,2.33,4.2,4.2,0,0,1,.61.45q0,.12-.18.21a.45.45,0,0,1-.15.11l-.15.07a11.11,11.11,0,0,1-1.48.23,8,8,0,0,0-2.84,1.08,11.56,11.56,0,0,1-1.19.59,2.5,2.5,0,0,1-.51,0c-1-.33.91-1.88,1.61-2.51a4.67,4.67,0,0,0,.44-.46,6.69,6.69,0,0,0,.89-2.18C367.69,302.5,367.86,302.32,368.17,302.35Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-291",
    d: "M368.15,302.6h.11c.37.06.48.22.67.84a3.25,3.25,0,0,0,1.33,2.18,5.48,5.48,0,0,1,.57.41c0,.06-.13.09-.27.15a.84.84,0,0,1-.19.08l-.14,0c-.38.07-.84.13-1.37.21a8.48,8.48,0,0,0-2.61,1,7.1,7.1,0,0,1-1.09.54,2.7,2.7,0,0,1-.48,0c-.59-.36,1-1.66,1.58-2.18a5.56,5.56,0,0,0,.42-.43,5.32,5.32,0,0,0,.87-2C367.76,302.75,367.89,302.58,368.15,302.6Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-292",
    d: "M368.13,302.86h.1c.34.06.42.18.6.81a3,3,0,0,0,1.27,2,3.05,3.05,0,0,1,.52.38,1.31,1.31,0,0,1-.36.09l-.21,0-.14,0a10.73,10.73,0,0,0-1.26.19,8.73,8.73,0,0,0-2.38,1,6.27,6.27,0,0,1-1,.49,2.51,2.51,0,0,1-.44,0c-.18-.39,1.07-1.44,1.54-1.86.16-.14.29-.27.41-.39a4.12,4.12,0,0,0,.84-1.89C367.82,303,367.93,302.85,368.13,302.86Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-270",
    d: "M365.38,307.68a1.68,1.68,0,0,1-.4,0,9.15,9.15,0,0,1,1.51-1.54l.39-.35a3.26,3.26,0,0,0,.82-1.75c.18-.76.27-.89.42-.89h.08c.3,0,.36.13.53.77a2.8,2.8,0,0,0,1.22,1.88c.21.14.36.25.47.34a2.69,2.69,0,0,1-.46,0h-.37a7.15,7.15,0,0,0-3.3,1.12A5.23,5.23,0,0,1,365.38,307.68Z",
    transform: "translate(-332.25 -113.32)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-258"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-282",
    d: "M360.66,319c-.49.32-.08,1.56.83,2.63a3.93,3.93,0,0,0,3.81,1.59,7,7,0,0,0,3.34-1.73,2.22,2.22,0,0,0,.5-2.53c-.41-.92-1.86-1.35-3.54-1.33a11.25,11.25,0,0,0-2.6.37A8.11,8.11,0,0,0,360.66,319Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-283",
    d: "M360.83,319.18a10.07,10.07,0,0,1,2.27-.86,11,11,0,0,1,1.73-.29c.26,0,.52,0,.77,0a7.4,7.4,0,0,1,1.67.11,2.27,2.27,0,0,1,1.76,1,1.93,1.93,0,0,1-.28,2.1l-.25.3a7,7,0,0,1-3.24,1.62,2.83,2.83,0,0,1-1.08.05h0a4.29,4.29,0,0,1-2.54-1.53C360.77,320.65,360.39,319.48,360.83,319.18Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-284",
    d: "M361,319.35a12.79,12.79,0,0,1,2.19-.73,10,10,0,0,1,1.67-.26c.24,0,.49-.05.74-.06a8.34,8.34,0,0,1,1.6.06,2.11,2.11,0,0,1,1.72.89,1.7,1.7,0,0,1,.17.82,1.89,1.89,0,0,1-.5,1.17,2.91,2.91,0,0,1-.24.27,7,7,0,0,1-3.14,1.51,3,3,0,0,1-1,.05h0a4,4,0,0,1-2.42-1.42C361,320.71,360.6,319.63,361,319.35Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-285",
    d: "M361.18,319.51c.7-.23,1.4-.44,2.12-.6a12.77,12.77,0,0,1,1.61-.22l.71-.07a8.65,8.65,0,0,1,1.53,0c.8.07,1.45.3,1.67.76a1.46,1.46,0,0,1,.16.78,1.75,1.75,0,0,1-.52,1.09c-.08.08-.16.17-.25.25a6.84,6.84,0,0,1-3,1.39,2.62,2.62,0,0,1-1,.06h0a3.73,3.73,0,0,1-2.3-1.32C361.15,320.78,360.82,319.78,361.18,319.51Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-286",
    d: "M361.36,319.68c.71-.16,1.36-.34,2-.47A13.31,13.31,0,0,1,365,319c.2,0,.43,0,.67-.07a10.52,10.52,0,0,1,1.47-.05c.78,0,1.41.21,1.63.64a1.31,1.31,0,0,1,.14.74,1.66,1.66,0,0,1-.55,1l-.24.23a6.85,6.85,0,0,1-2.94,1.28,2.56,2.56,0,0,1-.91.06h0a3.49,3.49,0,0,1-2.17-1.21C361.33,320.84,361,319.93,361.36,319.68Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-287",
    d: "M361.53,319.84c.73-.09,1.33-.22,2-.33.46-.07.93-.13,1.48-.17.19,0,.41,0,.65-.08a13.37,13.37,0,0,1,1.39-.1c.76,0,1.39.12,1.59.51a1.08,1.08,0,0,1,.13.71,1.6,1.6,0,0,1-.58.92,2.4,2.4,0,0,1-.23.21,7.2,7.2,0,0,1-2.84,1.17,2.47,2.47,0,0,1-.85.05h0a3.23,3.23,0,0,1-2.06-1.1C361.52,320.91,361.26,320.08,361.53,319.84Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-288",
    d: "M361.71,320a16.15,16.15,0,0,0,1.89-.2c.43-.06.87-.11,1.42-.14a6,6,0,0,0,.61-.09c.44-.07.9-.12,1.33-.15.74,0,1.36,0,1.55.38a.9.9,0,0,1,.11.67,1.54,1.54,0,0,1-.6.84l-.23.19a7.45,7.45,0,0,1-2.74,1.06,2.43,2.43,0,0,1-.8.05h0a3,3,0,0,1-1.93-1C361.71,321,361.47,320.23,361.71,320Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-289",
    d: "M361.88,320.18a10.23,10.23,0,0,0,1.82-.07c.4,0,.82-.08,1.36-.11a3.2,3.2,0,0,0,.58-.1c.4-.08.85-.15,1.26-.2.71-.08,1.32-.07,1.51.24a.82.82,0,0,1,.09.64,1.51,1.51,0,0,1-.63.77l-.22.16a7.75,7.75,0,0,1-2.65.95,2.62,2.62,0,0,1-.73.05h0a2.83,2.83,0,0,1-1.81-.88C361.89,321,361.69,320.38,361.88,320.18Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-290",
    d: "M362.06,320.34a7.72,7.72,0,0,0,1.74.07c.38,0,.76-.06,1.3-.08a2.87,2.87,0,0,0,.54-.1c.38-.09.8-.19,1.2-.26.69-.12,1.29-.16,1.46.11a.65.65,0,0,1,.08.6c-.06.2-.24.42-.66.69l-.21.14a8.34,8.34,0,0,1-2.55.84,2.59,2.59,0,0,1-.67,0h0a2.56,2.56,0,0,1-1.69-.78C362.08,321.1,361.91,320.53,362.06,320.34Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-291",
    d: "M362.23,320.51a6.11,6.11,0,0,0,1.67.2l1.24,0a2.25,2.25,0,0,0,.51-.11l1.13-.31c.66-.17,1.26-.26,1.42,0a.53.53,0,0,1,.06.57,1.51,1.51,0,0,1-.69.6l-.21.12a9.09,9.09,0,0,1-2.44.73,2.65,2.65,0,0,1-.62,0h0a2.29,2.29,0,0,1-1.56-.66C362.27,321.17,362.13,320.67,362.23,320.51Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-292",
    d: "M362.41,320.67a5.7,5.7,0,0,0,1.6.34c.31,0,.64,0,1.17,0a1.92,1.92,0,0,0,.48-.12l1.06-.36c.63-.21,1.23-.36,1.37-.15a.43.43,0,0,1,.05.53,1.65,1.65,0,0,1-.71.52l-.21.1a10.55,10.55,0,0,1-2.34.62,2.78,2.78,0,0,1-.56,0h0a2.17,2.17,0,0,1-1.45-.55C362.45,321.23,362.34,320.82,362.41,320.67Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-270",
    d: "M364.33,322.06a2,2,0,0,1-1.32-.45,1,1,0,0,1-.43-.77,4.74,4.74,0,0,0,2.64.48,9,9,0,0,0,1.44-.54c.61-.25,1.2-.45,1.33-.28s.11.39,0,.49a1.75,1.75,0,0,1-.74.44,11.69,11.69,0,0,1-2.45.59,4.38,4.38,0,0,1-.5,0Z",
    transform: "translate(-332.25 -113.32)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-258"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-282",
    d: "M387.59,311.05c.05.61.88.28,1.89-.61a13.17,13.17,0,0,0,3-3.94c1.52-3.2,1.64-5.49,0-5.45-.81,0-2.12,1.55-3.18,3.56a17.81,17.81,0,0,0-1.31,3.25A9.09,9.09,0,0,0,387.59,311.05Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-294",
    d: "M392.5,301.22c.78,0,1.12.59,1.05,1.61a10.73,10.73,0,0,1-1.14,3.56,12.32,12.32,0,0,1-1.82,2.74,10.15,10.15,0,0,1-1,1,4.4,4.4,0,0,1-1.26.88c-.37.14-.56.09-.61-.16a8.11,8.11,0,0,1,.31-2.67c0-.13.07-.26.11-.39a18,18,0,0,1,.85-2.17c.14-.32.3-.64.46-.95a9.06,9.06,0,0,1,2.43-3.25A1.19,1.19,0,0,1,392.5,301.22Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-295",
    d: "M392.54,301.39c.71.05,1,.57.92,1.54a10.52,10.52,0,0,1-1.08,3.34,12.45,12.45,0,0,1-1.71,2.6,11.69,11.69,0,0,1-.89.94,4.46,4.46,0,0,1-1.25.9c-.38.15-.53.1-.6-.07a7.79,7.79,0,0,1,.35-2.58c0-.12.07-.24.11-.37a18.8,18.8,0,0,1,.86-2.06c.14-.29.28-.61.44-.92a8.63,8.63,0,0,1,2.3-3.16A.88.88,0,0,1,392.54,301.39Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-296",
    d: "M392.58,301.57c.63.07.89.54.79,1.46a10.11,10.11,0,0,1-1,3.13,12.31,12.31,0,0,1-1.58,2.44,9.15,9.15,0,0,1-.84.89,3.9,3.9,0,0,1-1.23.92c-.39.16-.49.13-.58,0a7.06,7.06,0,0,1,.37-2.47l.12-.35c.24-.65.55-1.3.87-2l.42-.89a8.45,8.45,0,0,1,2.16-3.07A.74.74,0,0,1,392.58,301.57Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-297",
    d: "M392.63,301.74c.54.11.76.52.66,1.39a10,10,0,0,1-1,2.91,12.09,12.09,0,0,1-1.47,2.29,9.26,9.26,0,0,1-.77.84,3.93,3.93,0,0,1-1.23.95c-.38.17-.45.14-.56.11a6.61,6.61,0,0,1,.41-2.37l.12-.33c.25-.61.56-1.22.88-1.86.13-.25.26-.55.41-.86a8.06,8.06,0,0,1,2-3A.73.73,0,0,1,392.63,301.74Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-298",
    d: "M392.67,301.91c.47,0,.65.5.53,1.33a9.51,9.51,0,0,1-.93,2.68,11.88,11.88,0,0,1-1.35,2.14,8.17,8.17,0,0,1-.7.8,3.94,3.94,0,0,1-1.22,1,2.32,2.32,0,0,1-.54.2,5.9,5.9,0,0,1,.43-2.26l.13-.31c.25-.57.57-1.14.9-1.76.11-.23.24-.52.38-.83.59-1.25,1.33-2.61,1.89-2.9A.5.5,0,0,1,392.67,301.91Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-299",
    d: "M392.71,302.09c.39.05.54.47.41,1.25a10.07,10.07,0,0,1-.88,2.47,12.64,12.64,0,0,1-1.24,2c-.21.28-.43.52-.63.74a3.83,3.83,0,0,1-1.21,1,1.89,1.89,0,0,0-.53.29,5.26,5.26,0,0,1,.47-2.16c0-.1.09-.19.13-.29.26-.53.59-1.06.91-1.67.11-.2.23-.48.37-.79.54-1.19,1.24-2.56,1.75-2.81C392.5,302,392.62,302,392.71,302.09Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-300",
    d: "M392.75,302.26c.32.06.42.45.28,1.18a9.4,9.4,0,0,1-.83,2.25,12.23,12.23,0,0,1-1.12,1.84,7,7,0,0,1-.57.69,3.44,3.44,0,0,1-1.19,1,1,1,0,0,0-.51.38,4.63,4.63,0,0,1,.5-2.05c0-.09.08-.18.13-.27.27-.5.6-1,.92-1.57.1-.18.21-.45.35-.75.5-1.14,1.15-2.52,1.62-2.74C392.58,302.12,392.68,302.18,392.75,302.26Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-301",
    d: "M392.79,302.43c.24.08.31.43.16,1.11a10.45,10.45,0,0,1-.78,2,13.12,13.12,0,0,1-1,1.68,5.84,5.84,0,0,1-.5.65,3.54,3.54,0,0,1-1.18,1c-.42.2-.31.21-.5.47a4.37,4.37,0,0,1,.53-2l.14-.24c.27-.46.61-.91.93-1.47.09-.16.2-.42.33-.72.46-1.07,1.07-2.47,1.49-2.65C392.65,302.27,392.74,302.35,392.79,302.43Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-287",
    d: "M392.83,302.61c.17.08.2.4,0,1a10.87,10.87,0,0,1-.72,1.81c-.25.49-.55,1-.89,1.53-.15.22-.3.42-.44.6a3.4,3.4,0,0,1-1.17,1.05c-.42.22-.27.24-.49.56a3.78,3.78,0,0,1,.57-1.85l.14-.22c.28-.42.62-.83.94-1.37a6.06,6.06,0,0,0,.32-.69c.41-1,1-2.42,1.34-2.56S392.8,302.51,392.83,302.61Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-302",
    d: "M392.88,302.78c.08.1.08.38-.11,1a10.34,10.34,0,0,1-.67,1.59c-.21.42-.47.89-.77,1.39a5.89,5.89,0,0,1-.38.55,3.5,3.5,0,0,1-1.15,1.07c-.43.22-.24.25-.47.65a3.33,3.33,0,0,1,.59-1.75l.15-.2c.29-.38.63-.76,1-1.27a6.27,6.27,0,0,0,.29-.66c.37-.94.89-2.37,1.21-2.47S392.86,302.67,392.88,302.78Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-303",
    d: "M391.1,307a3.46,3.46,0,0,1-1.14,1.1c-.44.23-.2.26-.46.73a2.88,2.88,0,0,1,.63-1.64c.32-.41.72-.78,1.12-1.35.26-.38,1-2.91,1.35-3s.31.05.32.17a2.85,2.85,0,0,1-.23.9,21.08,21.08,0,0,1-1.28,2.61,4.75,4.75,0,0,1-.31.5Z",
    transform: "translate(-332.25 -113.32)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-258"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-282",
    d: "M375.12,320.67c-.15.6.75.55,2,0a13.09,13.09,0,0,0,4.07-2.77,10.5,10.5,0,0,0,2.39-3.36c.33-.91.15-1.56-.63-1.81s-2.5.79-4.15,2.36a17.59,17.59,0,0,0-2.28,2.65A9.36,9.36,0,0,0,375.12,320.67Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-294",
    d: "M382.9,312.92a.93.93,0,0,1,.59.42,1.5,1.5,0,0,1,0,1.31l-.11.26a11.3,11.3,0,0,1-2.2,2.93,13.82,13.82,0,0,1-1.14,1c-.28.21-.56.42-.84.61h0a11.82,11.82,0,0,1-1.92,1,4.44,4.44,0,0,1-.6.22c-.86.27-1.37.23-1.3-.18A8.23,8.23,0,0,1,376.6,318l.13-.18a16.41,16.41,0,0,1,1.72-2l.5-.5a16.47,16.47,0,0,1,1.65-1.39C381.57,313.16,382.43,312.77,382.9,312.92Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-295",
    d: "M382.86,313.07a.85.85,0,0,1,.56.4,1.46,1.46,0,0,1-.07,1.25c0,.08-.07.16-.11.25a11.34,11.34,0,0,1-2.12,2.78,11.11,11.11,0,0,1-1.09,1,8.64,8.64,0,0,1-.8.59h0a10.67,10.67,0,0,1-1.84,1l-.57.2c-.83.25-1.27.22-1.24-.11a7.75,7.75,0,0,1,1.24-2.47l.12-.16a17.77,17.77,0,0,1,1.69-1.91l.48-.47a15.68,15.68,0,0,1,1.57-1.36C381.59,313.34,382.42,312.94,382.86,313.07Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-296",
    d: "M382.83,313.22a.78.78,0,0,1,.52.39,1.42,1.42,0,0,1-.11,1.18l-.11.24a11.1,11.1,0,0,1-2,2.63,10.29,10.29,0,0,1-1,.93,9.4,9.4,0,0,1-.76.57h0a9.69,9.69,0,0,1-1.76.95,5.17,5.17,0,0,1-.55.19c-.78.23-1.15.22-1.17,0a7,7,0,0,1,1.23-2.34,1.67,1.67,0,0,1,.12-.16,18.34,18.34,0,0,1,1.66-1.79l.45-.45a16.22,16.22,0,0,1,1.49-1.32C381.62,313.52,382.41,313.11,382.83,313.22Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-297",
    d: "M382.79,313.38a.64.64,0,0,1,.48.37,1.33,1.33,0,0,1-.14,1.11,2.26,2.26,0,0,1-.11.22,11,11,0,0,1-2,2.5c-.31.3-.64.6-1,.88s-.48.38-.72.55h0a8.42,8.42,0,0,1-1.67.9l-.52.18c-.75.21-1,.21-1.11,0a6.69,6.69,0,0,1,1.21-2.22l.12-.14a19.59,19.59,0,0,1,1.63-1.67l.43-.44a18.53,18.53,0,0,1,1.41-1.28C381.65,313.7,382.4,313.28,382.79,313.38Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-298",
    d: "M382.75,313.53a.55.55,0,0,1,.45.36,1.31,1.31,0,0,1-.18,1,2.12,2.12,0,0,1-.11.21,10.92,10.92,0,0,1-1.88,2.35c-.29.29-.61.57-.94.84s-.46.36-.69.52h0a7.44,7.44,0,0,1-1.59.86,4.6,4.6,0,0,1-.49.16c-.71.19-.93.22-1.05.11a6.2,6.2,0,0,1,1.2-2.09l.12-.14c.47-.52,1-1,1.59-1.55l.41-.41c.42-.43.88-.87,1.33-1.25C381.68,313.88,382.39,313.45,382.75,313.53Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-299",
    d: "M382.71,313.68a.5.5,0,0,1,.42.34,1.29,1.29,0,0,1-.22,1l-.11.2a10.92,10.92,0,0,1-1.8,2.2c-.28.27-.57.54-.89.8a7.51,7.51,0,0,1-.65.5h0a7.33,7.33,0,0,1-1.51.81l-.46.15a2.74,2.74,0,0,1-1,.18,5.68,5.68,0,0,1,1.19-2l.11-.12c.46-.48,1-.92,1.56-1.44l.39-.39c.38-.4.82-.83,1.24-1.21C381.71,314.06,382.38,313.62,382.71,313.68Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-300",
    d: "M382.67,313.84a.41.41,0,0,1,.39.32,1.41,1.41,0,0,1-.25.91l-.11.19a12,12,0,0,1-1.73,2.05c-.26.26-.54.51-.84.76s-.41.33-.61.47h0a6,6,0,0,1-1.43.77,3.64,3.64,0,0,1-.44.14c-.63.15-.71.2-.92.25a4.87,4.87,0,0,1,1.18-1.84.57.57,0,0,1,.11-.11c.45-.44,1-.83,1.52-1.33.11-.09.23-.22.37-.36.35-.37.76-.81,1.16-1.19C381.74,314.25,382.37,313.78,382.67,313.84Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-301",
    d: "M382.63,314c.29,0,.33.17.35.31a1.33,1.33,0,0,1-.28.84l-.11.18a12.51,12.51,0,0,1-1.66,1.91c-.23.23-.5.47-.78.71s-.38.31-.57.45h0a5.3,5.3,0,0,1-1.35.72,3.15,3.15,0,0,1-.41.13,2.06,2.06,0,0,0-.85.33,4.31,4.31,0,0,1,1.15-1.73l.11-.1c.44-.39.95-.74,1.49-1.2a3.88,3.88,0,0,0,.34-.35c.33-.34.71-.77,1.09-1.15C381.77,314.43,382.36,314,382.63,314Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-287",
    d: "M382.6,314.14c.28,0,.3.17.31.3a1.41,1.41,0,0,1-.32.77l-.11.16a12.75,12.75,0,0,1-1.58,1.77c-.22.22-.46.44-.73.67a4.86,4.86,0,0,1-.53.42h0a5.26,5.26,0,0,1-1.27.69l-.38.1c-.56.12-.49.2-.79.41a3.73,3.73,0,0,1,1.14-1.6l.11-.09c.43-.35.93-.65,1.46-1.09a3.26,3.26,0,0,0,.31-.32c.29-.32.65-.74,1-1.12C381.8,314.61,382.35,314.11,382.6,314.14Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-302",
    d: "M382.56,314.3c.28,0,.29.15.28.27a1.62,1.62,0,0,1-.36.71l-.11.15a13.33,13.33,0,0,1-1.5,1.62c-.2.2-.43.41-.68.63a5.74,5.74,0,0,1-.49.4h0a4.28,4.28,0,0,1-1.19.64l-.35.09c-.53.1-.39.19-.73.48a3.35,3.35,0,0,1,1.13-1.48l.1-.08c.43-.3.91-.55,1.43-1a2.12,2.12,0,0,0,.29-.3c.26-.29.6-.7.93-1.08C381.83,314.79,382.34,314.28,382.56,314.3Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-303",
    d: "M379.76,317.93a3.33,3.33,0,0,1-1.44.67c-.48.08-.27.19-.66.55a2.73,2.73,0,0,1,1.12-1.35c.43-.29.93-.51,1.49-.92a13.84,13.84,0,0,0,1.12-1.33c.47-.57.94-1.11,1.13-1.1s.28.15.24.26a2.3,2.3,0,0,1-.5.78,21.93,21.93,0,0,1-2.05,2.06c-.15.14-.3.26-.45.38Z",
    transform: "translate(-332.25 -113.32)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-258"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-282",
    d: "M375.1,314.37c.56-.15.91-1.31.51-2.47s-1.56-2.32-4-2.46a11.49,11.49,0,0,0-4.83.86c-1.44.62-2.47,1.5-2.35,2.5s2,1.6,4.27,1.86a23.81,23.81,0,0,0,3.48.11A12.89,12.89,0,0,0,375.1,314.37Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-283",
    d: "M366.89,310.35a11.48,11.48,0,0,1,1.9-.59,10.88,10.88,0,0,1,2.76-.23,6.32,6.32,0,0,1,1.77.34,4,4,0,0,1,.72.33h0a3.07,3.07,0,0,1,1.41,1.66c.39,1.09.07,2.17-.44,2.33a15.6,15.6,0,0,1-2.42.26l-.38,0c-.57,0-1.17,0-1.78,0s-1-.05-1.55-.1a17,17,0,0,1-1.75-.26c-1.33-.29-2.31-.75-2.39-1.41C364.63,311.73,365.57,310.92,366.89,310.35Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-284",
    d: "M367,310.41a8.78,8.78,0,0,1,1.83-.57,10.44,10.44,0,0,1,2.65-.22,6,6,0,0,1,1.71.31,5.07,5.07,0,0,1,.7.31h0a3,3,0,0,1,1.39,1.58c.37,1,.08,2-.39,2.18-.66.07-1.44.14-2.29.16h-.36c-.54,0-1.11,0-1.7-.05l-1.49-.09a13.52,13.52,0,0,1-1.67-.22c-1.29-.25-2.25-.65-2.33-1.27C365,311.67,365.82,310.92,367,310.41Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-285",
    d: "M367.15,310.46a8.34,8.34,0,0,1,1.76-.55,10,10,0,0,1,2.55-.2,6.16,6.16,0,0,1,1.65.29,3.75,3.75,0,0,1,.67.29h0a2.87,2.87,0,0,1,1.36,1.49c.37,1,.1,1.89-.32,2-.65,0-1.38,0-2.17,0h-.34c-.51,0-1,0-1.63-.08l-1.42-.07a13.26,13.26,0,0,1-1.6-.18c-1.23-.2-2.18-.55-2.25-1.12C365.29,311.6,366.07,310.93,367.15,310.46Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-286",
    d: "M367.28,310.51A8.13,8.13,0,0,1,369,310a10,10,0,0,1,2.45-.2,7.22,7.22,0,0,1,1.58.27,4.39,4.39,0,0,1,.65.27h0a2.71,2.71,0,0,1,1.33,1.41c.36.88.12,1.74-.26,1.89-.64-.05-1.31-.05-2-.07h-.32c-.48,0-1-.06-1.55-.12-.39,0-.86,0-1.35-.05s-1-.07-1.53-.13c-1.19-.16-2.11-.46-2.19-1C365.63,311.53,366.32,310.93,367.28,310.51Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-287",
    d: "M367.41,310.56a7.68,7.68,0,0,1,1.62-.5,10.09,10.09,0,0,1,2.35-.18,7,7,0,0,1,1.52.25,3.6,3.6,0,0,1,.63.25h0a2.61,2.61,0,0,1,1.3,1.32c.34.81.13,1.6-.2,1.74-.63-.11-1.26-.13-1.93-.18l-.3,0c-.44,0-.91-.08-1.46-.14-.35,0-.81,0-1.29,0s-1-.05-1.46-.1c-1.13-.12-2-.35-2.12-.83C366,311.46,366.58,310.93,367.41,310.56Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-288",
    d: "M367.54,310.61a6.93,6.93,0,0,1,1.55-.47,9.1,9.1,0,0,1,2.25-.17,6.56,6.56,0,0,1,1.45.23,3.36,3.36,0,0,1,.61.22h0a2.46,2.46,0,0,1,1.27,1.24c.33.75.15,1.46-.13,1.6a9.73,9.73,0,0,0-1.81-.29l-.28,0c-.41,0-.85-.1-1.39-.17a11.83,11.83,0,0,0-1.22,0c-.46,0-.93,0-1.38-.05-1.09-.08-2-.26-2.06-.69C366.3,311.4,366.83,310.93,367.54,310.61Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-289",
    d: "M367.67,310.66a6.47,6.47,0,0,1,1.48-.45,9.24,9.24,0,0,1,2.15-.15,7.89,7.89,0,0,1,1.39.2,4.38,4.38,0,0,1,.58.2h0a2.36,2.36,0,0,1,1.24,1.16c.32.68.17,1.32-.07,1.45a7.67,7.67,0,0,0-1.68-.4l-.26,0-1.31-.2a8.69,8.69,0,0,0-1.15,0c-.44,0-.89,0-1.31,0-1,0-1.92-.16-2-.54C366.63,311.33,367.08,310.94,367.67,310.66Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-290",
    d: "M367.8,310.71a5.65,5.65,0,0,1,1.41-.42,8.76,8.76,0,0,1,2-.14,7.22,7.22,0,0,1,1.33.18,3.69,3.69,0,0,1,.56.18h0a2.24,2.24,0,0,1,1.22,1.07,1.16,1.16,0,0,1,0,1.31,6,6,0,0,0-1.56-.52l-.24-.05-1.23-.23a6.94,6.94,0,0,0-1.09,0l-1.24,0c-1,0-1.85-.07-1.92-.41S367.33,310.94,367.8,310.71Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-291",
    d: "M367.93,310.76a5.34,5.34,0,0,1,1.34-.4,8.34,8.34,0,0,1,1.94-.12,8,8,0,0,1,1.27.16,3.69,3.69,0,0,1,.53.15h0a2.15,2.15,0,0,1,1.19,1,1.05,1.05,0,0,1,.05,1.16,5.38,5.38,0,0,0-1.44-.63l-.21-.06-1.16-.26a5.61,5.61,0,0,0-1,0l-1.16.08c-.94.05-1.78,0-1.86-.26S367.58,310.94,367.93,310.76Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-292",
    d: "M368.06,310.82a3.88,3.88,0,0,1,1.27-.38,8.57,8.57,0,0,1,1.84-.11,10.22,10.22,0,0,1,1.2.13,3.57,3.57,0,0,1,.52.14h0a2,2,0,0,1,1.15.9,1,1,0,0,1,.12,1,5.66,5.66,0,0,0-1.32-.74l-.19-.06c-.29-.09-.6-.17-1.08-.29a3.52,3.52,0,0,0-.95.06l-1.09.12c-.89.09-1.72.13-1.79-.12A.51.51,0,0,1,368.06,310.82Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-270",
    d: "M372.76,310.64a2,2,0,0,1,1.13.82,1,1,0,0,1,.18.87,6.27,6.27,0,0,0-1.2-.85,9.5,9.5,0,0,0-1.17-.4,10.84,10.84,0,0,0-1.91.24c-.84.13-1.65.23-1.72,0s0-.41.11-.48a3.64,3.64,0,0,1,1.21-.36,9.22,9.22,0,0,1,2.88,0,3.52,3.52,0,0,1,.49.11Z",
    transform: "translate(-332.25 -113.32)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-258"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-282",
    d: "M377.19,293.68c.51-.29.56-1.51-.11-2.53s-2.08-1.86-4.5-1.4a11.34,11.34,0,0,0-4.47,2c-1.25,1-2,2.06-1.67,3s2.35,1.06,4.6.76a22.89,22.89,0,0,0,3.4-.75A13.29,13.29,0,0,0,377.19,293.68Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-283",
    d: "M372.66,289.83a7.4,7.4,0,0,1,1.26-.12h0a3.5,3.5,0,0,1,3,1.44c.64,1,.6,2.09.14,2.37a19.71,19.71,0,0,1-2.65,1c-.53.14-1.09.28-1.66.39s-1.07.22-1.6.3a15.86,15.86,0,0,1-1.72.17c-1.38.06-2.46-.15-2.7-.78a1.33,1.33,0,0,1,0-1,4.44,4.44,0,0,1,1.6-1.84A11.14,11.14,0,0,1,372.66,289.83Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-284",
    d: "M372.74,289.92a5.73,5.73,0,0,1,1.19-.11h0a3.26,3.26,0,0,1,2.82,1.34c.62.9.59,2,.17,2.21-.72.26-1.58.55-2.54.81-.51.13-1,.24-1.6.35s-1,.21-1.53.3-1.12.16-1.64.19c-1.32.08-2.35-.08-2.59-.66a1.2,1.2,0,0,1,0-.93,4.18,4.18,0,0,1,1.55-1.72A10.84,10.84,0,0,1,372.74,289.92Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-285",
    d: "M372.83,290a5.58,5.58,0,0,1,1.11-.1h0a3.1,3.1,0,0,1,2.65,1.25c.59.84.57,1.81.19,2.05-.73.19-1.54.44-2.44.66-.47.11-1,.21-1.52.3s-.95.2-1.46.3-1.07.17-1.56.22c-1.26.11-2.26,0-2.49-.54a1.12,1.12,0,0,1,0-.88,4.06,4.06,0,0,1,1.5-1.6A10.48,10.48,0,0,1,372.83,290Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-286",
    d: "M372.91,290.08a4.84,4.84,0,0,1,1-.09h0a3,3,0,0,1,2.49,1.16c.56.77.55,1.66.21,1.9-.74.11-1.49.31-2.33.5l-1.46.26c-.4.06-.88.19-1.38.3s-1,.18-1.48.24c-1.2.13-2.17.07-2.39-.42a1,1,0,0,1,0-.84,3.91,3.91,0,0,1,1.44-1.47A10.2,10.2,0,0,1,372.91,290.08Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-287",
    d: "M373,290.16a5.45,5.45,0,0,1,.95-.08h0a2.82,2.82,0,0,1,2.32,1.07c.53.71.53,1.52.24,1.74a16.11,16.11,0,0,0-2.23.35c-.42.08-.87.14-1.4.21-.36.05-.82.19-1.31.3s-.95.2-1.4.26c-1.14.17-2.08.16-2.28-.28a.89.89,0,0,1,0-.8,3.79,3.79,0,0,1,1.39-1.36A10.07,10.07,0,0,1,373,290.16Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-288",
    d: "M373.08,290.24a5.66,5.66,0,0,1,.88-.07h0a2.66,2.66,0,0,1,2.15,1c.49.65.51,1.38.26,1.58a10,10,0,0,0-2.13.2l-1.32.17a10.3,10.3,0,0,0-1.24.3c-.44.11-.89.2-1.32.28-1.08.19-2,.23-2.18-.16a.85.85,0,0,1,0-.75,3.67,3.67,0,0,1,1.35-1.24A9.86,9.86,0,0,1,373.08,290.24Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-289",
    d: "M373.17,290.32a5.7,5.7,0,0,1,.8-.06h0a2.51,2.51,0,0,1,2,.89c.46.59.49,1.23.28,1.42a7.45,7.45,0,0,0-2,.05l-1.26.12a9.11,9.11,0,0,0-1.16.3c-.41.12-.84.22-1.24.31-1,.22-1.9.31-2.08,0a.75.75,0,0,1,0-.7,3.58,3.58,0,0,1,1.29-1.12A9.63,9.63,0,0,1,373.17,290.32Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-290",
    d: "M373.25,290.4a3.69,3.69,0,0,1,.73,0h0a2.3,2.3,0,0,1,1.8.79c.44.52.48,1.09.32,1.27a5.66,5.66,0,0,0-1.92-.11l-1.2.08a6.21,6.21,0,0,0-1.09.3l-1.15.33c-1,.25-1.81.38-2,.08a.62.62,0,0,1,0-.65,3.42,3.42,0,0,1,1.24-1A9.55,9.55,0,0,1,373.25,290.4Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-291",
    d: "M373.33,290.48a3.81,3.81,0,0,1,.66,0h0a2.17,2.17,0,0,1,1.63.7c.41.46.46,1,.34,1.11a4.91,4.91,0,0,0-1.82-.26L373,292a5.47,5.47,0,0,0-1,.3l-1.08.35c-.9.28-1.72.47-1.87.21a.53.53,0,0,1,0-.6,3.47,3.47,0,0,1,1.19-.88A9.35,9.35,0,0,1,373.33,290.48Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-292",
    d: "M373.42,290.56a3.84,3.84,0,0,1,.58,0h0a2.08,2.08,0,0,1,1.46.61c.38.4.44.8.36,1a4.8,4.8,0,0,0-1.71-.41c-.28,0-.6,0-1.06,0a3.86,3.86,0,0,0-.94.3l-1,.37c-.84.31-1.63.55-1.77.33a.44.44,0,0,1,0-.55,3.78,3.78,0,0,1,1.13-.76A9.42,9.42,0,0,1,373.42,290.56Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-270",
    d: "M374,290.63a2,2,0,0,1,1.3.52,1,1,0,0,1,.39.79,4.67,4.67,0,0,0-2.61-.62,10.35,10.35,0,0,0-1.78.7c-.79.33-1.55.63-1.67.45s-.09-.4,0-.5a3.82,3.82,0,0,1,1.08-.64,9.23,9.23,0,0,1,2.79-.69,4.29,4.29,0,0,1,.5,0Z",
    transform: "translate(-332.25 -113.32)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-258"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-282",
    d: "M351.24,310.79c-.56.15-1.59,1.57-1.72,3.2s.65,3.47,3.72,4.47c3.68,1.2,4.39-1.61,5.54-1.91s.9-3.41-1.45-2.35-3.7.86-3.92,0S353.46,310.2,351.24,310.79Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-283",
    d: "M351.26,311h.05a1.2,1.2,0,0,1,1.33.53,2.76,2.76,0,0,1,.35.84c.22.81.28,1.71.43,2.11a1,1,0,0,0,.62.58,4.83,4.83,0,0,0,3.07-.53l.27-.12.31-.1c1.8-.56,1.92,2,.89,2.34-.83.24-1.43,1.79-3.16,2.06a4.6,4.6,0,0,1-2.16-.25c-2.95-1-3.74-2.71-3.64-4.29A4.06,4.06,0,0,1,351.26,311Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-284",
    d: "M351.27,311.12l.06,0a1.21,1.21,0,0,1,1.23.64,3.58,3.58,0,0,1,.33.85,15.78,15.78,0,0,0,.53,2.05,1,1,0,0,0,.66.53,5,5,0,0,0,3.08-.56l.28-.11a1.62,1.62,0,0,1,.27-.08c1.57-.48,1.63,1.88.68,2.2s-1.4,1.72-3,2a4.52,4.52,0,0,1-2.08-.25c-2.82-.92-3.63-2.58-3.56-4.12A4,4,0,0,1,351.27,311.12Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-285",
    d: "M351.29,311.28l.06,0a1.21,1.21,0,0,1,1.12.75,3.91,3.91,0,0,1,.31.85,8.19,8.19,0,0,0,.65,2,1.13,1.13,0,0,0,.69.49,5.27,5.27,0,0,0,3.09-.59l.28-.12.25-.05c1.33-.4,1.34,1.74.45,2.07s-1.36,1.65-2.92,1.87a4.4,4.4,0,0,1-2-.25c-2.7-.88-3.52-2.45-3.47-3.94A3.91,3.91,0,0,1,351.29,311.28Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-286",
    d: "M351.31,311.44l.05,0c.51,0,.84.47,1,.86a6.17,6.17,0,0,1,.28.86,5.62,5.62,0,0,0,.76,1.94,1.28,1.28,0,0,0,.73.44,5.5,5.5,0,0,0,3.1-.62l.28-.11.22,0c1.1-.32,1.06,1.59.23,1.94s-1.32,1.57-2.8,1.77a4.45,4.45,0,0,1-1.9-.25c-2.57-.84-3.41-2.32-3.39-3.77A3.89,3.89,0,0,1,351.31,311.44Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-287",
    d: "M351.32,311.6h.06c.46,0,.76.57.92,1a5.42,5.42,0,0,1,.26.87,4.27,4.27,0,0,0,.88,1.89,1.49,1.49,0,0,0,.76.39,5.82,5.82,0,0,0,3.11-.65l.28-.11h.19c.87-.24.77,1.45,0,1.81s-1.28,1.5-2.68,1.67a4.31,4.31,0,0,1-1.81-.25c-2.45-.8-3.31-2.19-3.32-3.59A3.88,3.88,0,0,1,351.32,311.6Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-288",
    d: "M351.34,311.76h.05c.42.08.69.68.83,1.07s.16.59.23.87a3.55,3.55,0,0,0,1,1.84,1.79,1.79,0,0,0,.8.35,6.18,6.18,0,0,0,3.12-.68,1.32,1.32,0,0,1,.28-.11.42.42,0,0,1,.16,0c.64-.16.49,1.31-.2,1.68s-1.24,1.43-2.56,1.56a4.2,4.2,0,0,1-1.72-.24c-2.33-.76-3.2-2.06-3.23-3.42A3.79,3.79,0,0,1,351.34,311.76Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-289",
    d: "M351.36,311.92h.05c.37.12.6.8.72,1.17s.15.61.22.89a2.93,2.93,0,0,0,1.1,1.78,1.94,1.94,0,0,0,.83.3,6.43,6.43,0,0,0,3.13-.71l.28-.11.13,0c.41-.08.21,1.17-.42,1.54s-1.2,1.36-2.44,1.47a4.12,4.12,0,0,1-1.63-.24c-2.2-.71-3.09-1.93-3.15-3.24A3.77,3.77,0,0,1,351.36,311.92Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-290",
    d: "M351.38,312.08h0c.34.16.53.91.63,1.28s.12.62.19.89a2.63,2.63,0,0,0,1.21,1.73,2.35,2.35,0,0,0,.86.26,6.86,6.86,0,0,0,3.15-.74,1.92,1.92,0,0,1,.28-.11.41.41,0,0,1,.11.07c.16,0-.09,1-.64,1.4s-1.17,1.29-2.32,1.37a4,4,0,0,1-1.55-.24c-2.07-.67-3-1.8-3.06-3.06A3.69,3.69,0,0,1,351.38,312.08Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-291",
    d: "M351.39,312.24h.05c.29.2.45,1,.52,1.39s.1.63.17.9a2.43,2.43,0,0,0,1.33,1.67,2.38,2.38,0,0,0,.89.21,7.13,7.13,0,0,0,3.16-.77,1.1,1.1,0,0,1,.29-.1.31.31,0,0,1,.07.09,4.21,4.21,0,0,1-.86,1.27c-.63.49-1.12,1.21-2.2,1.27a4.13,4.13,0,0,1-1.45-.24c-2-.63-2.87-1.67-3-2.89A3.68,3.68,0,0,1,351.39,312.24Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-292",
    d: "M351.41,312.4h0a3.8,3.8,0,0,1,.43,1.5,8.6,8.6,0,0,0,.14.9,2.27,2.27,0,0,0,1.44,1.62,3,3,0,0,0,.93.17,7.73,7.73,0,0,0,3.17-.8,1.93,1.93,0,0,1,.29-.11.56.56,0,0,1,0,.12c-.3.14-.64.75-1.08,1.14a3.1,3.1,0,0,1-2.08,1.17,4.07,4.07,0,0,1-1.36-.24c-1.83-.59-2.76-1.54-2.9-2.71A3.61,3.61,0,0,1,351.41,312.4Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-270",
    d: "M354.65,318a4.07,4.07,0,0,1-1.27-.24c-1.7-.55-2.65-1.41-2.82-2.54a3.56,3.56,0,0,1,.87-2.7h0a5,5,0,0,1,.32,1.61,5.37,5.37,0,0,0,.13.91,2.35,2.35,0,0,0,2.51,1.69,7.89,7.89,0,0,0,3.18-.84,1.24,1.24,0,0,1,.29-.1.61.61,0,0,1,0,.14,3.89,3.89,0,0,0-1.29,1A2.62,2.62,0,0,1,354.65,318Z",
    transform: "translate(-332.25 -113.32)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-258"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-282",
    d: "M374.42,299.25c-.32.48.53,2.76,2.19,4.61a7.65,7.65,0,0,0,3.07,2.15,5.39,5.39,0,0,0,4-.19c3.55-1.54,3-3.27,2.63-4.4-.63-1.85-3.49-4-3.58-1.45s-.72,2.59-1.45,2.09a36.92,36.92,0,0,0-3.25-2.31C376.6,298.87,375.05,298.29,374.42,299.25Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-283",
    d: "M374.86,299.49c.57-.82,1.89-.31,3.18.44l.23.14c.4.24.79.49,1.15.75.91.64,1.67,1.23,1.94,1.4s.68.34.94.06a3.41,3.41,0,0,0,.5-2c.05-.84.41-1.14.87-1.11a3.37,3.37,0,0,1,2,1.35,3,3,0,0,1,.52.93,3.31,3.31,0,0,1,.21,1.69,2.5,2.5,0,0,1-.9,1.43,6.68,6.68,0,0,1-1.81,1.07,5.21,5.21,0,0,1-3.83.22,7.21,7.21,0,0,1-2.91-2,10.24,10.24,0,0,1-1.61-2.39,3.19,3.19,0,0,1-.48-2Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-284",
    d: "M375.31,299.73c.53-.73,1.77-.18,2.95.52l.21.13c.37.23.74.48,1.08.72.84.59,1.57,1.13,1.84,1.28s.65.3.9.05a3,3,0,0,0,.53-1.82c.07-.77.41-1.05.85-1a3,3,0,0,1,1.83,1.12,1.92,1.92,0,0,1,.49.81,3.36,3.36,0,0,1,.2,1.61,2.43,2.43,0,0,1-.86,1.36,6.51,6.51,0,0,1-1.71,1,5,5,0,0,1-3.62.23,6.43,6.43,0,0,1-2.74-1.84,9.16,9.16,0,0,1-1.53-2.27,2.94,2.94,0,0,1-.44-1.85Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-285",
    d: "M375.75,300c.5-.64,1.65-.05,2.72.6a1.37,1.37,0,0,1,.2.13c.35.22.69.45,1,.68.78.54,1.46,1,1.74,1.16s.61.26.86,0a2.7,2.7,0,0,0,.57-1.65c.08-.7.41-1,.82-1a2.76,2.76,0,0,1,1.69.89,1.43,1.43,0,0,1,.46.69,3.58,3.58,0,0,1,.17,1.52,2.24,2.24,0,0,1-.8,1.3,6.33,6.33,0,0,1-1.62,1,4.84,4.84,0,0,1-3.41.26,6,6,0,0,1-2.58-1.69,8.47,8.47,0,0,1-1.44-2.14,3,3,0,0,1-.41-1.75Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-286",
    d: "M376.19,300.21c.48-.55,1.53.09,2.49.68l.19.12.94.65a17.49,17.49,0,0,0,1.65,1c.31.13.57.22.8,0a2.38,2.38,0,0,0,.62-1.49c.1-.62.41-.86.79-.89a2.61,2.61,0,0,1,1.55.66.94.94,0,0,1,.42.57,3.56,3.56,0,0,1,.15,1.44,2,2,0,0,1-.75,1.23,5.9,5.9,0,0,1-1.52.91,4.66,4.66,0,0,1-3.2.27,5.45,5.45,0,0,1-2.42-1.53,7.54,7.54,0,0,1-1.35-2,2.9,2.9,0,0,1-.38-1.65Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-287",
    d: "M376.63,300.45c.45-.46,1.42.22,2.27.76l.18.12c.3.2.59.41.86.61a10.2,10.2,0,0,0,1.55.93c.29.11.53.18.76,0a2.1,2.1,0,0,0,.65-1.32c.12-.55.42-.78.77-.82a1.93,1.93,0,0,1,1.41.43.5.5,0,0,1,.38.45,3.59,3.59,0,0,1,.13,1.36,1.93,1.93,0,0,1-.69,1.16,5.72,5.72,0,0,1-1.43.85,4.44,4.44,0,0,1-3,.29,4.89,4.89,0,0,1-2.25-1.37A6.59,6.59,0,0,1,377,302a2.84,2.84,0,0,1-.36-1.55Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-288",
    d: "M377.08,300.69c.41-.37,1.29.36,2,.84l.17.12.79.56a7,7,0,0,0,1.46.82.74.74,0,0,0,.71,0,2,2,0,0,0,.69-1.15.93.93,0,0,1,.73-.75,1.85,1.85,0,0,1,1.28.2c.17,0,.29.06.34.33a3.85,3.85,0,0,1,.11,1.28,1.76,1.76,0,0,1-.63,1.09,5.37,5.37,0,0,1-1.34.79,4.36,4.36,0,0,1-2.78.32,4.46,4.46,0,0,1-2.09-1.22,5.87,5.87,0,0,1-1.17-1.76,2.58,2.58,0,0,1-.32-1.44Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-289",
    d: "M377.52,300.93c.39-.28,1.17.49,1.81.93l.15.1c.25.19.49.37.73.53a5,5,0,0,0,1.35.7.8.8,0,0,0,.66,0,1.77,1.77,0,0,0,.74-1,1,1,0,0,1,.7-.68,1.91,1.91,0,0,1,1.13,0c.17-.06.28-.05.31.21a4.29,4.29,0,0,1,.1,1.19,1.56,1.56,0,0,1-.59,1,4.82,4.82,0,0,1-1.24.75,4.23,4.23,0,0,1-2.57.33,3.73,3.73,0,0,1-1.92-1.06,5.12,5.12,0,0,1-1.09-1.63,2.49,2.49,0,0,1-.29-1.34Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-290",
    d: "M378,301.17c.36-.2,1.05.63,1.58,1l.14.1c.23.18.45.35.66.49a3.77,3.77,0,0,0,1.25.58.88.88,0,0,0,.62,0,1.72,1.72,0,0,0,.77-.82,1.28,1.28,0,0,1,.68-.61,3,3,0,0,1,1-.25c.16-.12.25-.16.28.09a5.18,5.18,0,0,1,.07,1.11,1.43,1.43,0,0,1-.53.95,4.13,4.13,0,0,1-1.16.69,4.18,4.18,0,0,1-2.35.36,3.36,3.36,0,0,1-1.76-.91,4.63,4.63,0,0,1-1-1.5,2.52,2.52,0,0,1-.26-1.24Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-291",
    d: "M378.41,301.41c.32-.11.92.77,1.34,1.09l.13.1c.2.16.4.32.59.45a2.59,2.59,0,0,0,1.16.46,1.06,1.06,0,0,0,.56,0,1.82,1.82,0,0,0,.82-.65,1.73,1.73,0,0,1,.65-.54c.33-.17.64-.38.85-.48s.23-.26.24,0a6,6,0,0,1,.05,1,1.29,1.29,0,0,1-.48.88,4.62,4.62,0,0,1-3.2,1,2.88,2.88,0,0,1-1.6-.75,3.91,3.91,0,0,1-.91-1.37,2.47,2.47,0,0,1-.23-1.14Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-292",
    d: "M378.85,301.66c.29,0,.8.9,1.12,1.16l.11.09a4.56,4.56,0,0,0,.52.42,2.19,2.19,0,0,0,1.06.35,1.51,1.51,0,0,0,.52-.05,2.18,2.18,0,0,0,.86-.48,5.07,5.07,0,0,1,.62-.47,3.17,3.17,0,0,0,.71-.71c.15-.22.2-.37.2-.15s.06.65,0,.95a1.12,1.12,0,0,1-.42.81,3.5,3.5,0,0,1-1,.58,4.2,4.2,0,0,1-1.93.4,2.35,2.35,0,0,1-1.43-.6,3.15,3.15,0,0,1-.83-1.24,2.41,2.41,0,0,1-.19-1Z",
    transform: "translate(-332.25 -113.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-270",
    d: "M384,303.47a3.08,3.08,0,0,1-.87.52,4.26,4.26,0,0,1-1.72.42,1.9,1.9,0,0,1-1.27-.44,2.56,2.56,0,0,1-.74-1.12,2.37,2.37,0,0,1-.16-.93l0,0c.27.06.68,1,.89,1.24a5.15,5.15,0,0,0,.55.47,2,2,0,0,0,1.44.17,3.3,3.3,0,0,0,1.48-.71,2.64,2.64,0,0,0,.58-.94c.12-.29.17-.48.16-.27s0,.6,0,.86A1,1,0,0,1,384,303.47Z",
    transform: "translate(-332.25 -113.32)"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactUs);
export default __webpack_public_path__ + "static/media/contact-us.d4b99f0dcb2a6f6edc5071fb6e622c92.svg";
export { ForwardRef as ReactComponent };